import { stayAndPlay } from './../../globals';
import { Country } from './../../data/country-location';
import {
  CaddySelectionCriteria,
  ItemizedBill,
  BuggyDayDetails,
  CaddyDayDetails,
  ClubRating,
  RatingItem,
  BookingStatistics,
  CourseUtilizationStatistics,
  CaddieBuggyAssignmentStatistics,
  BookingOfflinePayment,
  CaddyAssignment,
  TeeTimeClubVoucher,
  ClubData,
  CancelBookingSpecification,
  ClubMembership,
  ClubHelpItem,
  LowestAverageGrossLeaderboard,
  PlayerLowestAverageGross,
  LeagueScorecards,
  PlayerRoundScores,
  EclecticPlayerRound,
  LeagueLeaderboard,
  PagedData,
  ClubCaddieSchedule,
  Unavailability,
  BookingCount,
  PaymentMethod,
  TransactionType,
  PaymentTrxnType,
  TrxnTypePriceComponentMap,
  RefundTrxnType,
  DiscountCompany,
  TransactionGroup,
  TeeTimePriceComponent,
  PlayerDiscountProgramPage,
  PartnerProgramMembershipApplicationPage,
  ClubMembershipPage,
  PlayerClubWalletBalancePage,
  PlayerClubWalletBalance,
  PlayerClubAccountPage,
  PlayerClubAccount,
  UserAddress,
  AddressData,
  UserAuthentication,
  DiscountCompanyPage,
  TeeTimePricingPlan,
  BuggyType,
  PlayerInsurance,
  TeeTimePrice,
  Bill,
  PlayerDiscountProgram,
  ClubOutlet,
  PlayerClubAccountTransactionPage,
  ClubOutletPage,
  PlayerClubWalletTransactionPage,
  PlayerClubWalletTopupPage,
  TeeTimeSlotDisplayPage,
  BookingAgentClubSetting,
  ClubDataLite,
  ClubDataLitePage,
  BookingAgentStatement,
  BookingAgentStatementPage,
  BookingAgentTransactionPage,
  ClubFacilityBooking,
  ClubPosSalePage,
  ClubGroupPage,
  ClubGroup,
  ClubPosSalesImportPage,
  ClubPosSale,
  ClubPosSalesImport,
  ClubPosPage,
  TeeTimeClubVoucherPage,
  VoucherSeriesPage,
  NewsPage,
  News,
  OffersAndAdvertisementPage,
  OfferAndAdvertisement,
  BookableFacilitySearchResult,
  FacilityBookingRequest,
  AdditionalItemCount,
  BookingPax,
  CompetitionDataLitePage,
  CompetitionDataLite,
  CompetitionDataPage,
  CompetitionData,
  ClubDataPage,
  UserPage,
  UserHomeItem,
  ClubOutletType,
  OfflinePayment,
  RefundForm,
  BookingConfirmationStatus,
  EInvoicingSetup,
  TBookingEInvoicePlayerDTO,
  State,
  LeagueSeasonGuestView,
  TournamentPlayerBasicView,
  LeagueSeasonTeam,
  LeagueSeason,
  LeagueSeasonCompetition,
  NotificationData,
} from './../../data/mygolf.data';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';

import { RemoteHttpService } from '../../remote-http';
import * as global from '../../globals';
import { ContentType, RemoteRequest } from '../../remote-request';
import { Custom_RequestMethod, removeEmptyKeys } from '../common-service';
import { ClubList, CourseHoleInfo, CourseInfo } from '../../data/club-course';
import { JsonService } from '../../json-util';
import { Observable, throwError } from 'rxjs';
import { isPresent } from '../common-service';
import { SearchCriteria } from '../../data/search-criteria';
import {
  TeeTimeFlight,
  BuggyData,
  CaddyData,
  CaddySchedule,
  BuggySchedule,
  TeeTimeSlot,
  TeeTimeSlotBookingRequest,
  TeeTimeSlotDisplay,
  ClubTeeTimeSlots,
  TeeTimeBooking,
  TeeTimeBookingPlayer,
  TeeTimeBookingOptions,
  PlayerData,
  BuggyCaddiePreference,
  FutureBookingStatistics,
  CaddieBuggyStatistics,
  HandicapSystem,
} from '../../data/mygolf.data';
import { ClubInfo } from '../../data/mygolf.data';
import * as moment from 'moment';
import { PlayerInfo } from '../../data/player-data';
import { FiletransferService } from '../filetransfer-service/filetransfer-service';
import { UploadResult } from '../../data/fileupload-result';
// import { FAQItem, GroupItem } from 'src/app/pages/faq/faq.page';
import { ContactUsItem, GroupItem, HelpURLs } from 'src/app/pages/contact-us/contact-us.page';
import { from } from 'rxjs';
import { CommonProvider } from 'src/app/pages/commonServices/common';
import { Platform } from '@ionic/angular';
import * as appProps from 'src/appProperties';
import { OrderService } from '../order-service/order-service';
import { HttpParams } from '@angular/common/http';
import { EnvironmentService } from '../environment-service/environment-service.service';
/*

 Generated class for the ClubService provider.

 See https://angular.io/docs/ts/latest/guide/dependency-injection.html
 for more info on providers and Angular 2 DI.
 */
@Injectable()
export class ClubFlightService {
  private searchCriteria: SearchCriteria;

  constructor(
    public http: RemoteHttpService,
    private ftService: FiletransferService,
    public requestMethod: Custom_RequestMethod,
    private commonProvider: CommonProvider,
    private platform: Platform,
    private orderService: OrderService,
    private environmentService: EnvironmentService
  ) {}

  /**
   * Gets the information about a single club
   * @param clubId The ID of the club
   */
  public getClubInfo(clubId: number): Observable<ClubInfo> {
    let request = new RemoteRequest(global.ServerUrls.getClub, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      clubId: clubId,
      fullDetails: true,
    });
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let clubInfo: ClubInfo = resp;
        //    if (!isPresent(clubInfo.clubImage)) clubInfo.clubImage = "document/img/default_club.png";
        if (!isPresent(clubInfo.clubImage)) clubInfo.clubImage = ' ./assets/image/default_club.png';

        JsonService.deriveFullUrl(clubInfo, 'clubImage');
        return clubInfo;
      })
    );
  }

  /**
   * Get the courses for a given club
   * @param clubId The ID of the club
   * @returns {Observable<R>}
   */
  public getClubCourses(clubId: number): Observable<Array<CourseInfo>> {
    let request = new RemoteRequest(global.ServerUrls.getClubCourses, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      clubId: clubId,
    });

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let courses: Array<CourseInfo> = resp;
        courses.forEach((c: CourseInfo) => {
          JsonService.deriveFullUrl(c, 'photoUrl');
          c.holes.forEach((h: CourseHoleInfo) => {
            JsonService.deriveFullUrl(h, 'holeImage');
          });
        });
        return courses;
      })
    );
  }

  /**
   * Gets the nearby club within a certain distance
   * @param maxDistance The maximum distance from the club to current location.
   * The current location details are automatically addedd
   * @returns {Observable<R>} Returns the Observable with next method returning
   * array of ClubInfo objects
   */
  public getNearbyClubs(maxDistance: number = 10): Observable<Array<ClubInfo>> {
    let request = new RemoteRequest(global.ServerUrls.getClubsNearby, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      maxDistance: maxDistance,
    });

    //??
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let clubInfos: Array<ClubInfo> = resp;
        clubInfos.forEach((c: ClubInfo) => {
          //    if (!isPresent(c.clubImage)) c.clubImage = "document/img/default_club.png";
          if (!isPresent(c.clubImage)) c.clubImage = './assets/image/default_club.png';

          JsonService.deriveFullUrl(c, 'clubImage');
        });

        return clubInfos;
      })
    );
  }

  /**
   * Gets the recent clubs played. The ID of the player is automatically inserted
   * @param maxClubs The maximum number of recent clubs to return
   * @returns {Observable<R>}
   */
  public getRecentClubs(maxClubs: number = 10): Observable<Array<ClubInfo>> {
    let request = new RemoteRequest(global.ServerUrls.getRecentClubs, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      maxItems: maxClubs,
    });

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let clubInfos: Array<ClubInfo> = resp;
        clubInfos.forEach((c: ClubInfo) => {
          //    if (!isPresent(c.clubImage)) c.clubImage = "document/img/default_club.png";
          if (!isPresent(c.clubImage)) c.clubImage = './assets/image/default_club.png';

          JsonService.deriveFullUrl(c, 'clubImage');
        });

        return clubInfos;
      })
    );
  }

  /**
   * Search clubs
   * @param searchText The search text filter. The search is applied on clubName, tag, address,
   * city, state
   * @param activeOnly Only clubs with status "Active" are considered.
   * @param pageNumber The search happens in paged manner. This parameter specifies which page is
   * requested
   * @param countryId The optional country id. Only clubs from this country are returned. Clubs
   * without country are ignored
   * @returns {Observable<R>}
   */
  public searchClubs(searchText: string, activeOnly: boolean, pageNumber: number, countryId?: string): Observable<ClubList> {
    let request = new RemoteRequest(global.ServerUrls.searchClubs, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      searchText: searchText,
      activeOnly: activeOnly,
      pageNumber: pageNumber,
      countryId: countryId,
    });

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let clubList: ClubList = resp;
        if (clubList && clubList.clubs)
          clubList.clubs.forEach((c: any) => {
            //    if (!isPresent(c.clubImage)) c.clubImage = "document/img/default_club.png";
            if (!isPresent(c.clubImage)) c.clubImage = './assets/image/default_club.png';

            JsonService.deriveFullUrl(c, 'clubImage');
          });
        return clubList;
      })
    );
  }

  public getMasterFlightList() {
    let request = new RemoteRequest('assets/teeTimeFlight.json', this.requestMethod.get);

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let flightList: any = resp;
        flightList.forEach((tb: TeeTimeBooking) => {
          tb.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
            JsonService.deriveFullUrl(p.player, 'profile');
            JsonService.deriveFullUrl(p.player, 'image');
          });
          if (tb.flight) tb.bookingStatus = 'PaymentFull';
        });
        //  //??
        //    if (clubList && clubList.clubs)
        //        clubList.clubs.forEach((c: ClubInfo) => {
        //            if (!isPresent(c.clubImage)) c.clubImage = "document/img/default_club.png";

        //            JsonService.deriveFullUrl(c, "clubImage");
        //        });
        return flightList;
      })
    );
    // return this.http.get('/assets/shipping.json');
  }

  public updateStatusClubMembership(clubId: number, membershipId: number, params?: any): Observable<any> {
    let _clubId;
    let _membershipId;
    let _params;

    if (params) _params = params;
    if (clubId) _clubId = clubId;
    if (membershipId) _membershipId = membershipId;

    let reClub = /:clubId/gi;
    let reMembership = /:membershipId/gi;
    console.debug('service update status club membership : ', _params, params);
    let _url = global.ServerUrls.clubMemberships.updateStatus;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(reMembership, _membershipId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.HTML, _params);

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        return data;
      })
    );
  }

  public getBookingFlightList(clubId: number, forDate: string, registeredOnly: boolean = false, includeCancelled: boolean = false) {
    // 'assets/json_teeTimeBooking.json'
    let _params =
      '?clubId=' + clubId + '&forDate=' + forDate + '&registeredOnly=' + registeredOnly + '&includeCancelled=' + includeCancelled;
    let request = new RemoteRequest(global.ServerUrls.getTeeTimeBookingList + _params, this.requestMethod.get);

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let flightList: Array<TeeTimeBooking> = resp;
        flightList.forEach((tb: TeeTimeBooking) => {
          tb.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
            JsonService.deriveFullUrl(p.player, 'profile');
            JsonService.deriveFullUrl(p.player, 'image');
            JsonService.deriveFullUrl(p.caddyAssigned, 'caddyImage');
            JsonService.deriveFullUrl(p.caddyPreferred, 'caddyImage');
          });
          //    if(tb.flight) tb.bookingStatus = 'PaymentFull'
        });
        //  //??
        return {
          resp,
          flightList,
        };
      })
    );
  }

  public getBookingFlightDetail() {
    let request = new RemoteRequest('assets/flightDetail.json', this.requestMethod.get);

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let flightDetail: TeeTimeFlight = resp;
        //  //??
        return flightDetail;
      })
    );
  }

  public changePasswordByAdmin(email: string, newPassword: string): Observable<any> {
    let _params = {
      email: email,
      newPassword: newPassword,
    };
    let _url = global.ServerUrls.changePasswordByAdmin;
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  public updatePartnerMembershipVerification(partnerId: string, playerMembershipId: number, params?: any): Observable<any> {
    let _partnerId = partnerId;
    let rePartnerId = /:partnerId/gi;
    let _playerMembershipId = playerMembershipId;
    let rePlayerMembershipId = /:playerMembershipId/gi;

    let _url = global.ServerUrls.partnerDiscountCompany.approveMembership;
    _url = _url.replace(rePartnerId, _partnerId);
    _url = _url.replace(rePlayerMembershipId, _playerMembershipId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  public approveApplication(partnerId: string, params?: any): Observable<any> {
    let _partnerId = partnerId;
    let rePartnerId = /:partnerId/gi;

    let _url = global.ServerUrls.partnerDiscountCompany.approveApplications;
    _url = _url.replace(rePartnerId, _partnerId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  public listProgramMemberships(partnerId: string, programId: string, params) {
    let _params = params;
    let _partnerId = partnerId;
    let rePartnerId = /:partnerId/gi;
    let _programId = programId;
    let reprogramId = /:programId/gi;

    let _url = global.ServerUrls.partnerDiscountCompany.listProgramMembers;
    _url = _url.replace(rePartnerId, partnerId);
    _url = _url.replace(reprogramId, programId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let playerProgramPage: PlayerDiscountProgramPage = resp;
        console.debug('api - bill details : ', playerProgramPage);
        if (playerProgramPage && playerProgramPage.items) {
          if (playerProgramPage.items.length > 0) {
            playerProgramPage.items.forEach(ppma => {
              if (ppma.discountProgram && ppma.discountProgram.discountCompany && ppma.discountProgram.discountCompany.partnerImage)
                JsonService.deriveFulImageURL(ppma.discountProgram.discountCompany, 'partnerImage');
              JsonService.deriveFulImageURL(ppma.player, 'profile');
              JsonService.deriveFulImageURL(ppma.player, 'image');
            });
          }
        }
        return playerProgramPage;
      })
    );
  }

  public getListClubMemberships(clubId: number, params?: any) {
    // ,activeOnly?: boolean, search?: string
    let _clubId;
    let _params = {};
    if (clubId) _clubId = clubId;
    // if(clubId) _params['clubId'] = clubId;
    let _status;
    if (params) _params = params;
    console.debug('new get club members list : ', params);
    // if(params['search']) _params['search'] = params['search'];
    // if(params['statuses']) _status = params['statuses'];
    // if(params['membershipTypes']) _params['membershipTypes'] = params['membershipTypes'];
    // if(params['country']) _params['country'] = params['country'];

    let _clubMembersURL = global.ServerUrls.clubMemberships.listClubMemberships;

    let reClub = /:clubId/gi;
    _clubMembersURL = _clubMembersURL.replace(reClub, _clubId);

    let request = new RemoteRequest(_clubMembersURL, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: ClubMembershipPage = resp;
        data.items.forEach((c: ClubMembership) => {
          JsonService.deriveFulImageURL(c.player, 'profile');
          JsonService.deriveFulImageURL(c.player, 'image');
          c.player.playerId = c.player.id;
        });
        //   let player: PlayerData = resp;
        //??console.log("get list club members : ", resp)
        return data;
      })
    );
  }

  userProfileSetDefaultAddress(userId: number, addressName: string) {
    let _addressName;
    let _params = {};
    let _userId;
    if (userId) _userId = userId;
    if (addressName) _params['addressName'] = addressName;
    let _setDefaultAddressURL = global.ServerUrls.profileUsers + '/' + _userId + global.ServerUrls.userProfiles.setDefaultAddress;

    let request = new RemoteRequest(_setDefaultAddressURL, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: PlayerData = resp;
        //??console.log("Booking Cancel Guard - ",resetCancelGuard," : ",result)
        return result;
      })
    );
  }

  public listPartnerApplication(params) {
    let _params = params;

    let _url = global.ServerUrls.partnerDiscountCompany.listApplications;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let partnerApplications: PartnerProgramMembershipApplicationPage = resp;
        console.debug('api - bill details : ', partnerApplications);
        if (partnerApplications && partnerApplications.items) {
          if (partnerApplications.items.length > 0) {
            partnerApplications.items.forEach(ppma => {
              if (ppma.partnerProgram && ppma.partnerProgram.discountCompany && ppma.partnerProgram.discountCompany.partnerImage)
                JsonService.deriveFulImageURL(ppma.partnerProgram.discountCompany, 'partnerImage');
            });
          }
        }
        return partnerApplications;
      })
    );
  }

  public updateProgramMembership(partnerId: string, playerMembershipId: number, params): Observable<any> {
    let _params = params;
    let rePartnerId = /:partnerId/gi;
    let rePlayerMembershipId = /:playerMembershipId/gi;
    let _url = global.ServerUrls.partnerDiscountCompany.updateMembership;
    _url = _url.replace(rePartnerId, partnerId);
    _url = _url.replace(rePlayerMembershipId, playerMembershipId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  public listAllPartnerMemberships(partnerId: string, params) {
    let _params = params;
    let _partnerId = partnerId;
    let rePartnerId = /:partnerId/gi;

    let _url = global.ServerUrls.partnerDiscountCompany.listAllMembers;
    _url = _url.replace(rePartnerId, partnerId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let playerProgramPage: PlayerDiscountProgramPage = resp;
        console.debug('api - bill details : ', playerProgramPage);
        if (playerProgramPage && playerProgramPage.items) {
          if (playerProgramPage.items.length > 0) {
            playerProgramPage.items.forEach(ppma => {
              if (ppma.discountProgram && ppma.discountProgram.discountCompany && ppma.discountProgram.discountCompany.partnerImage)
                JsonService.deriveFulImageURL(ppma.discountProgram.discountCompany, 'partnerImage');
              JsonService.deriveFulImageURL(ppma.player, 'profile');
              JsonService.deriveFulImageURL(ppma.player, 'image');
              if (ppma && ppma.document) JsonService.deriveFulImageURL(ppma, 'document');
            });
          }
        }
        return playerProgramPage;
      })
    );
  }

  public updateProgramAppNumbers(partnerId: string, programId: string, applicationId: number, params?: any): Observable<any> {
    let _partnerId;
    let _programId;
    let _applicationId;
    let _params;

    if (params) _params = params;
    if (partnerId) _partnerId = partnerId;
    if (programId) _programId = programId;
    if (applicationId) _applicationId = applicationId;

    let rePartner = /:partnerId/gi;
    let reProgram = /:programId/gi;
    let reApplication = /:applicationId/gi;
    console.debug('service add club player topup : ', _params, params);
    let _url = global.ServerUrls.partnerDiscountCompany.updateNumbers;
    _url = _url.replace(rePartner, _partnerId);
    _url = _url.replace(reProgram, _programId);
    _url = _url.replace(reApplication, _applicationId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.URL_ENCODED_FORM_DATA, _params);

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        return data;
      })
    );
  }

  public getBuggyList(clubId: number) {
    let request = new RemoteRequest(global.ServerUrls.getBuggyList, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      clubId: clubId,
    });
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let buggyList: Array<BuggyData> = resp;
        buggyList.forEach((buggy: BuggyData) => {
          JsonService.deriveFullUrl(buggy, 'buggyImage');
        });
        //  //??
        return buggyList;
      })
    );
  }

  public getCaddyList(clubId: number) {
    // 'assets/caddyList.json'
    let request = new RemoteRequest(global.ServerUrls.getCaddyList, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      clubId: clubId,
    });
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let caddyList: Array<CaddyData> = resp;
        caddyList.forEach((caddy: CaddyData) => {
          JsonService.deriveFullUrl(caddy, 'caddyImage');
          JsonService.deriveFullUrl(caddy.nationality, 'flagUrl');
        });
        //  //??
        return caddyList;
      })
    );
  }

  public getAvailableCaddiesBooking(bookingId: number) {
    let _bookingId;
    if (bookingId) _bookingId = bookingId;
    let request = new RemoteRequest(
      global.ServerUrls.getAvailableCaddieBooking + '/' + _bookingId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let caddyList: Array<CaddyData> = resp;
        caddyList.forEach((caddy: CaddyData) => {
          // JsonService.deriveFullUrl(caddy, "caddyImage");
          // JsonService.deriveFullUrl(caddy.nationality, "flagUrl");
          JsonService.deriveFulImageURL(caddy, 'caddyImage');
          JsonService.deriveFulImageURL(caddy.nationality, 'flagUrl');
        });
        //  //??
        return caddyList;
      })
    );
  }

  public getAvailableCaddies(clubId: number, availableOn: string) {
    let request = new RemoteRequest(global.ServerUrls.getAvailableCaddies, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      clubId: clubId,
      availableOn: availableOn,
    });
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let caddyList: Array<CaddyData> = resp;
        caddyList.forEach((caddy: CaddyData) => {
          JsonService.deriveFullUrl(caddy, 'caddyImage');
          JsonService.deriveFullUrl(caddy.nationality, 'flagUrl');
        });
        //  //??
        return caddyList;
      })
    );
  }

  public getAvailableBuggies(clubId: number, availableOn: string) {
    let request = new RemoteRequest(global.ServerUrls.getAvailableBuggies, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      clubId: clubId,
      availableOn: availableOn,
    });

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let buggyList: Array<BuggyData> = resp;
        buggyList.forEach((buggy: BuggyData) => {
          JsonService.deriveFullUrl(buggy, 'buggyImage');
        });
        //  //??
        return buggyList;
      })
    );
  }

  public getCaddySchedule(caddyId: number, fromDate: string, toDate?: string) {
    let request = new RemoteRequest(global.ServerUrls.getCaddySchedule, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      caddyId: caddyId,
      fromDate: fromDate,
      toDate: toDate,
    });

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let caddySchedule: CaddySchedule = resp;
        //    caddySchedule.forEach((caddyS: any) => {
        //     JsonService.deriveFullUrl(buggy, "buggyImage");
        //    })
        //  //??
        return caddySchedule;
      })
    );
  }

  public getBuggySchedule(buggyId: number, fromDate: string, toDate?: string) {
    let request = new RemoteRequest(global.ServerUrls.getBuggySchedule, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      buggyId: buggyId,
      fromDate: fromDate,
      toDate: toDate,
    });

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let getBuggySchedule: BuggySchedule = resp;
        //    caddySchedule.forEach((caddyS: any) => {
        //     JsonService.deriveFullUrl(buggy, "buggyImage");
        //    })
        //  //??
        return getBuggySchedule;
      })
    );
  }

  public getTeeTimeSlot(forDate: string, isClub?: boolean, clubCourseId?: number, fromTime?: string, toTime?: string, clubId?: number) {
    let _clubCourseId = clubCourseId;
    //??
    //??
    let request = new RemoteRequest(global.ServerUrls.getTeeTimeSlot, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      clubId: isClub ? _clubCourseId : '',
      courseId: isClub ? '' : _clubCourseId,
      forDate: forDate,
      fromTime: fromTime,
      toTime: toTime,
    });

    return this.http.execute(request).pipe(
      map((resp: any) => {
        // TeeTimeSlot
        let teeTimeSlotDisplay: Array<TeeTimeSlotDisplay> = resp;
        //??
        teeTimeSlotDisplay.forEach(c => {
          JsonService.deriveFullUrl(c.slot.startCourse, 'courseImage');
        });
        return teeTimeSlotDisplay;
      })
    );
  }

  public getTeeTimeSlotNearbyClubs(forDate: string, maxDistance: number, fromTime?: string, toTime?: string) {
    let hdrs = {};
    // // hdrs['Location-Longitude'] = 10.00;
    // hdrs['Lo']
    //??
    // Location-Longitude
    // Location-Latitude
    let request = new RemoteRequest(
      global.ServerUrls.getTeeTimeSlotNearbyClubs,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        forDate: forDate,
        fromTime: fromTime,
        toTime: toTime,
        maxDistance: maxDistance,
      },
      hdrs
    );

    return this.http.execute(request).pipe(
      map((resp: any) => {
        // TeeTimeSlot
        let teeTimeSlot: Array<any> = resp;
        //??
        return teeTimeSlot;
      })
    );
  }

  public getTeeTimeSlotFavClubs(forDate: string, fromTime?: string, toTime?: string) {
    // Player-Id
    let request = new RemoteRequest(global.ServerUrls.getTeeTimeSlotFavClubs, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      forDate: forDate,
      fromTime: fromTime,
      toTime: toTime,
    });

    return this.http.execute(request).pipe(
      map((resp: any) => {
        // TeeTimeSlot
        let teeTimeSlot: Array<ClubTeeTimeSlots> = resp;
        teeTimeSlot.forEach(c => {
          JsonService.deriveFullUrl(c.club, 'clubImage');
          JsonService.deriveFullUrl(c.club, 'clubThumbnail');
          JsonService.deriveFullUrl(c.club, 'clubLogo');
          c.slots.forEach(s => {
            JsonService.deriveFullUrl(s.slot.startCourse, 'courseImage');
          });
        });
        //??
        return {
          teeTimeSlot: teeTimeSlot,
          resp: resp,
        };
      })
    );
  }

  public getListAllSlots(playerId: number, forDate: string, fromTime?: string, toTime?: string) {
    // Player-Id
    let request = new RemoteRequest(global.ServerUrls.listAllSlots, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      forDate: forDate,
      fromTime: fromTime,
      toTime: toTime,
    });

    return this.http.execute(request).pipe(
      map((resp: any) => {
        // TeeTimeSlot
        let teeTimeSlot: Array<ClubTeeTimeSlots> = resp;
        teeTimeSlot.forEach(c => {
          JsonService.deriveFullUrl(c.club, 'clubImage');
          JsonService.deriveFullUrl(c.club, 'clubThumbnail');
          JsonService.deriveFullUrl(c.club, 'clubLogo');
          c.slots.forEach(s => {
            JsonService.deriveFullUrl(s.slot.startCourse, 'courseImage');
          });
        });
        //??
        return {
          teeTimeSlot: teeTimeSlot,
          resp: resp,
        };
      })
    );
  }

  // TeeTimeSlotBookingRequest
  // public bookTeeTimeSlot(reqBookSlot?: TeeTimeSlotBookingRequest, addBookingPlayer: boolean = true, captchaResponse?: string): Observable<any> {
  public bookTeeTimeSlot(reqBookSlot?: any, addBookingPlayer: boolean = true, captchaResponse?: string): Observable<any> {
    let _reqBookSlot = reqBookSlot;
    let _addBookingPlayer = '?addBookingPlayer=' + (addBookingPlayer ? 'true' : 'false');
    let headers = {};
    if (!!captchaResponse && captchaResponse.length > 0) headers['captcha-response'] = captchaResponse;
    else headers = null;
    let request = new RemoteRequest(
      global.ServerUrls.bookTeeTimeBookingSlot + _addBookingPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      reqBookSlot,
      headers
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getRecaptcha(key: string) {
    let _getRecaptcha = 'https://www.google.com/recaptcha/api2/reload?k=' + key;
    // '/googleRec?k='+ key;
    //??
    let request = new RemoteRequest(_getRecaptcha, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public getBookingByPlayer(playerId: number, fromDate: string, maxBookings: number = 999, clubId?: number) {
    let request = new RemoteRequest(global.ServerUrls.getBookingByPlayer, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      playerId: playerId,
      fromDate: fromDate,
      maxBookings: maxBookings,
      clubId: clubId,
    });
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let bookingByPlayerList: Array<TeeTimeBooking> = resp;
        //  //??

        //
        bookingByPlayerList.forEach((teeTime: TeeTimeBooking) => {
          teeTime.bookingPlayers.forEach((players: TeeTimeBookingPlayer) => {
            JsonService.deriveFullUrl(players.player, 'image');
            JsonService.deriveFullUrl(players.player, 'profile');
          });
          JsonService.deriveFullUrl(teeTime.clubData, 'clubImage');
        });
        //  //??
        return bookingByPlayerList;
      })
    );
  }

  public getBookingForPlayer(playerId: number, fromDate: string, maxBookings: number = 999) {
    let request = new RemoteRequest(global.ServerUrls.getBookingForPlayer, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      playerId: playerId,
      fromDate: fromDate,
      maxBookings: maxBookings,
    });
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let bookingByPlayerList: Array<TeeTimeBooking> = resp;
        //  //??

        //
        bookingByPlayerList.forEach((teeTime: TeeTimeBooking) => {
          teeTime.bookingPlayers.forEach((players: TeeTimeBookingPlayer) => {
            JsonService.deriveFullUrl(players.player, 'image');
            JsonService.deriveFullUrl(players.player, 'profile');
          });
          JsonService.deriveFullUrl(teeTime.clubData, 'clubImage');
        });
        //  //??
        return bookingByPlayerList;
      })
    );
  }

  public getBookingById(bookingId: number) {
    let request = new RemoteRequest(
      global.ServerUrls.getBookingById + '/' + bookingId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http.execute(request).pipe(
      map((result: any) => {
        let bookingByPlayer: TeeTimeBooking = result;

        JsonService.deriveFullUrl(bookingByPlayer.bookedByPlayer, 'profile');
        JsonService.deriveFullUrl(bookingByPlayer.bookedByPlayer, 'image');
        JsonService.deriveFullUrl(bookingByPlayer.bookingAgent, 'partnerImage');
        JsonService.deriveFullUrl(bookingByPlayer.bookedByUser?.profile, 'photo');
        JsonService.deriveFullUrl(bookingByPlayer.bookedByUser?.profile, 'profileImage');
        JsonService.deriveFullUrl(bookingByPlayer.clubData, 'clubImage');
        JsonService.deriveFullUrl(bookingByPlayer.clubData, 'clubLogo');
        JsonService.deriveFullUrl(bookingByPlayer.clubData, 'clubThumbnail');
        bookingByPlayer.bookingPlayers.forEach((players: TeeTimeBookingPlayer) => {
          JsonService.deriveFullUrl(players.player, 'profile');
          JsonService.deriveFullUrl(players.player, 'image');
          JsonService.deriveFullUrl(players.caddyAssigned, 'caddyImage');
          JsonService.deriveFullUrl(players.caddyPreferred, 'caddyImage');
        });
        //  //??
        return bookingByPlayer;
      })
    );
  }

  public addPlayerToBooking(bookingId: number, playerInfo: any, sequence?: string) {
    // TeeTimeBookingPlayer
    //??
    let _params = {};
    // _params = "?bookingId=" + bookingId + "&sequence=" + sequence;
    _params['bookingId'] = bookingId;
    // _params['sequence'] = null;//sequence;
    let _caddySelectionCriteria;
    if (playerInfo.playerDetails.caddySelectionCriteria) _caddySelectionCriteria = playerInfo.playerDetails.caddySelectionCriteria;
    if (playerInfo.new) {
      _params['playerName'] = playerInfo.playerDetails.playerName;
      _params['email'] = playerInfo.playerDetails.email;
      _params['gender'] = playerInfo.playerDetails.gender;
      _params['phone'] = playerInfo.playerDetails.phone;
      _params['playerContact'] =
        playerInfo.playerContact && playerInfo.playerContact.playerContact ? playerInfo.playerContact.playerContact : '';
      if (playerInfo.playerDetails) _params['walking'] = playerInfo.playerDetails.walking;
      if (playerInfo.playerDetails) _params['caddySelectionCriteria.caddyRequired'] = _caddySelectionCriteria.caddyRequired;

      // _params += '&playerName=' + playerInfo.playerDetails.playerName;
      // _params += '&email=' + playerInfo.playerDetails.email;
      // _params += '&gender=' + playerInfo.playerDetails.gender;
      // _params += '&phone=' + playerInfo.playerDetails.phone;
    } else if (!playerInfo.new) {
      // _params += '&player.id=' + playerInfo.playerId;
      _params['player.id'] = playerInfo.playerId;
      if (playerInfo.playerDetails) _params['walking'] = playerInfo.playerDetails.walking;
      if (playerInfo.playerDetails) _params['caddySelectionCriteria.caddyRequired'] = _caddySelectionCriteria.caddyRequired;
    }

    // let _bookingPlayer: TeeTimeBookingPlayer = bookingPlayer;
    let request = new RemoteRequest(
      global.ServerUrls.addPlayerToBooking,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((result: any) => {
        let bookingByPlayer: TeeTimeBooking = result;

        JsonService.deriveFullUrl(bookingByPlayer.bookedByPlayer, 'profile');
        JsonService.deriveFullUrl(bookingByPlayer.bookedByPlayer, 'image');
        JsonService.deriveFullUrl(bookingByPlayer.bookingAgent, 'partnerImage');
        JsonService.deriveFullUrl(bookingByPlayer.bookedByUser?.profile, 'photo');
        JsonService.deriveFullUrl(bookingByPlayer.bookedByUser?.profile, 'profileImage');
        JsonService.deriveFullUrl(bookingByPlayer.clubData, 'clubImage');
        JsonService.deriveFullUrl(bookingByPlayer.clubData, 'clubLogo');
        JsonService.deriveFullUrl(bookingByPlayer.clubData, 'clubThumbnail');
        bookingByPlayer.bookingPlayers.forEach((players: TeeTimeBookingPlayer) => {
          JsonService.deriveFullUrl(players.player, 'profile');
          JsonService.deriveFullUrl(players.player, 'image');
          JsonService.deriveFullUrl(players.caddyAssigned, 'caddyImage');
          JsonService.deriveFullUrl(players.caddyPreferred, 'caddyImage');
        });
        //  //??
        return bookingByPlayer;
      })
    );
  }

  public deletePlayerFromBooking(bookingPlayerId: number) {
    // TeeTimeBookingPlayer

    // let _bookingPlayer: TeeTimeBookingPlayer = bookingPlayer;
    let _bookingPlayerId = bookingPlayerId;
    let _params; // = {};
    _params = '?bookingPlayerId=' + _bookingPlayerId;
    // _params["bookingPlayerId"] = _bookingPlayerId;
    let request = new RemoteRequest(
      global.ServerUrls.deletePlayerFromBooking + _params,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );

    return this.http.execute(request).pipe(map((result: any) => result));
  }

  public getClubBookingOptions(clubId: number, forDate: string) {
    let request = new RemoteRequest(global.ServerUrls.getClubBookingOptions, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      clubId: clubId,
      forDate: forDate,
    });
    return this.http
      .execute(request)
      .pipe(
        map((result: any) => {
          let bookingOptions: TeeTimeBookingOptions = result;
          //  //??
          return bookingOptions;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getPlayerById(id: number) {
    //??
    let _params = '?playerId=' + id;
    let request = new RemoteRequest(global.ServerUrls.getPlayerById + _params, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      // caddyId: caddyId,
      // fromDate: fromDate,
      // toDate: toDate
    });
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let player: PlayerData = resp;
        JsonService.deriveFulImageURL(player, 'image');
        JsonService.deriveFulImageURL(player, 'profile');
        return player;
      })
    );
  }

  public getPlayerByMembership(id: string, clubId: number) {
    let _params = '?membership=' + id + '&clubId=' + clubId;
    let request = new RemoteRequest(
      global.ServerUrls.getPlayerByMembership + _params,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {}
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let player: PlayerData = resp;
        //    caddySchedule.forEach((caddyS: any) => {
        //     JsonService.deriveFullUrl(buggy, "buggyImage");
        //    })
        //  //??
        return player;
      })
    );
  }
  public searchPlayerByMembership(id: string, clubId: number) {
    let _params = {};
    // "?membership=" + id + "&clubId=" + clubId
    _params['membership'] = id;
    _params['clubId'] = clubId;
    let request = new RemoteRequest(
      global.ServerUrls.searchPlayerByMembership,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let player: Array<PlayerData> = resp;
        //    caddySchedule.forEach((caddyS: any) => {
        //     JsonService.deriveFullUrl(buggy, "buggyImage");
        //    })
        //  //??
        return player;
      })
    );
  }

  public updateBookingPlayerContact(bookingPlayerId: number, playerInfo: any) {
    // TeeTimeBookingPlayer
    //??
    let _params = {};
    // _params = "?bookingId=" + bookingId + "&sequence=" + sequence;
    _params['bookingPlayerId'] = bookingPlayerId;
    if (playerInfo.new) {
      // _params['playerContact'] = playerInfo.playerContact;
      _params['address1'] = playerInfo.playerDetails.address.address1;
      _params['address2'] = playerInfo.playerDetails.address.address2;
      _params['city'] = playerInfo.playerDetails.address.city;
      _params['state'] = playerInfo.playerDetails.address.state;
      _params['postCode'] = playerInfo.playerDetails.address.postCode;
      // _params['countryData.id'] = playerInfo.playerDetails.address.countryData.id;
      _params['phone1'] = playerInfo.playerDetails.address.phone1;
      _params['phone2'] = playerInfo.playerDetails.address.phone2;

      // _params += '&playerName=' + playerInfo.playerDetails.playerName;
      // _params += '&email=' + playerInfo.playerDetails.email;
      // _params += '&gender=' + playerInfo.playerDetails.gender;
      // _params += '&phone=' + playerInfo.playerDetails.phone;
    } else if (!playerInfo.new) {
      // _params['player.address.address1'] = playerInfo.playerDetails.address.address1
      _params['address1'] = playerInfo.playerDetails.address.address1;
      _params['address2'] = playerInfo.playerDetails.address.address2;
      _params['city'] = playerInfo.playerDetails.address.city;
      _params['state'] = playerInfo.playerDetails.address.state;
      _params['postCode'] = playerInfo.playerDetails.address.postCode;
      _params['countryData.id'] = playerInfo.playerDetails.address.countryData.id;
      _params['phone1'] = playerInfo.playerDetails.address.phone1;
      _params['phone2'] = playerInfo.playerDetails.address.phone2;
    }

    let request = new RemoteRequest(
      global.ServerUrls.updateBookingPlayerContact,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(map((resp: any) => resp));
    //    .catch(this.http.handleError);
  }

  updateBookingPlayerDetails(bookingId: number, player: TeeTimeBookingPlayer, type?: string, bookingOptions?: TeeTimeBookingOptions) {
    let _params = {};
    _params['bookingId'] = bookingId;
    _params['id'] = player.id;
    // if(!player.player) {
    _params['playerName'] = player.playerName;
    _params['gender'] = player.gender;
    _params['email'] = player.email;
    _params['sequence'] = player.sequence;
    _params['phone'] = player.phone;
    // }

    _params['playerContact'] = player.playerContact;
    _params['caddyPairing'] = player.caddyPairing;
    _params['walking'] = player.pairingNo === 0 ? true : false;
    _params['driving'] = player.driving;
    _params['caddySelectionCriteria.gender'] =
      player.caddySelectionCriteria && player.caddySelectionCriteria.gender ? player.caddySelectionCriteria.gender : null;
    _params['caddySelectionCriteria.maxAge'] =
      player.caddySelectionCriteria && player.caddySelectionCriteria.maxAge ? player.caddySelectionCriteria.maxAge : null;
    _params['caddySelectionCriteria.minAge'] =
      player.caddySelectionCriteria && player.caddySelectionCriteria.minAge ? player.caddySelectionCriteria.minAge : null;

    //??
    //??
    switch (type) {
      case 'driving':
        _params['caddyPreferred.id'] = player.caddyPreferred && player.caddyPreferred.id ? player.caddyPreferred.id : null;
        _params['driving'] = player.driving;
        _params['caddyPairing'] = player.caddyPairing;
        _params['pairingNo'] = player.pairingNo;
        break;
      case 'caddyPreferred':
        _params['caddyPreferred.id'] = player.caddyPreferred && player.caddyPreferred.id ? player.caddyPreferred.id : null;
        _params['caddyPairing'] = player.caddyPairing;
        _params['caddySelectionCriteria.caddyRequired'] = true;
        _params['pairingNo'] = player.pairingNo;
        break;
      case 'pairing':
        _params['caddyPreferred.id'] = player.caddyPreferred ? player.caddyPreferred.id : null;
        _params['pairingNo'] = player.pairingNo;
        // _params['walking'] = player.walking;
        _params['caddyPairing'] = player.caddyPairing;
        break;
      case 'caddyPairing':
        _params['caddyPairing'] = player.caddyPairing;
        _params['caddyPreferred.id'] = player.caddyPreferred && player.caddyPreferred.id ? player.caddyPreferred.id : null;
        _params['caddySelectionCriteria.caddyRequired'] = true;
        _params['pairingNo'] = player.pairingNo;
        break;
      case 'removeCaddy':
        _params['caddyPreferred.id'] = null;
        _params['caddySelectionCriteria.caddyRequired'] = false;
        // _params['caddyPairing'] = 0;
        _params['pairingNo'] = player.pairingNo;
        break;
      case 'playerType':
        _params['caddyPreferred.id'] = player.caddyPreferred && player.caddyPreferred.id ? player.caddyPreferred.id : null;
        _params['driving'] = player.driving;
        _params['caddyPairing'] = player.caddyPairing;
        _params['pairingNo'] = player.pairingNo;
        _params['playerTypeUsed.id'] = player['playerTypeUsed.id'];
        _params['caddySelectionCriteria.gender'] =
          player.caddySelectionCriteria && player.caddySelectionCriteria.gender ? player.caddySelectionCriteria.gender : null;
        _params['caddySelectionCriteria.maxAge'] =
          player.caddySelectionCriteria && player.caddySelectionCriteria.maxAge ? player.caddySelectionCriteria.maxAge : null;
        _params['caddySelectionCriteria.minAge'] =
          player.caddySelectionCriteria && player.caddySelectionCriteria.minAge ? player.caddySelectionCriteria.minAge : null;
        break;
      case 'clear':
        _params['caddyPreferred.id'] = null;
        if (bookingOptions && !bookingOptions.buggyMandatory) _params['pairingNo'] = 0;
        if (bookingOptions && !bookingOptions.caddyMandatory) _params['caddyPairing'] = 0;
        _params['caddySelectionCriteria.caddyRequired'] = false;
        _params['caddySelectionCriteria.gender'] = '';
        _params['caddySelectionCriteria.minAge'] = null;
        _params['caddySelectionCriteria.maxAge'] = null;
        break;
      case 'resetProfile':
        _params['caddyPreferred.id'] = player.caddyPreferred && player.caddyPreferred.id ? player.caddyPreferred.id : null;
        _params['driving'] = player.driving;
        _params['caddyPairing'] = player.caddyPairing;
        _params['pairingNo'] = player.pairingNo;
        _params['caddySelectionCriteria.gender'] =
          player.caddySelectionCriteria && player.caddySelectionCriteria.gender ? player.caddySelectionCriteria.gender : null;
        _params['caddySelectionCriteria.maxAge'] =
          player.caddySelectionCriteria && player.caddySelectionCriteria.maxAge ? player.caddySelectionCriteria.maxAge : null;
        _params['caddySelectionCriteria.minAge'] =
          player.caddySelectionCriteria && player.caddySelectionCriteria.minAge ? player.caddySelectionCriteria.minAge : null;
        break;
    }

    //
    //

    let request = new RemoteRequest(
      global.ServerUrls.updateBookingPlayerDetails,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(map((resp: any) => resp));
    //    .catch(this.http.handleError);
  }

  public addFromGroup(bookingId: number, groupId: number) {
    let _params = {};
    _params['bookingId'] = bookingId;
    _params['playerGroup'] = groupId;
    let request = new RemoteRequest(global.ServerUrls.addFromGroup, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
    //    .catch(this.http.handleError);
  }

  public cancelBooking(bookingId: number, cancelledByClub: boolean, reasonText?: string) {
    let _params = {};
    let _reason;
    if (!reasonText || reasonText === null) {
      if (cancelledByClub) _reason = 'Cancelled by Club';
      else _reason = 'Cancelled by Player';
    }
    if (bookingId) _params['bookingId'] = bookingId;
    _params['cancelledByClub'] = cancelledByClub;
    _params['reason'] = _reason;
    //??
    // let _bookingPlayer: TeeTimeBookingPlayer = bookingPlayer;
    let request = new RemoteRequest(global.ServerUrls.cancelBooking, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
    //    .catch(this.http.handleError);
  }

  public cancelBookingByClub(cancelBookingSpec: CancelBookingSpecification) {
    let _params = {};
    let _reason;
    if (cancelBookingSpec) _params = cancelBookingSpec;
    //??
    // let _bookingPlayer: TeeTimeBookingPlayer = bookingPlayer;
    let request = new RemoteRequest(global.ServerUrls.cancelBookingByClub, this.requestMethod.post, ContentType.JSON, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
    //    .catch(this.http.handleError);
  }

  public checkinBooking(bookingId: number, arrivingIn: number, bookingPlayerId: Array<number>, byClub: boolean = false) {
    let _params;
    let _arrivingIn = arrivingIn ? arrivingIn : 0;
    let _bookingPlayerId = bookingPlayerId;
    let _byClub;
    // _params['bookingId'] = bookingId;
    // _params['arrivingIn'] = _arrivingIn;
    // _params['bookingPlayerId'] =
    let _paramBookingPlayer;
    _paramBookingPlayer = 'bookingId=' + bookingId + '&arrivingIn=' + _arrivingIn + '&byClub=' + byClub;
    _bookingPlayerId.forEach((v, i) => {
      _paramBookingPlayer += '&bookingPlayerId=' + v;
    });
    //??
    // let _bookingPlayer: TeeTimeBookingPlayer = bookingPlayer;
    let request = new RemoteRequest(
      global.ServerUrls.checkinBooking + '?' + _paramBookingPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(map((resp: any) => resp));
    //    .catch(this.http.handleError);
  }

  public processBookingAssignments(bookingId: number) {
    // let _params;
    // _params['bookingId'] = bookingId;
    //??
    // let _bookingPlayer: TeeTimeBookingPlayer = bookingPlayer;
    let request = new RemoteRequest(
      global.ServerUrls.processBookingAssignments,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        bookingId: bookingId,
      }
    );
    return this.http.execute(request).pipe(map((resp: any) => resp));
    //    .catch(this.http.handleError);
  }

  public getPlayerByEmail(email: string) {
    // let _params = "?membership=" + id + "&clubId=" + clubId
    //??
    let _params = {};
    if (email) _params['email'] = email;
    let request = new RemoteRequest(global.ServerUrls.getPlayerByEmail, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let player: PlayerInfo = resp;
        //    caddySchedule.forEach((caddyS: any) => {
        //     JsonService.deriveFullUrl(buggy, "buggyImage");
        //    })
        //  //??
        return player;
      })
    );
  }

  public updateBuggyCaddiePreference(bookingBuggyCaddyPref: BuggyCaddiePreference) {
    let _params: BuggyCaddiePreference;
    // _params['playerPairings']['caddyAssigned'] = null;
    // _params['playerPairings']['caddyPreferred'] = null;

    if (bookingBuggyCaddyPref) {
      _params = bookingBuggyCaddyPref;

      _params.playerPairings.forEach(pp => {
        pp.caddyAssigned = null;
        pp.caddyPreferred = null;
      });
    }

    let request = new RemoteRequest(global.ServerUrls.updateBuggyCaddyPreference, this.requestMethod.post, ContentType.JSON, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));

    //
    //
    //
    // // let _bookingPlayer: TeeTimeBookingPlayer = bookingPlayer;
    //         //    .catch(this.http.handleError);
  }

  public updateBookingFlightStatus(bookingId: number, status: string) {
    let _status = status ? status : null;
    // Dispatched
    // PlayStarted
    // CrossedOver
    // PlayFinished
    // Abandoned
    let _params = {};
    _params['bookingId'] = bookingId;
    _params['status'] = _status;
    //??
    let request = new RemoteRequest(
      global.ServerUrls.updateBookingFlightStatus,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(map((resp: any) => resp));

    //
    //
    //
    // // let _bookingPlayer: TeeTimeBookingPlayer = bookingPlayer;
    //         //    .catch(this.http.handleError);
  }

  public getBookingItemizedBill(bookingId: number, afterAssignment: boolean) {
    let _params = {};
    // "?membership=" + id + "&clubId=" + clubId
    _params['bookingId'] = bookingId;
    let _afterAssignment;
    _afterAssignment = '&afterAssignment=' + afterAssignment ? 'true' : 'false';
    //??
    let request = new RemoteRequest(
      global.ServerUrls.getBookingItemizedBill + '/' + bookingId + '?afterAssignment=' + afterAssignment,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //    let itemizedBill: ItemizedBill = resp;
        //    return itemizedBill;

        return resp;
      })
    );
  }
  public cancelBookingAssignments(bookingId: number, includePreferredCaddies: boolean = false) {
    // let _params;
    // _params['bookingId'] = bookingId;
    //??
    // let _bookingPlayer: TeeTimeBookingPlayer = bookingPlayer;
    let request = new RemoteRequest(
      global.ServerUrls.cancelBookingAssignments,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        bookingId: bookingId,
        cancelPreferredCaddies: includePreferredCaddies,
      }
    );
    return this.http.execute(request).pipe(map((resp: any) => resp));
    //    .catch(this.http.handleError);
  }

  public changeBuggy(bookingId: number, bookingPlayersId: Array<number>, buggyId: number) {
    //??
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (bookingPlayersId) _params['bookingPlayerId'] = bookingPlayersId;
    if (buggyId) _params['buggyId'] = buggyId;
    //??
    let _paramBookingPlayer;
    _paramBookingPlayer = 'bookingId=' + bookingId + '&buggyId=' + buggyId;
    bookingPlayersId.forEach((v, i) => {
      _paramBookingPlayer += '&bookingPlayerId=' + v;
    });
    let request = new RemoteRequest(
      global.ServerUrls.changeBuggyFlight + '?' + _paramBookingPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let bookingObject: TeeTimeBooking = resp;
        bookingObject.bookingPlayers.forEach((player: TeeTimeBookingPlayer) => {
          JsonService.deriveFullUrl(player.player, 'image');
          JsonService.deriveFullUrl(player.player, 'profile');
          JsonService.deriveFullUrl(player.caddyAssigned, 'caddyImage');
          JsonService.deriveFullUrl(player.caddyPreferred, 'caddyImage');
        });

        return {
          resp,
          bookingObject,
        };
      })
    );
  }

  public changeCaddy(bookingId: number, bookingPlayersId: Array<number>, caddieId: number) {
    let _params = {};
    _params['bookingId'] = bookingId;
    _params['bookingPlayerId'] = bookingPlayersId;
    _params['caddieId'] = caddieId;

    let _paramBookingPlayer;
    _paramBookingPlayer = 'bookingId=' + bookingId + '&caddieId=' + caddieId;
    bookingPlayersId.forEach((v, i) => {
      _paramBookingPlayer += '&bookingPlayerId=' + v;
    });

    let request = new RemoteRequest(
      global.ServerUrls.changeCaddyFlight + '?' + _paramBookingPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let bookingObject: TeeTimeBooking = resp;
        bookingObject.bookingPlayers.forEach((player: TeeTimeBookingPlayer) => {
          JsonService.deriveFullUrl(player.player, 'image');
          JsonService.deriveFullUrl(player.player, 'profile');
          JsonService.deriveFullUrl(player.caddyAssigned, 'caddyImage');
          JsonService.deriveFullUrl(player.caddyPreferred, 'caddyImage');
        });

        return {
          resp,
          bookingObject,
        };
      })
    );
  }

  public getBuggyDayDetails(clubId: number, forDate: string) {
    let _params = {};
    _params['clubId'] = clubId;
    _params['forDate'] = forDate;

    let request = new RemoteRequest(
      global.ServerUrls.getBuggyDayDetails,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let buggyDayDetails: Array<BuggyDayDetails> = resp;
        buggyDayDetails.forEach((buggy: BuggyDayDetails) => {
          JsonService.deriveFullUrl(buggy.buggy, 'buggyImage');
        });
        //  //??
        return buggyDayDetails;
      })
    );
  }

  public getCaddieDayDetails(clubId: number, forDate: string) {
    let _params = {};
    _params['clubId'] = clubId;
    _params['forDate'] = forDate;

    let request = new RemoteRequest(
      global.ServerUrls.getCaddyDayDetails,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let caddyDayDetails: Array<CaddyDayDetails> = resp;
        caddyDayDetails.forEach((caddy: CaddyDayDetails) => {
          JsonService.deriveFullUrl(caddy.caddy, 'caddyImage');
        });
        //  //??
        return caddyDayDetails;
      })
    );
  }

  public changeSlot(bookingId: number, newSlot: TeeTimeSlotDisplay) {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (newSlot) _params['slotDayId'] = newSlot.slot.slotDayId;
    if (newSlot) _params['slotNo'] = newSlot.slot.slotNo;

    let request = new RemoteRequest(global.ServerUrls.changeSlot, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        //    let bookingObject: TeeTimeBooking = resp;
        //    bookingObject.bookingPlayers.forEach((player: TeeTimeBookingPlayer) => {

        //     JsonService.deriveFullUrl(player.player, "image");
        //     JsonService.deriveFullUrl(player.player, "profile");
        //         JsonService.deriveFullUrl(player.caddyAssigned, "caddyImage");
        //         JsonService.deriveFullUrl(player.caddyPreferred, "caddyImage");
        //        })

        return resp;
        //    { resp, bookingObject}
      })
    );
  }
  public swapFlightSlot(bookingId: number, swapBookingId: number) {
    let _params = {};
    if (bookingId) _params['firstBookingId'] = bookingId;
    if (swapBookingId) _params['secondBookingId'] = swapBookingId;
    // if (newSlot) _params['slotNo'] = newSlot.slot.slotNo;

    let request = new RemoteRequest(global.ServerUrls.swapFlightSlot, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          //??console.log("change slot ", resp)

          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public moveSlot(bookingId: number, newSlot: TeeTimeSlotDisplay) {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (newSlot) _params['teeOffDate'] = newSlot.slot.teeOffDate;
    if (newSlot) _params['slotNo'] = newSlot.slot.slotNo;

    let request = new RemoteRequest(global.ServerUrls.moveFlightSlot, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        //    let bookingObject: TeeTimeBooking = resp;
        //    bookingObject.bookingPlayers.forEach((player: TeeTimeBookingPlayer) => {

        //     JsonService.deriveFullUrl(player.player, "image");
        //     JsonService.deriveFullUrl(player.player, "profile");
        //         JsonService.deriveFullUrl(player.caddyAssigned, "caddyImage");
        //         JsonService.deriveFullUrl(player.caddyPreferred, "caddyImage");
        //        })

        return resp;
        //    { resp, bookingObject}
      })
    );
  }

  public rateForClub(clubId: number, clubRating: ClubRating) {
    let _params = {};
    if (clubRating) _params = clubRating;
    // if(clubId) _params['clubId'] = clubId;
    // if(rating) _params['rating'] = rating;
    // if(playerId) _params['playerId'] = playerId;

    let request = new RemoteRequest(global.ServerUrls.rateForClub + '/' + clubId, this.requestMethod.post, ContentType.JSON, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
        //    { resp, bookingObject}
      })
    );
  }

  public rateForCaddy(caddieId: number, rating: number, playerId: number, comment: string) {
    let _params = {};
    // if(caddieId) _params['caddieId'] = caddieId;
    if (rating) _params['rating'] = rating;
    if (playerId) _params['playerId'] = playerId;
    if (comment) _params['comment'] = comment;
    //??

    let request = new RemoteRequest(
      global.ServerUrls.rateForCaddie + '/' + caddieId + '?rating=' + _params['rating'] + '&playerId=' + _params['playerId'],
      this.requestMethod.post,
      ContentType.PLAIN_TEXT,
      comment
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
        //    { resp, bookingObject}
      })
    );
  }

  public getClubRatingItems(clubId: number) {
    let _params = {};
    _params['clubId'] = clubId;

    let request = new RemoteRequest(
      global.ServerUrls.getClubRatingItems + '/' + clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let ratingItems: Array<RatingItem> = resp;
        //  //??
        return ratingItems;
      })
    );
  }

  public getBookingStatsWithPlayerInfo(clubId: number, startDate?: string, endDate?: string, courseId?: number) {
    let _params = {};
    _params['startDate'] = startDate;
    _params['endDate'] = endDate;
    if (courseId) _params['courseId'] = courseId;
    let request = new RemoteRequest(
      global.ServerUrls.getBookingStats + '/' + clubId + global.ServerUrls.getBookStatPlayerInfo,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let bookingStats: BookingStatistics = resp;
        //  //??
        return bookingStats;
      })
    );
  }

  public getBookingStats(clubId: number, startDate?: string, endDate?: string) {
    let _params = {};
    _params['startDate'] = startDate;
    _params['endDate'] = endDate;
    let request = new RemoteRequest(
      global.ServerUrls.getBookingStats + '/' + clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let bookingStats: BookingStatistics = resp;
        //  //??
        return bookingStats;
      })
    );
  }

  public getCourseUtilStats(clubId: number, startDate?: string, endDate?: string, courseId?: number) {
    let _params = {};
    _params['startDate'] = startDate;
    _params['endDate'] = endDate;
    if (courseId) _params['courseId'] = courseId;
    let request = new RemoteRequest(
      global.ServerUrls.getCourseUtilStats + '/' + clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let courseUtilStats: CourseUtilizationStatistics = resp;
        //  //??
        return courseUtilStats;
      })
    );
  }

  public getCaddyBuggyUtilStats(clubId: number, startDate?: string, endDate?: string, courseId?: number) {
    let _params = {};
    _params['startDate'] = startDate;
    _params['endDate'] = endDate;
    if (courseId) _params['courseId'] = courseId;
    let request = new RemoteRequest(
      global.ServerUrls.getCaddyBuggyStats + '/' + clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let caddieBuggyAsgmtStats: CaddieBuggyAssignmentStatistics = resp;
        //  //??
        return caddieBuggyAsgmtStats;
      })
    );
  }

  public getCaddyBuggyDayStats(clubId: number, startDate?: string, endDate?: string, courseId?: number) {
    let _params = {};
    _params['startDate'] = startDate;
    _params['endDate'] = endDate;
    if (courseId) _params['courseId'] = courseId;
    let request = new RemoteRequest(
      global.ServerUrls.getCaddyBuggyDayStats + '/' + clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let caddieBuggyAsgmtStats: CaddieBuggyStatistics = resp;
        //  //??
        return caddieBuggyAsgmtStats;
      })
    );
  }

  public getFutureStats(clubId: number) {
    let _params = {};
    let request = new RemoteRequest(
      global.ServerUrls.getFutureStats + '/' + clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let futureStats: FutureBookingStatistics = resp;
        //  //??
        return futureStats;
      })
    );
  }

  public getFAQ() {
    let request = new RemoteRequest('http://' + global.MygolfServerHost + '/document/assets/faq.json', this.requestMethod.get);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //
        let groupItems: any = resp;
        //  //??
        return groupItems;
      })
    );
    // return this.http.get('/assets/shipping.json');
  }

  public getContactUs() {
    let request = new RemoteRequest('http://' + global.MygolfServerHost + '/document/assets/contact-us.json', this.requestMethod.get);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //
        let contactUsItem: ContactUsItem = resp;
        //  //??
        return contactUsItem;
      })
    );
    // return this.http.get('/assets/shipping.json');
  }

  public getHelp() {
    //??
    let request = new RemoteRequest('http://' + global.MygolfServerHost + '/document/assets/help.json', this.requestMethod.get);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        // HelpURLs
        let helpURL;
        let _data: Array<HelpURLs> = resp;
        helpURL = _data
          .map(h => {
            return h;
          })
          .filter(h => {
            return h.server.toLowerCase() === global.MygolfServerHost.toLowerCase();
          });
        //  //??
        return helpURL;
      })
    );
    // return this.http.get('/assets/shipping.json');
  }
  public getClubHelp() {
    let request = new RemoteRequest('http://' + global.MygolfServerHost + '/document/assets/clubHelp.json', this.requestMethod.get);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //
        let clubHelpItem: Array<ClubHelpItem> = resp;
        //  //??
        return clubHelpItem;
      })
    );
    // return this.http.get('/assets/shipping.json');
  }

  public clubBookingSlot(
    reqBookSlot?: TeeTimeSlotBookingRequest,
    addBookingPlayer: boolean = true,
    captchaResponse?: string
  ): Observable<any> {
    let _reqBookSlot = reqBookSlot;
    // reqBookSlot = {
    //     "courseId": 0,
    //     "teeOffDate": moment().format("YYYY-MM-DD"),
    //     "teeOffTimeFrom": moment().format("HH:mm"),
    //     "teeOffTimeTo":  moment().format("HH:mm"),
    //     "totalPlayers": 0,
    //       "buggyRequired": 0,
    //       "caddiesRequired": 0,
    //       "ninesPlaying": 0,
    //       "bookingName": "string",
    //       "bookingEmail": "string",
    //       "bookingPhone": "string",
    // }

    // "bookingRequestedAt":  moment().format("YYYY-MM-DD")

    let headers = {};
    if (captchaResponse && captchaResponse.length > 0) headers['captcha-response'] = captchaResponse;
    else headers = null;

    let _addBookingPlayer = '?addBookingPlayer=' + (addBookingPlayer ? 'true' : 'false');
    let request = new RemoteRequest(
      global.ServerUrls.clubBookingSlot,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      reqBookSlot,
      headers
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
    //    .catch(this.http.handleError);
  }

  public clubRegisterUser(params: any) {
    // lastName: string,
    // gender: string,
    // email: string,
    // phone: string,
    // handicap: number,
    // teeoff: string,
    // countryId?: string): Observable<PlayerInfo> {
    // let request = new RemoteRequest(global.ServerUrls.registerFriend,
    //     this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, {
    //         firstName: firstName,
    //         lastName : lastName,
    //         gender   : gender,
    //         email    : email,
    //         teeoff   : teeoff,
    //         phone    : phone,
    //         handicap : handicap,
    //         country  : countryId,
    //     });

    // return this.http.execute(request)
    //            .pipe(map((resp: any) => {
    //                let player: PlayerInfo = resp;
    //                return player;
    //            }));

    let _params = {};
    _params = params ? params : {};
    // // if(caddieId) _params['caddieId'] = caddieId;
    // if(rating) _params['rating'] = params.rating;
    // if(playerId) _params['playerId'] = playerId;

    //??
    //??
    let request = new RemoteRequest(
      global.ServerUrls.clubRegisterUser,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
        //    { resp, bookingObject}
      })
    );
  }

  public clubCapturePayment(bookingOfflinePayment: BookingOfflinePayment) {
    let _params = {};
    _params = bookingOfflinePayment ? bookingOfflinePayment : {};
    // // if(caddieId) _params['caddieId'] = caddieId;
    // if(rating) _params['rating'] = params.rating;
    // if(playerId) _params['playerId'] = playerId;

    //??
    //??
    let request = new RemoteRequest(global.ServerUrls.clubCapturePayment, this.requestMethod.post, ContentType.JSON, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
        //    { resp, bookingObject}
      })
    );
  }
  public getCaddyRatings(caddyId: number, fromDate: string, toDate?: string) {
    //??
    let _params = {};
    let _caddyId = caddyId ? '/' + caddyId : '';
    if (fromDate) _params['fromDate'] = fromDate;
    if (toDate) _params['toDate'] = toDate;
    let request = new RemoteRequest(
      global.ServerUrls.getCaddyRatings + _caddyId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let contactUsItem: ContactUsItem = resp;
        //  //??
        return contactUsItem;
      })
    );
    // return this.http.get('/assets/shipping.json');
  }

  public getCaddyAssignments(caddyId: number, fromDate: string, toDate?: string) {
    //??
    let _params = {};
    let _caddyId = caddyId ? '/' + caddyId : '';
    if (fromDate) _params['fromDate'] = fromDate;
    if (toDate) _params['toDate'] = toDate;
    let request = new RemoteRequest(
      global.ServerUrls.getCaddyAssignments + _caddyId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let caddyAssignment: Array<CaddyAssignment> = resp;
        //  //??
        return {
          resp,
          caddyAssignment,
        };
      })
    );
    // return this.http.get('/assets/shipping.json');
  }

  public getCaddyInfo(caddyId?: number) {
    //??
    let _caddyId = caddyId ? '/' + caddyId : '';
    let request = new RemoteRequest(global.ServerUrls.getCaddyInfo + _caddyId, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let contactUsItem: ContactUsItem = resp;
        //  //??
        return contactUsItem;
      })
    );
    // return this.http.get('/assets/shipping.json');
  }

  public getListClubPlayerVouchers(clubId?: number, playerId?: number) {
    //??
    //??
    // let _caddyId = (caddyId)?"/"+caddyId:"";
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (playerId) _params['playerId'] = playerId;
    let request = new RemoteRequest(
      global.ServerUrls.listActiveClubPlayerVouchers,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let voucherList: Array<TeeTimeClubVoucher> = resp;
        //  //??
        return voucherList;
      })
    );
    // return this.http.get('/assets/shipping.json');
  }

  public setRefundBookingPlayer(
    bookingId: number,
    playerId: number,
    amount: number,
    reason: string,
    refundMode: string = 'CASH',
    refundReason: string,
    validUntil?: string
  ): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (playerId) _params['playerId'] = playerId;
    if (amount) _params['amount'] = amount;
    if (reason) _params['reason'] = reason;
    if (refundMode) _params['refundMode'] = refundMode;
    if (refundReason) _params['refundReason'] = refundReason;
    if (validUntil) _params['refundValidUntil'] = validUntil;
    if (reason) _params['description'] = reason;

    let request = new RemoteRequest(
      global.ServerUrls.setRefundBookingPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public setRefundBookingAgent(
    bookingId: number,
    partnerId: string,
    amount: number,
    reason: string,
    refundMode: string = 'CASH',
    refundReason: string,
    validUntil?: string
  ): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (partnerId) _params['partnerId'] = partnerId;
    if (amount) _params['amount'] = amount;
    if (reason) _params['reason'] = reason;
    if (refundMode) _params['refundMode'] = refundMode;
    if (refundReason) _params['refundReason'] = refundReason;
    if (validUntil) _params['refundValidUntil'] = validUntil;
    if (reason) _params['description'] = reason;

    let request = new RemoteRequest(
      global.ServerUrls.setRefundBookingPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??console.log("set refund booking player : ", resp)
        return resp;
      })
    );
  }

  public applyPlayerBookingVoucher(bookingId: number, voucherId: number, force?: boolean): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (voucherId) _params['voucherId'] = voucherId;
    if (force) _params['force'] = force;

    let request = new RemoteRequest(
      global.ServerUrls.applyPlayerBookingVoucher,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public removePlayerBookingVoucher(bookingId: number, voucherId: number): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (voucherId) _params['voucherId'] = voucherId;

    let request = new RemoteRequest(
      global.ServerUrls.removePlayerBookingVoucher,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public getClubVoucherSeries(url: number, clubId: number, search?: string, pageSize?: number, pageNo?: number, showAll?: boolean) {
    //??
    //
    // let _caddyId = (caddyId)?"/"+caddyId:"";
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (pageNo) _params['pageNo'] = pageNo;
    if (pageSize) _params['pageSize'] = pageSize;
    if (search) _params['search'] = search;
    if (showAll) _params['activeOnly'] = false;

    let _url;
    if (url === 1) _url = global.ServerUrls.listClubVoucherSeries;
    if (url === 2) _url = 'assets/club-voucher-series.json';
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);

    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let voucherList: Array<TeeTimeClubVoucher> = resp;
        //  //??
        return voucherList;
      })
    );
    // return this.http.get('/assets/shipping.json');
  }

  public assignClubPlayerVoucher(
    clubId: number,
    playerId: number,
    voucherSeriesId: number,
    numberOfVouchers: number,
    validFrom?: string,
    remarks?: string,
    dynamicAmount?: number
  ): Observable<any> {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (playerId) _params['playerId'] = playerId;
    if (voucherSeriesId) _params['voucherSeriesId'] = voucherSeriesId;
    if (numberOfVouchers) _params['numberOfVouchers'] = numberOfVouchers;
    if (validFrom) _params['validFrom'] = validFrom;
    if (remarks) _params['remarks'] = remarks;
    if (dynamicAmount) _params['voucherAmount'] = dynamicAmount;
    let request = new RemoteRequest(
      global.ServerUrls.assignClubPlayerVoucher,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public getListPlayerVouchers(playerId?: number, activeAsOf?: string) {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (activeAsOf) _params['activeAsOf'] = activeAsOf;
    let request = new RemoteRequest(
      global.ServerUrls.listActivePlayerVouchers,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let voucherList: Array<TeeTimeClubVoucher> = resp;
        //  //??
        return voucherList;
      })
    );
    // return this.http.get('/assets/shipping.json');
  }

  public getListClubDiscounts(clubId: number, search?: string, pageSize?: number, pageNo?: number) {
    //??
    // let _caddyId = (caddyId)?"/"+caddyId:"";
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (search) _params['search'] = search;
    if (pageSize) _params['pageSize'] = pageSize;
    if (pageNo) _params['pageNo'] = pageNo;
    let request = new RemoteRequest(
      global.ServerUrls.listClubDiscounts,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let listClubDiscount: any = resp;
        //  //??
        return listClubDiscount;
      })
    );
    // return this.http.get('/assets/shipping.json');
  }

  public getActiveListClubDiscounts(clubId: number, effectiveDate?: string) {
    //??
    // let _caddyId = (caddyId)?"/"+caddyId:"";
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (effectiveDate) _params['effectiveDate'] = effectiveDate;
    let request = new RemoteRequest(
      global.ServerUrls.listActiveDiscounts,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let listClubDiscount: any = resp;
        //  //??
        return listClubDiscount;
      })
    );
    // return this.http.get('/assets/shipping.json');
  }

  public unassignClubPlayerVoucher(clubId: number, playerId: number, voucherIds: Array<number>): Observable<any> {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (playerId) _params['playerId'] = playerId;
    if (voucherIds) _params['voucherIds'] = voucherIds;

    //??
    // if(1) return null;

    let request = new RemoteRequest(
      global.ServerUrls.unassignClubPlayerVoucher,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public getApplicableClubPlayerTypes(clubId: number, playerId: number, effectiveDate?: string) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (playerId) _params['playerId'] = playerId;
    if (effectiveDate) _params['effectiveDate'] = effectiveDate;
    let request = new RemoteRequest(
      global.ServerUrls.getClubApplicablePlayerTypes,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let player: PlayerData = resp;
        //??
        return player;
      })
    );
  }

  public applyPlayerBookingDiscount(bookingId: number, discountId: number, bookingPlayerId?: number, force?: boolean): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (discountId) _params['discountId'] = discountId;
    if (bookingPlayerId) _params['bookingPlayerId'] = bookingPlayerId;
    if (force) _params['force'] = force;

    let request = new RemoteRequest(
      global.ServerUrls.applyPlayerBookingDiscount,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public removePlayerBookingDiscount(bookingId: number, discountId: number, bookingPlayerId?: number): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (discountId) _params['discountId'] = discountId;
    if (bookingPlayerId) _params['bookingPlayerId'] = bookingPlayerId;

    let request = new RemoteRequest(
      global.ServerUrls.removePlayerBookingDiscount,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public getDiscountCompanies(search?: string, pageSize: number = 30, pageNo: number = 1) {
    let _params = {};
    if (search) _params['search'] = search;
    if (pageSize) _params['pageSize'] = pageSize;
    if (pageNo) _params['pageNo'] = pageNo;
    let request = new RemoteRequest(
      global.ServerUrls.listDiscountCompanies,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let player: PlayerData = resp;
        //??
        return player;
      })
    );
  }

  public createPlayerDiscountCard(
    playerId: number,
    programId: string,
    membershipNo?: string,
    validFrom?: string,
    validUntil?: string
  ): Observable<any> {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (programId) _params['programId'] = programId;
    if (membershipNo) _params['membershipNo'] = membershipNo;
    if (validFrom) _params['validFrom'] = validFrom;
    if (validUntil) _params['validUntil'] = validUntil;
    let request = new RemoteRequest(
      global.ServerUrls.createPlayerDiscountCard,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public deletePlayerDiscountCard(playerDiscountId: number): Observable<any> {
    let _params = {};
    if (playerDiscountId) _params['playerDiscountId'] = playerDiscountId;
    let request = new RemoteRequest(
      global.ServerUrls.deletePlayerDiscountCard,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public applyForClubVerifyDiscountCard(playerId: number, programId: string, clubId?: number): Observable<any> {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (programId) _params['programId'] = programId;
    if (clubId) _params['clubId'] = clubId;
    let request = new RemoteRequest(
      global.ServerUrls.applyForClubVerifyDiscountCard,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public approvePlayerDiscountCard(
    playerId: number,
    playerDiscountProgramId: Array<number>,
    clubId: number,
    validFrom?: string,
    validUntil?: string
  ): Observable<any> {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    // if(programId) _params['programId'] = programId;
    if (playerDiscountProgramId) _params['playerDiscountProgramId'] = playerDiscountProgramId;
    if (clubId) _params['clubId'] = clubId;
    if (validFrom) _params['validFrom'] = validFrom;
    if (validUntil) _params['validUntil'] = validUntil;
    let re = /:clubId/gi;
    // let re = '/:playerId/';
    let _url = global.ServerUrls.approvePlayerDiscountCard;
    _url = _url.replace(re, _params['clubId']);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          //??console.log("apply for verifiy player discount card: ", resp)
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public approveMultiPlayerDiscountCard(
    playerId: number,
    programId: string,
    clubId: number,
    validFrom?: string,
    validUntil?: string
  ): Observable<any> {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (programId) _params['programId'] = programId;
    if (clubId) _params['clubId'] = clubId;
    if (validFrom) _params['validFrom'] = validFrom;
    if (validUntil) _params['validUntil'] = validUntil;
    let request = new RemoteRequest(
      global.ServerUrls.approveMultiPlayerDiscountCard,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }
  public undoApprovePlayerDiscountCard(playerId: number, programId: string, clubId: number, pdpId?: number): Observable<any> {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (programId) _params['programId'] = programId;
    if (clubId) _params['clubId'] = clubId;
    if (pdpId) _params['playerDiscountProgramId'] = pdpId;
    let request = new RemoteRequest(
      global.ServerUrls.undoApprovePlayerDiscountCard,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public getPlayerDiscountPrograms(playerId: string) {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    let request = new RemoteRequest(
      global.ServerUrls.listPlayerDiscountPrograms,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let pdp: Array<PlayerDiscountProgram> = resp;
          if (pdp && pdp.length > 0)
            pdp.forEach(p => {
              JsonService.deriveFulImageURL(p.discountProgram.discountCompany, 'partnerImage');
            });
          //??console.log("get list player discount programs : ", resp)
          return pdp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public listDiscountProgramsClub(programId: string) {
    let _params = {};
    if (programId) _params['programId'] = programId;
    let request = new RemoteRequest(
      global.ServerUrls.listDiscountProgramsClub,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //    let player: PlayerData = resp;
        //??
        return resp;
      })
    );
  }

  public getDiscountPrograms(companyId: string) {
    let _params = {};
    if (companyId) _params['companyId'] = companyId;
    let request = new RemoteRequest(
      global.ServerUrls.listDiscountPrograms,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let player: PlayerData = resp;
        //??
        return player;
      })
    );
  }

  public getPlayerCredits(playerId: number) {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    let request = new RemoteRequest(global.ServerUrls.getPlayerCredits, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let player: PlayerData = resp;
        //??
        return player;
      })
    );
  }

  public getPlayerClubCredits(playerId: number, clubId: number) {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (clubId) _params['clubId'] = clubId;
    let request = new RemoteRequest(
      global.ServerUrls.getPlayerClubCredits,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let player: any = resp;
        //??
        return player;
      })
    );
  }
  public getVouchersIssued(
    clubId: number,
    seriesId?: number,
    search?: string,
    includeRedeemed: boolean = false,
    includeExpired: boolean = false,
    pageSize: number = 999,
    pageNo: number = 1
  ) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (seriesId) _params['seriesId'] = seriesId;
    if (search) _params['search'] = search;
    if (includeRedeemed) _params['includeRedeemed'] = includeRedeemed;
    if (includeExpired) _params['includeExpired'] = includeExpired;
    if (pageSize) _params['pageSize'] = pageSize;
    if (pageNo) _params['pageNo'] = pageNo;

    let request = new RemoteRequest(
      global.ServerUrls.listClubVouchersIssued,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let voucherIssued: Array<TeeTimeClubVoucher> = resp;
          //??console.log("get list club vouchers issued : ", resp)
          return voucherIssued;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public redeemPlayerClubCredit(bookingId: number, playerId: number, amount: number, bypassWallet?: boolean): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (playerId) _params['playerId'] = playerId;
    if (amount) _params['amount'] = amount;
    if (bypassWallet) _params['bypassWallet'] = bypassWallet;
    let request = new RemoteRequest(
      global.ServerUrls.redeemClubCredit,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public getListAllCardApplyForPlayer(playerId: number, programId: string, pendingOnly: boolean = false, includeExpired: boolean = false) {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (programId) _params['programId'] = programId;
    if (pendingOnly) _params['pendingOnly'] = pendingOnly;
    if (includeExpired) _params['includeExpired'] = includeExpired;

    let request = new RemoteRequest(
      global.ServerUrls.listAllCardApplyForPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //   let player: PlayerData = resp;
        //??
        return resp;
      })
    );
  }

  public getListAllPlayersCardDiscount(clubId: number, programId?: string, pendingOnly: boolean = false, includeExpired: boolean = false) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (programId) _params['programId'] = programId;
    if (pendingOnly) _params['pendingOnly'] = pendingOnly;
    if (includeExpired) _params['includeExpired'] = includeExpired;

    let request = new RemoteRequest(
      global.ServerUrls.listAllPlayersCardDiscount,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //   let player: PlayerData = resp;
        //??
        return resp;
      })
    );
  }

  public getListClubDiscountProgram(clubId: number, programId: string) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (programId) _params['programId'] = programId;

    let request = new RemoteRequest(
      global.ServerUrls.listClubDiscountProgram,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //   let player: PlayerData = resp;
        //??
        return resp;
      })
    );
  }

  public getApplicableDiscountsForPlayer(clubId: number, playerId: number, effectiveDate?: string) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (playerId) _params['playerId'] = playerId;
    if (effectiveDate) _params['effectiveDate'] = effectiveDate;

    let request = new RemoteRequest(
      global.ServerUrls.getApplicableDiscountsForPlayer,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let listClubDiscount: any = resp;
        //   let player: PlayerData = resp;
        //??
        return listClubDiscount;
      })
    );
  }

  public updatePlayerCardDocument(
    imageURL: string,
    contentType: string,
    playerDiscountProgramId: number,
    authToken?: string
  ): Observable<UploadResult> {
    // public updatePlayerPhoto(imageUrl: string, mimeType: string, playerId?: number): Observable<UploadResult>{
    let _pDiscountProgId;
    if (playerDiscountProgramId) _pDiscountProgId = '?id=' + playerDiscountProgramId;
    let options = {
      // "playerId": (playerId)? playerId:this.session.playerId
      file: imageURL,
      authToken: authToken,
    };

    return from(
      this.ftService.uploadFile(imageURL, global.ServerUrls.updatePlayerDiscountDocument + _pDiscountProgId, contentType, options)
    );
  }

  public addPlayerType(
    imageURL: string,
    contentType: string,
    playerId: number,
    bookingPlayerType: string,
    authToken?: string
  ): Observable<UploadResult> {
    // public updatePlayerPhoto(imageUrl: string, mimeType: string, playerId?: number): Observable<UploadResult>{
    let _playerId;
    let _playerType;
    if (playerId) _playerId = 'playerId=' + playerId;
    if (bookingPlayerType) _playerType = '&bookingPlayerType=' + bookingPlayerType;
    let options = {
      // "playerId": (playerId)? playerId:this.session.playerId
      file: imageURL,
      authToken: authToken,
    };

    return from(
      this.ftService.uploadFile(imageURL, global.ServerUrls.assignBookingPlayerType + '?' + _playerId + _playerType, contentType, options)
    );
  }

  // public updatePlayerPhoto(imageURL: string,
  //     contentType: string, playerId: number, friend: boolean=false): Observable<PlayerInfo> {
  //     return this.playerService.updatePlayerPhoto(imageURL, contentType, playerId)
  //         .pipe(map((uploadResult: UploadResult)=>{
  //             let playerInfo: PlayerInfo;
  //             let errMsg: PlayerInfo;
  //           //??
  //           //??
  //             playerInfo = JSON.parse(JSON.stringify(uploadResult.message));
  //             // errMsg = JSON.parse(JSON.stringify(uploadResult.message));
  //             // playerInfo.errorMessage = errMsg.errorMessage;
  //             // playerInfo.errorMessage = JSON.parse(JSON.stringify(uploadResult.message));
  //           //??
  //             JsonService.deriveFullUrl(playerInfo, "photoUrl");
  //             JsonService.deriveFullUrl(playerInfo, "thumbnail");
  //             if(!friend) {
  //                 //The upload result message is player info
  //                 this.store.dispatch(createAction(PlayerHomeActions.UPDATE_PLAYER_PROFILE, playerInfo));
  //             }
  //             return playerInfo;
  //         });
  // }

  public updatePlayerPhotoWeb(
    file: any,
    imageURL: string,
    contentType: string,
    playerId: number,
    authToken: string,
    formData?: any
  ): Observable<any> {
    // public updatePlayerPhoto(imageUrl: string, mimeType: string, playerId?: number): Observable<UploadResult>{
    let _playerId;
    let _playerType;
    // if (playerId) _playerId = "playerId=" + playerId;
    // if (bookingPlayerType) _playerType = "&bookingPlayerType=" + bookingPlayerType
    let options = {
      // "playerId": (playerId)? playerId:this.session.playerId
      file: file,
      authToken: authToken,
    };

    const _formData: FormData = new FormData();
    _formData.append('file', file);
    _formData.append('playerId', String(playerId));
    let _hdrs = {
      'Content-Type': 'multipart/form-data',
      'X-AUTH-TOKEN': authToken,
      'Player-Id': _playerId,
    };

    // let _url = global.ServerUrls.updatePhoto;
    // let request = new RemoteRequest(_url,
    //     this.requestMethod.post, ContentType.MULTIPART_FORM, _formData);
    // return this.http.execute(request)
    //     .map((resp: any) => resp)
    let request = new RemoteRequest(global.ServerUrls.updatePhoto, this.requestMethod.post, ContentType.MULTIPART_FORM, _formData);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }
  public recalculateBookingPricing(bookingId: number, ignoreDate?: boolean) {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (ignoreDate) _params['ignoreDate'] = ignoreDate;

    let request = new RemoteRequest(
      global.ServerUrls.recalculateBookingPricing,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let bookingObject: any = resp;

        JsonService.deriveFullUrl(bookingObject.bookedByPlayer, 'profile');
        JsonService.deriveFullUrl(bookingObject.bookedByPlayer, 'image');
        JsonService.deriveFullUrl(bookingObject.bookingAgent, 'partnerImage');
        JsonService.deriveFullUrl(bookingObject.bookedByUser?.profile, 'photo');
        JsonService.deriveFullUrl(bookingObject.bookedByUser?.profile, 'profileImage');
        JsonService.deriveFullUrl(bookingObject.clubData, 'clubImage');
        JsonService.deriveFullUrl(bookingObject.clubData, 'clubLogo');
        JsonService.deriveFullUrl(bookingObject.clubData, 'clubThumbnail');
        bookingObject.bookingPlayers.forEach((players: TeeTimeBookingPlayer) => {
          JsonService.deriveFullUrl(players.player, 'profile');
          JsonService.deriveFullUrl(players.player, 'image');
          JsonService.deriveFullUrl(players.caddyAssigned, 'caddyImage');
          JsonService.deriveFullUrl(players.caddyPreferred, 'caddyImage');
        });
        return bookingObject;
      })
    );
  }
  public bookingWaiveOff(bookingId: number, amount: number, reason?: string): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (amount) _params['amount'] = amount;
    if (reason) _params['reason'] = reason;

    let request = new RemoteRequest(global.ServerUrls.bookingWaiveOff, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public undoBookingWaiveOff(bookingId: number, sequence: number): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (sequence) _params['sequence'] = sequence;

    let request = new RemoteRequest(
      global.ServerUrls.undoBookingWaiveOff,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public assignBookingPlayerType(playerId: number, bookingPlayerType: string): Observable<any> {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (bookingPlayerType) _params['bookingPlayerType'] = bookingPlayerType;

    let request = new RemoteRequest(
      global.ServerUrls.assignBookingPlayerType,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public assignableBookingPlayerType() {
    let _params = {};
    // if(clubId) _params['clubId'] = clubId;
    // if(playerId) _params['playerId'] = playerId;
    // if(effectiveDate) _params['effectiveDate'] = effectiveDate;

    let request = new RemoteRequest(
      global.ServerUrls.assignableBookingPlayerType,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        //   let player: PlayerData = resp;
        //??
        return data;
      })
    );
  }

  public assignedBookingPlayerType(playerId: number) {
    let _params = {};
    // if(clubId) _params['clubId'] = clubId;
    if (playerId) _params['playerId'] = playerId;
    // if(effectiveDate) _params['effectiveDate'] = effectiveDate;

    let request = new RemoteRequest(
      global.ServerUrls.assignedBookingPlayerType,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: Array<any> = resp;
        data.forEach(d => {
          JsonService.deriveFulImageURL(d, 'supportingDocument');
        });
        //   let player: PlayerData = resp;
        //??
        return data;
      })
    );
  }

  public removeBookingPlayerType(playerId: number, bookingPlayerType: string): Observable<any> {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (bookingPlayerType) _params['bookingPlayerType'] = bookingPlayerType;

    let request = new RemoteRequest(
      global.ServerUrls.removeBookingPlayerType,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  public getClubMembersList(clubId: number, params?: any) {
    // ,activeOnly?: boolean, search?: string
    let _params = {};
    // if(clubId) _params['clubId'] = clubId;
    // if(clubId) _params['clubId'] = clubId;
    let _status;
    console.debug('get club members list : ', params);
    if (params['activeOnly']) _params['activeOnly'] = params['activeOnly'];
    if (params['search']) _params['search'] = params['search'];
    if (params['status']) _status = params['status'];
    if (params['membershipTypes']) _params['membershipTypes'] = params['membershipTypes'];
    // if(effectiveDate) _params['effectiveDate'] = effectiveDate;

    let _clubMembersURL = global.ServerUrls.listClubMembership + '/' + clubId;
    if (_status) _clubMembersURL += '/' + _status;

    let request = new RemoteRequest(_clubMembersURL, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: Array<ClubMembership> = resp;
          data.forEach((d: ClubMembership) => {
            JsonService.deriveFulImageURL(d.player, 'profile');
            JsonService.deriveFulImageURL(d.player, 'image');
            d.player.playerId = d.player.id;
          });
          //   let player: PlayerData = resp;
          //??console.log("get list club members : ", resp)
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updatePlayerClubMembership(mode: string, params: any): Observable<any> {
    let _params = {};
    // params['handicapSystem'] = _hcpSys;
    _params['membership'] = params['membership'];
    let _playerId = params['playerId'];
    let _clubId = params['clubId'];
    let _mode;
    if (mode) _mode = mode;
    let _clubMembersURL = global.ServerUrls.listClubMembership + '/' + _clubId;
    if (_mode === 'approve') _clubMembersURL += global.ServerUrls.approveClubMembership + _playerId;
    else if (_mode === 'suspend') _clubMembersURL += global.ServerUrls.suspendClubMembership + _playerId;
    //
    let request = new RemoteRequest(_clubMembersURL, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: any = resp;
        //??
        return result;
      })
    );
  }

  public getHandicapSystemList() {
    let _params = {};
    //??

    let request = new RemoteRequest(global.ServerUrls.getHandicapSystemList, this.requestMethod.get, ContentType.XML);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        // Array<HandicapSystem>
        //   let player: PlayerData = resp;
        //??
        return data;
      })
    );
  }

  public getPlayerHandicapIndex(playerId: number, handicapSystem: string): Observable<any> {
    let params = {};
    let _hcpSys = handicapSystem;
    params['handicapSystem'] = _hcpSys;
    //??
    let request = new RemoteRequest(
      global.ServerUrls.getPlayerHcpIdx + '/' + playerId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: any = resp;
        //??
        return result;
      })
    );
  }

  public syncPlayerHandicapIndex(playerId: number, handicapSystem: string): Observable<any> {
    let params = {};
    let _hcpSys = handicapSystem;
    params['handicapSystem'] = _hcpSys;
    params['playerId'] = playerId;
    //??
    let request = new RemoteRequest(
      global.ServerUrls.syncHandicapIndex + '/' + playerId,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          //??
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getLatestCourseHandicap(playerId?: number, teeBox?: string, firstNineCourse?: number, secondNineCourse?: number): Observable<any> {
    let hdrs = {};
    if (isPresent(playerId)) hdrs['Player-Id'] = playerId;
    //??
    //??
    let params = {};
    params['playerId'] = playerId;
    params['teeBox'] = teeBox;
    params['firstNine'] = firstNineCourse;
    params['secondNine'] = secondNineCourse;
    let _paramUrl = playerId + '/' + teeBox;
    let request = new RemoteRequest(
      global.ServerUrls.getLatestCourseHandicap + _paramUrl,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let courseHandicap: any = resp;
        return courseHandicap;
      })
    );
  }

  public checkLeagueCompetition(compId?: number): Observable<any> {
    let hdrs = {};
    let params = {};
    let _url = global.ServerUrls.leagueEclectic;
    let _compId = '/' + compId;
    let request = new RemoteRequest(
      global.ServerUrls.getLeagueCompetition + _compId + _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let eclectic: any = resp;
        return eclectic;
      })
    );
  }

  public getLeagueScorecards(compId?: number): Observable<any> {
    let hdrs = {};
    let params = {};
    let _url = global.ServerUrls.leagueScorecards;
    let _compId = '/' + compId;
    let request = new RemoteRequest(
      global.ServerUrls.getLeagueCompetition + _compId + _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let scorecards: LeagueScorecards = resp;
        scorecards.playerRounds.forEach((p: EclecticPlayerRound) => {
          JsonService.deriveFulImageURL(p, 'photo');
        });
        return scorecards;
      })
    );
  }

  public getLeagueLeaderboard(compId?: number): Observable<any> {
    let hdrs = {};
    let params = {};
    let _url = global.ServerUrls.leagueLeaderboard;
    let _compId = '/' + compId;
    let request = new RemoteRequest(
      global.ServerUrls.getLeagueCompetition + _compId + _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let leagueLeaderboard: LeagueLeaderboard = resp;
        leagueLeaderboard.playerRounds.forEach((p: EclecticPlayerRound) => {
          JsonService.deriveFulImageURL(p, 'photo');
        });
        return leagueLeaderboard;
      })
    );
  }

  public getLeagueSeason(compId?: number): Observable<any> {
    let hdrs = {};
    let params = {};
    let _url = global.ServerUrls.getLeagueSeason;
    let _compId = '/' + compId;
    let request = new RemoteRequest(
      global.ServerUrls.getLeagueCompetition + _compId + _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let leagueSeason: any = resp;
        return leagueSeason;
      })
    );
  }

  public getLeagueRounds(seasonId?: number): Observable<any> {
    let hdrs = {};
    let params = {};
    let _url = global.ServerUrls.leagueRounds;
    let _seasonId = '/' + seasonId;
    let request = new RemoteRequest(
      global.ServerUrls.getLeague + _seasonId + _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let leagueRounds: any = resp;
        return leagueRounds;
      })
    );
  }

  public getLeagueLowestLeaderboard(seasonId?: number): Observable<any> {
    let hdrs = {};
    let params = {};
    let _url = global.ServerUrls.leagueLowestGrossLeaderboard;
    let _seasonId = '/' + seasonId;
    let request = new RemoteRequest(
      global.ServerUrls.getLeague + _seasonId + _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let leagueLowestLb: LowestAverageGrossLeaderboard = resp;
        leagueLowestLb.players.forEach((p: PlayerLowestAverageGross) => {
          JsonService.deriveFulImageURL(p, 'teeBoxImage');
          JsonService.deriveFulImageURL(p, 'imageUrl');
          JsonService.deriveFulImageURL(p, 'photo');
        });
        return leagueLowestLb;
      })
    );
  }
  public getClubBookingList(clubId: number, fromDate?: string, toDate?: string, maxResults?: number, status?: string, courseId?: number) {
    // pageSize?: number, pageNo?: number

    // 'assets/json_teeTimeBooking.json'
    let _params = {}; //"?clubId="+clubId+"&forDate=" +forDate + "&registeredOnly="+registeredOnly+"&includeCancelled="+includeCancelled;
    let _clubId = clubId ? '/' + clubId : '';
    if (fromDate) _params['fromDate'] = fromDate;
    if (toDate) _params['toDate'] = toDate;
    if (maxResults) _params['maxResults'] = maxResults;
    if (status) _params['status'] = status;
    if (courseId) _params['courseId'] = courseId;

    let request = new RemoteRequest(
      global.ServerUrls.getClubBookingList + _clubId + '/search',
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    // let request = new RemoteRequest(global.ServerUrls.getTeeTimeBookingList,
    //     this.requestMethod.get,ContentType.URL_ENCODED_FORM_DATA,{
    //         clubId: clubId,
    //         forDate: forDate,
    //         registeredOnly: registeredOnly
    //     });
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let clubBookingList: Array<TeeTimeBooking> = resp;
        clubBookingList.forEach((tb: TeeTimeBooking) => {
          tb.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
            JsonService.deriveFullUrl(p.player, 'profile');
            JsonService.deriveFullUrl(p.player, 'image');
            JsonService.deriveFullUrl(p.caddyAssigned, 'caddyImage');
            JsonService.deriveFullUrl(p.caddyPreferred, 'caddyImage');
          });
          //    if(tb.flight) tb.bookingStatus = 'PaymentFull'
        });
        //  //??
        return {
          resp,
          clubBookingList,
        };
      })
    );
  }

  public getClubCaddySchedule(clubId: number, forDate?: string) {
    // pageSize?: number, pageNo?: number

    // 'assets/json_teeTimeBooking.json'
    let _params = {}; //"?clubId="+clubId+"&forDate=" +forDate + "&registeredOnly="+registeredOnly+"&includeCancelled="+includeCancelled;
    let _clubId = clubId ? '/' + clubId : '';
    if (forDate) _params['forDate'] = forDate;

    let request = new RemoteRequest(
      global.ServerUrls.displayCaddySchedule + _clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let caddyScheduleList: Array<ClubCaddieSchedule> = resp;
        caddyScheduleList.forEach((csl: ClubCaddieSchedule) => {
          JsonService.deriveFullUrl(csl, 'caddieImage');
        });
        return caddyScheduleList;
      })
    );
  }

  public getCaddyUnavailability(caddieId: number, fromDate?: string, toDate?: string) {
    let _params = {}; //"?clubId="+clubId+"&forDate=" +forDate + "&registeredOnly="+registeredOnly+"&includeCancelled="+includeCancelled;
    let _caddieId = caddieId ? '/' + caddieId : '';
    if (fromDate) _params['fromDate'] = fromDate;
    if (toDate) _params['toDate'] = toDate;

    let request = new RemoteRequest(
      global.ServerUrls.listCaddyUnavailability + _caddieId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let caddyUnavailability: Unavailability = resp;
        return caddyUnavailability;
      })
    );
  }

  public addCaddyUnavailability(caddieId: number, fromDate: string, toDate: string, remarks?: string): Observable<any> {
    let params = {};
    let _caddieId = caddieId;
    params['fromDate'] = fromDate;
    params['toDate'] = toDate;
    let _remarks =
      'Set unavailability from ' + moment(fromDate).format('ddd, DD MMM YYYY') + ' to ' + moment(fromDate).format('ddd, DD MMM YYYY');
    params['remarks'] = remarks ? remarks : _remarks;
    let _paramUrl = '?' + 'fromDate=' + params['fromDate'] + '&toDate=' + params['toDate'];
    let request = new RemoteRequest(
      global.ServerUrls.addCaddyUnavailability + '/' + _caddieId + '/create' + _paramUrl,
      this.requestMethod.post,
      ContentType.JSON,
      params['remarks']
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: any = resp;
        //??
        return result;
      })
    );
  }

  public removeCaddyUnavailability(unavailabilityId: number): Observable<any> {
    let params = {};
    let _unavailabilityId = unavailabilityId;
    let request = new RemoteRequest(
      global.ServerUrls.addCaddyUnavailability + '/' + _unavailabilityId + '/delete',
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: any = resp;
        //??
        return result;
      })
    );
  }

  public getPlayerMaxBooking(clubId: number, playerId: number, teeOffDate?: string) {
    let _params = {};
    let _clubId = clubId ? '/' + clubId : '';
    let _playerId = playerId ? '/' + playerId : '';
    if (teeOffDate) _params['teeOffDate'] = teeOffDate;

    let request = new RemoteRequest(
      global.ServerUrls.getPlayerMaxBookingCount + _clubId + _playerId + '/booking-count',
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let bookingCount: BookingCount = resp;
        return bookingCount;
      })
    );
  }

  public getBuggyUnavailability(buggyId: number, fromDate?: string, toDate?: string) {
    let _params = {}; //"?clubId="+clubId+"&forDate=" +forDate + "&registeredOnly="+registeredOnly+"&includeCancelled="+includeCancelled;
    let _buggyId = buggyId ? '/' + buggyId : '';
    if (fromDate) _params['fromDate'] = fromDate;
    if (toDate) _params['toDate'] = toDate;

    let request = new RemoteRequest(
      global.ServerUrls.listBuggyUnavailability + _buggyId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let buggyUnavailability: Unavailability = resp;
        return buggyUnavailability;
      })
    );
  }

  public addBuggyUnavailability(buggyId: number, fromDate: string, toDate: string, remarks?: string): Observable<any> {
    let params = {};
    let _buggyId = buggyId;
    params['fromDate'] = fromDate;
    params['toDate'] = toDate;
    let _remarks =
      'Set unavailability from ' + moment(fromDate).format('ddd, DD MMM YYYY') + ' to ' + moment(fromDate).format('ddd, DD MMM YYYY');
    params['remarks'] = remarks ? remarks : _remarks;
    let _paramUrl = '?' + 'fromDate=' + params['fromDate'] + '&toDate=' + params['toDate'];
    let request = new RemoteRequest(
      global.ServerUrls.addBuggyUnavailability + '/' + _buggyId + '/create' + _paramUrl,
      this.requestMethod.post,
      ContentType.JSON,
      params['remarks']
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: any = resp;
        //??
        return result;
      })
    );
  }

  public removeBuggyUnavailability(unavailabilityId: number): Observable<any> {
    let params = {};
    let _unavailabilityId = unavailabilityId;
    let request = new RemoteRequest(
      global.ServerUrls.addBuggyUnavailability + '/' + _unavailabilityId + '/delete',
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: any = resp;
        //??
        return result;
      })
    );
  }

  public getPaymentMethodList() {
    let request = new RemoteRequest(global.ServerUrls.getPaymentMethodList, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let paymentMethodList: Array<PaymentMethod> = resp;
        return paymentMethodList;
      })
    );
  }

  setBookingCancelGuard(bookingId: number, resetCancelGuard: boolean = false) {
    let _bookingId;
    let _cancelGuard = '';
    if (resetCancelGuard) _cancelGuard = '?cancelGuard=' + 'false';
    if (bookingId) _bookingId = '/' + bookingId;
    let _bookingUrl = global.teeTimeBookingBase + _bookingId + global.ServerUrls.setBookingCancelGuard + _cancelGuard;
    let request = new RemoteRequest(_bookingUrl, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: TeeTimeBooking = resp;
        //??
        return result;
      })
    );
    // /rest/tee-time/booking/{bookingId}/set-cancel-guard?cancelGuard=false
  }

  public searchBookingClub(
    clubId: number,
    params: any
    // fromDate?: string,
    // toDate?: string,
    // statusType?: string,
    // statusList?: Array<string>,
    // courseId?: number,
    // search?: string,
    // pageSize?: number,
    // pageNo?: number,
    // bookingMedium?: string,
    // shallow?: boolean,
    // confirmationStatus?: string
  ) {
    let _params = params;
    let _clubId = clubId ? '/' + clubId : '';
    // if (fromDate) _params['fromDate'] = fromDate;
    // if (toDate) _params['toDate'] = toDate;
    // if (statusType) _params['statusType'] = statusType;

    // if (statusList) _params['statusList'] = statusList; // statusList.join(",");
    // if (courseId) _params['courseId'] = courseId;
    // if (pageSize) _params['pageSize'] = pageSize;
    // if (pageNo) _params['pageNo'] = pageNo;
    // if (search) _params['search'] = search;
    if (_params['bookingMedium']) _params['bookingMedium'] = _params['bookingMedium'].toUpperCase();
    // if (shallow) _params['shallow'] = shallow;
    // if (confirmationStatus) _params['confirmationStatus'] = confirmationStatus;

    let request = new RemoteRequest(
      global.ServerUrls.searchBookingClub + _clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
      // {
      //   fromDate: _params['fromDate'],
      //   toDate: _params['toDate'],
      //   statusType: _params['statusType'],
      //   statusList: _params['statusList'],
      //   courseId: _params['courseId'],
      //   pageNo: _params['pageNo'],
      //   pageSize: _params['pageSize'],
      //   search: _params['search'],
      //   bookingMedium: _params['bookingMedium'],
      //   shallow: _params['shallow'],
      // }
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let clubBookingList: PagedData<TeeTimeBooking> = resp;
        clubBookingList.items.forEach((tb: TeeTimeBooking) => {
          JsonService.deriveFullUrl(tb.bookedByPlayer, 'profile');
          JsonService.deriveFullUrl(tb.bookedByPlayer, 'image');
          JsonService.deriveFullUrl(tb.bookingAgent, 'partnerImage');
          JsonService.deriveFullUrl(tb.bookedByUser?.profile, 'photo');
          JsonService.deriveFullUrl(tb.bookedByUser?.profile, 'profileImage');
          JsonService.deriveFullUrl(tb.clubData, 'clubImage');
          JsonService.deriveFullUrl(tb.clubData, 'clubLogo');
          JsonService.deriveFullUrl(tb.clubData, 'clubThumbnail');
          tb.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
            JsonService.deriveFullUrl(p.player, 'profile');
            JsonService.deriveFullUrl(p.player, 'image');
            JsonService.deriveFullUrl(p.caddyAssigned, 'caddyImage');
            JsonService.deriveFullUrl(p.caddyPreferred, 'caddyImage');
          });
        });
        return clubBookingList;
      })
    );
  }

  public removeCardClubApplication(clubId: number, playerDiscountId: number): Observable<any> {
    let _params = {};
    let _clubId = clubId;
    if (playerDiscountId) _params['playerDiscountId'] = playerDiscountId;
    let request = new RemoteRequest(
      global.ServerUrls.removeCardClubApplication + '/' + _clubId + '?playerDiscountId=' + _params['playerDiscountId'],
      // global.ServerUrls.removeCardClubApplication+"/"+_clubId,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return (
      this.http
        .execute(request)
        //  this.http.execute(request, global.ServerUrls.removeCardClubApplication+"/"+_clubId+"?playerDiscountId="+_params['playerDiscountId'])
        .pipe(
          map((resp: any) => {
            //??
            return resp;
          })
        )
    );
  }

  public getPartnerAttributes(initial: boolean = false) {
    let _params = {};
    let _randomizer = Math.floor(Math.random() * 7777) + 1;
    let _url;
    if (!initial) _url = global.MygolfServer + '/document/assets/partner-attributes.json' + '?v=' + _randomizer;
    else _url = 'http://app.mygolf2u.com/settings' + '/partner-attributes.json' + '?v=' + _randomizer;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public searchBookingPlayer(
    playerId: number,
    clubId?: number,
    fromDate?: string,
    toDate?: string,
    statusType?: string,
    statusList?: Array<string>,
    courseId?: number,
    search?: string,
    pageSize?: number,
    pageNo?: number,
    descendingByDate?: boolean
  ) {
    // pageSize?: number, pageNo?: number

    // 'assets/json_teeTimeBooking.json'
    let _params = {}; //"?clubId="+clubId+"&forDate=" +forDate + "&registeredOnly="+registeredOnly+"&includeCancelled="+includeCancelled;
    let _playerId = playerId ? '/' + playerId : '';
    if (clubId) _params['clubId'] = clubId;
    if (fromDate) _params['fromDate'] = fromDate;
    if (toDate) _params['toDate'] = toDate;
    if (statusType) _params['statusType'] = statusType;
    /**
             * A - Active, I - Inactive, B - Both, C - Custom For custom specify comma separated list of status in statusList
                Default value : B
             */
    if (statusList) _params['statusList'] = statusList; // statusList.join(",");
    if (courseId) _params['courseId'] = courseId;
    if (pageSize) _params['pageSize'] = pageSize;
    if (pageNo) _params['pageNo'] = pageNo;
    if (search) _params['search'] = search;
    if (descendingByDate) _params['descendingByDate'] = descendingByDate;

    //??

    let request = new RemoteRequest(
      global.ServerUrls.searchBookingPlayer + _playerId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        clubId: _params['clubId'],
        fromDate: _params['fromDate'],
        toDate: _params['toDate'],
        statusType: _params['statusType'],
        statusList: _params['statusList'],
        courseId: _params['courseId'],
        pageNo: _params['pageNo'],
        pageSize: _params['pageSize'],
        search: _params['search'],
        descendingByDate: _params['descendingByDate'],
      }
    );
    // let request = new RemoteRequest(global.ServerUrls.getTeeTimeBookingList,
    //     this.requestMethod.get,ContentType.URL_ENCODED_FORM_DATA,{
    //         clubId: clubId,
    //         forDate: forDate,
    //         registeredOnly: registeredOnly
    //     });
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        let playerBookingList: PagedData<TeeTimeBooking> = resp;
        playerBookingList.items.forEach((tb: TeeTimeBooking) => {
          tb.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
            JsonService.deriveFullUrl(p.player, 'profile');
            JsonService.deriveFullUrl(p.player, 'image');
            JsonService.deriveFullUrl(p.caddyAssigned, 'caddyImage');
            JsonService.deriveFullUrl(p.caddyPreferred, 'caddyImage');
          });
          //    if(tb.flight) tb.bookingStatus = 'PaymentFull'
        });
        //  //??
        //    return {resp , clubBookingList};
        return playerBookingList;
      })
    );
  }

  public refundRedeemForPlayer(clubId: number, playerId: number, startDate: string, endDate?: string, include: string = 'both') {
    let _params = {};
    let _clubId = clubId;
    // let _randomizer = Math.floor(Math.random() * 7777) + 1
    // let _url = 'http://'+global.MygolfServerHost+'/document/assets/app-attributes.json'+"?v="+_randomizer
    if (playerId) _params['playerId'] = playerId;
    if (startDate) _params['startDate'] = startDate;
    if (endDate) _params['endDate'] = endDate;
    if (include) _params['include'] = include;
    let request = new RemoteRequest(
      global.ServerUrls.refundRedeemForPlayer + '/' + _clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        return data;
      })
    );
  }

  public refundRedeemForClub(clubId: number, startDate: string, endDate?: string, include: string = 'both') {
    let _params = {};
    let _clubId = clubId;
    // let _randomizer = Math.floor(Math.random() * 7777) + 1
    // let _url = 'http://'+global.MygolfServerHost+'/document/assets/app-attributes.json'+"?v="+_randomizer
    if (startDate) _params['startDate'] = startDate;
    if (endDate) _params['endDate'] = endDate;
    if (include) _params['include'] = include;
    let request = new RemoteRequest(
      global.ServerUrls.refundRedeemForClub + '/' + _clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        return data;
      })
    );
  }

  undoRefundBooking(bookingId: number, refundInstanceId: number) {
    let _bookingId;
    let _refundInstanceId;
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (refundInstanceId) _params['refundInstanceId'] = refundInstanceId;
    let _bookingUrl = global.ServerUrls.undoRefundBooking;
    let request = new RemoteRequest(_bookingUrl, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: TeeTimeBooking = resp;
        //??
        return result;
      })
    );
  }

  undoCancelBooking(bookingId: number) {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    let _bookingUrl = global.ServerUrls.undoCancelBooking;
    let request = new RemoteRequest(_bookingUrl, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: TeeTimeBooking = resp;
        //??
        return result;
      })
    );
  }

  updateNinesBooking(bookingId: number, ninesPlayed: number) {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (ninesPlayed) _params['ninesPlayed'] = ninesPlayed;
    let _bookingUrl = global.ServerUrls.updateNinesBooking;
    let request = new RemoteRequest(_bookingUrl, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: TeeTimeBooking = resp;
        //??
        return result;
      })
    );
  }
  public deleteExportMappings(clubId: number, transactionTypeId: string): Observable<any> {
    let _params = {};
    let _clubId = clubId;
    let _transactionTypeId = transactionTypeId;

    let reClubId = /:clubId/gi;
    let reTrxnTypeId = /:transactionTypeId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.updateDeleteExportMappings;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reTrxnTypeId, transactionTypeId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      //  this.http.execute(request, global.ServerUrls.removeCardClubApplication+"/"+_clubId+"?playerDiscountId="+_params['playerDiscountId'])
      map((resp: any) => {
        //??console.log("delete player discount card: ", resp)
        return resp;
      })
    );
  }
  public deletePaymentMappings(clubId: number, mappingId: string): Observable<any> {
    let _params = {};
    // let _mappingId = mappingId;

    let reClubId = /:clubId/gi;
    let reMappingId = /:mappingId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.deletePaymentMappings;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reMappingId, mappingId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      //  this.http.execute(request, global.ServerUrls.removeCardClubApplication+"/"+_clubId+"?playerDiscountId="+_params['playerDiscountId'])
      map((resp: any) => {
        //??console.log("delete player discount card: ", resp)
        return resp;
      })
    );
  }

  public deleteRefundMappings(clubId: number, mappingId: string): Observable<any> {
    let _params = {};
    // let _mappingId = mappingId;

    let reClubId = /:clubId/gi;
    let reMappingId = /:mappingId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.deleteRefundMappings;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reMappingId, mappingId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      //  this.http.execute(request, global.ServerUrls.removeCardClubApplication+"/"+_clubId+"?playerDiscountId="+_params['playerDiscountId'])
      map((resp: any) => {
        //??console.log("delete player discount card: ", resp)
        return resp;
      })
    );
  }

  public deletePricingMappings(clubId: number, pricingComp: string): Observable<any> {
    let _params = {};
    // let _mappingId = mappingId;

    let reClubId = /:clubId/gi;
    let rePricingComp = /:pricingComp/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.deletePricingMappings;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePricingComp, pricingComp);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      //  this.http.execute(request, global.ServerUrls.removeCardClubApplication+"/"+_clubId+"?playerDiscountId="+_params['playerDiscountId'])
      map((resp: any) => {
        //??console.log("delete player discount card: ", resp)
        return resp;
      })
    );
  }

  public deleteTrxn(clubId: number, trxnTypeId: string): Observable<any> {
    let _params = {};
    // let _mappingId = mappingId;

    let reClubId = /:clubId/gi;
    let retrxnTypeId = /:transactionTypeId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.deleteTrxn;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(retrxnTypeId, trxnTypeId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      //  this.http.execute(request, global.ServerUrls.removeCardClubApplication+"/"+_clubId+"?playerDiscountId="+_params['playerDiscountId'])
      map((resp: any) => {
        //??console.log("delete player discount card: ", resp)
        return resp;
      })
    );
  }
  deleteClubComponent(clubId: number, componentId: string) {
    let _params = {};
    // let _mappingId = mappingId;

    let reClubId = /:clubId/gi;
    let reComponentId = /:componentId/gi;
    let _url = global.ServerUrls.productsPricing.deleteClubComponent;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reComponentId, componentId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      //  this.http.execute(request, global.ServerUrls.removeCardClubApplication+"/"+_clubId+"?playerDiscountId="+_params['playerDiscountId'])
      map((resp: any) => {
        //??console.log("delete player discount card: ", resp)
        return resp;
      })
    );
  }
  deleteTaxProfiles(clubId: number, profileId: string) {
    let _params = {};
    // let _mappingId = mappingId;

    let reClubId = /:clubId/gi;
    let reProfileId = /:profileId/gi;
    let _url = global.ServerUrls.taxProfiles.delete;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reProfileId, profileId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      //  this.http.execute(request, global.ServerUrls.removeCardClubApplication+"/"+_clubId+"?playerDiscountId="+_params['playerDiscountId'])
      map((resp: any) => {
        //??console.log("delete player discount card: ", resp)
        return resp;
      })
    );
  }
  deleteClubCustomer(clubId: number, customerCode: string) {
    // let _mappingId = mappingId;

    let reClubId = /:clubId/gi;
    let reCustomerCode = /:customerCode/gi;

    let _url = global.ServerUrls.clubOrder.deleteClubCustomer;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reCustomerCode, customerCode);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      //  this.http.execute(request, global.ServerUrls.removeCardClubApplication+"/"+_clubId+"?playerDiscountId="+_params['playerDiscountId'])
      map((resp: any) => {
        //??console.log("delete player discount card: ", resp)
        return resp;
      })
    );
  }

  public getBookingReportList() {
    let _url = global.ServerUrls.getBookingReportList;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        console.debug('tee time slot page  : ', resp);
        return resp;
      })
    );
  }

  listClubTrxnTypes(clubId: number, params?: any) {
    let reClubId = /:clubId/gi;
    let _params = params;
    let _url = global.ServerUrls.finance.clubTrxnTypes.getList;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: Array<TransactionType> = resp;
        console.debug('api - refund mapping : ', resp);
        return data;
      })
    );
  }

  listClubCustomers(clubId: number, search?: any) {
    let reClubId = /:clubId/gi;
    let _search = search;

    let _url = global.ServerUrls.clubOrder.listClubCustomers;

    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _search);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        console.debug('api - refund mapping : ', resp);
        return data;
      })
    );
  }

  listTaxProfiles(params: any) {
    let reClubId = /:clubId/gi;
    let _params = params;
    let _clubId = params['clubId'];

    let _url = global.ServerUrls.taxProfiles.getList;
    _url = _url.replace(reClubId, _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        console.debug('api - refund mapping : ', resp);
        return data;
      })
    );
  }

  listClubComponents(clubId: number, params: any) {
    let reClubId = /:clubId/gi;
    let _params = params;

    let _url = global.ServerUrls.productsPricing.listClubComponents;

    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        console.debug('api - list club components : ', resp, _params);
        return data;
      })
    );
  }

  listExportMappings(clubId: number) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.listExportMappings;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: Array<any> = resp;
        console.debug('api - export mapping : ', resp);
        return data;
      })
    );
  }

  listPaymentMappings(clubId: number) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.listPaymentMappings;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: Array<PaymentTrxnType> = resp;
        console.debug('api - payment mapping : ', resp);
        return data;
      })
    );
  }
  listPricingMappings(clubId: number) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.listPricingMappings;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: Array<TrxnTypePriceComponentMap> = resp;
        console.debug('api - pricing mapping : ', resp);
        return data;
      })
    );
  }
  listRefundMappings(clubId: number) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.listRefundMappings;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: Array<RefundTrxnType> = resp;
        console.debug('api - refund mapping : ', resp);
        return data;
      })
    );
  }

  addUpdateClubTrxnType(clubId: number, params: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.addType;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  addUpdateExportMappings(clubId: number, params: any) {
    let _params = params;
    let _trxnTypeId = params['transactionTypeId'];
    let reClubId = /:clubId/gi;
    let reTrxnTypeId = /:transactionTypeId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.updateExportMappings;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reTrxnTypeId, _trxnTypeId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  addUpdatePaymentMappings(clubId: number, params: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.updatePaymentMappings;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  addUpdatePricingMappings(clubId: number, params: any) {
    let _params = params;
    let _pricingComp = params['pricingComp'];
    let reClubId = /:clubId/gi;
    let rePricingComp = /:pricingComp/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.updatePricingMappings;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePricingComp, _pricingComp);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  addUpdateRefundMappings(clubId: number, params: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.updateRefundMappings;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  addUpdateClubComponents(clubId: number, params: any) {
    let _clubId = clubId;
    let reClubId = /:clubId/gi;
    let _params = params;
    let _url = global.ServerUrls.productsPricing.addUpdateClubComponents;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }
  addUpdateTaxProfiles(clubId: number, params: any) {
    let _clubId = clubId;
    let reClubId = /:clubId/gi;
    let _params = params;
    let _url = global.ServerUrls.taxProfiles.addUpdate;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  addClubCustomer(clubId: number, params: any) {
    let _params = params;
    let _url;
    _url = global.ServerUrls.clubOrder.addClubCustomer;
    let reClubId = /:clubId/gi;

    _url = _url.replace(reClubId, clubId);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  updateClubCustomer(clubId: number, params: any) {
    let _params = params;
    let _url;
    _url = global.ServerUrls.clubOrder.updateClubCustomer;
    let reClubId = /:clubId/gi;

    _url = _url.replace(reClubId, clubId);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  // public getAppAttributes() {
  //   let _params = {}; //"?clubId="+clubId+"&forDate=" +forDate + "&registeredOnly="+registeredOnly+"&includeCancelled="+includeCancelled;

  //   // let _url = "assets/app-attributes.json";
  //   let _randomizer = Math.floor(Math.random() * 7777) + 1;
  //   let _url =
  //     'http://' +
  //     global.MygolfServerHost +
  //     '/document/assets/app-attributes.json' +
  //     '?v=' +
  //     _randomizer;
  //   let request = new RemoteRequest(
  //     _url,
  //     this.requestMethod.get,
  //     ContentType.URL_ENCODED_FORM_DATA
  //   );
  //   return this.http.execute(request).pipe(
  //     map((resp: any) => {
  //       //    let data: any = resp;
  //       let data: any = resp;
  //       return data;
  //     })
  //   );
  // }

  public getAppAttributes(initial: boolean = false) {
    let _params = {}; //"?clubId="+clubId+"&forDate=" +forDate + "&registeredOnly="+registeredOnly+"&includeCancelled="+includeCancelled;

    // let _url = "assets/app-attributes.json";
    let _randomizer = Math.floor(Math.random() * 7777) + 1;
    let _url;
    if (!initial) _url = global.MygolfServer + '/document/assets/app-attributes.json' + '?v=' + _randomizer;
    else _url = 'http://app.mygolf2u.com/settings' + '/app-attributes.json' + '?v=' + _randomizer;
    // let _url = global.MygolfServer+'/document/assets/app-attributes.json'+"?v="+_randomizer
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //    let data: any = resp;
        let data: any = resp;
        return data;
      })
    );
  }

  public getAppRoleAccess() {
    let _params = {}; //"?clubId="+clubId+"&forDate=" +forDate + "&registeredOnly="+registeredOnly+"&includeCancelled="+includeCancelled;

    let _randomizer = Math.floor(Math.random() * 7777) + 1;
    let _url = 'assets/app-role-access.json' + '?v=' + _randomizer;
    // let _url = global.MygolfServer+'/document/assets/app-role-access.json'+"?v="+_randomizer
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        return data;
      })
    );
  }

  public getPartnerDetails(partnerId: string) {
    let _partnerId = partnerId;
    // if (search) _params['search'] = search;
    // if (pageSize) _params['pageSize'] = pageSize;
    // if (pageNo) _params['pageNo'] = pageNo;

    let _url = global.ServerUrls.partnerDiscountCompany.getDetails;
    let rePartnerId = /:partnerId/gi;
    _url = _url.replace(rePartnerId, _partnerId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let partner: DiscountCompany = resp;
        JsonService.deriveFulImageURL(partner, 'partnerImage');
        return partner;
      })
    );
  }

  listTrxnTypes(params?: any) {
    let reClubId = /:clubId/gi;
    let _params = params;
    let _url = global.ServerUrls.finance.listTrxnTypes;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: Array<TransactionType> = resp;
        console.debug('api - refund mapping : ', resp);
        return data;
      })
    );
  }

  listTrxnGroups(params?: any) {
    let reClubId = /:clubId/gi;
    let _params = params;
    let _url = global.ServerUrls.finance.listTrxnGroups;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: Array<TransactionGroup> = resp;
        console.debug('api - refund mapping : ', resp);
        return data;
      })
    );
  }
  public getPricingComponents(clubId: number, params?: any): Observable<Array<TeeTimePriceComponent>> {
    let _params;
    let _clubId;
    if (params) _params = params;
    if (params && params['clubId']) _clubId = params['clubId'];

    let reClub = /:clubId/gi;

    let _url = global.ServerUrls.teeTime.getPricingComponents;
    _url = _url.replace(reClub, _clubId);
    console.debug('get pricing component : ', _params);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let pricingComponents: Array<TeeTimePriceComponent> = resp;
        return pricingComponents;
      })
    );
  }

  getExtInterfaces(params?: any) {
    let _params = params;
    let _url = global.ServerUrls.external.system.getInterfaces;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: Array<any> = resp;
        console.debug('api - refund mapping : ', resp);
        return data;
      })
    );
  }

  getExtClubAcctSystem(clubId: number, systemId: string) {
    let reClubId = /:clubId/gi;
    let reSystemId = /:systemId/gi;

    let _url = global.ServerUrls.external.system.getAccounts;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reSystemId, systemId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: Array<any> = resp;
        console.debug('api - refund mapping : ', resp);
        return data;
      })
    );
  }

  getExtSystems(systemType?: any) {
    let _params = {
      systemType: systemType,
    };
    let _url = global.ServerUrls.external.system.getList;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: Array<any> = resp;
        console.debug('api - refund mapping : ', resp);
        return data;
      })
    );
  }
  getExportInstancesList(params?: any) {
    let _params = params;

    let _url = global.ServerUrls.finance.exports.listInstances;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        console.debug('api - refund mapping : ', resp);
        return data;
      })
    );
  }

  getFinanceClubTransactions(params?: any) {
    let _params = params;

    let _url = global.ServerUrls.finance.listTransactions;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        console.debug('api - refund mapping : ', resp);
        return data;
      })
    );
  }

  getExportInstanceDetails(instanceId: number) {
    let reInstanceId = /:instanceId/gi;

    let _url = global.ServerUrls.finance.exports.getInstanceDetails;
    _url = _url.replace(reInstanceId, instanceId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        console.debug('api - refund mapping : ', resp);
        return data;
      })
    );
  }

  getExportClubTransactions(instanceId: number, params?: any) {
    let reInstanceId = /:instanceId/gi;
    let _params = params;

    let _url = global.ServerUrls.finance.exports.getInstanceTrxnsList;

    _url = _url.replace(reInstanceId, instanceId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        console.debug('api - refund mapping : ', resp);
        return data;
      })
    );
  }
  generateClubTransactions(clubId: number, params?: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.generateTransactions;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }
  syncTransactions(clubId: number) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.syncTransactions;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public updateProgramApplication(partnerId: string, programId: number, params): Observable<any> {
    let _params = params;
    let rePartnerId = /:partnerId/gi;
    let reProgramId = /:programId/gi;
    let _url = global.ServerUrls.partnerDiscountCompany.updateApplication;
    _url = _url.replace(rePartnerId, partnerId);
    _url = _url.replace(reProgramId, programId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.JSON, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  updatePlayerInsurance(playerId: number, insuranceId: number, params: any): Observable<any> {
    let _playerId = playerId;
    let _insuranceId = insuranceId;
    let _params = params;

    // "bookingRequestedAt":  moment().format("YYYY-MM-DD")

    //??console.log("book tee time slot ", captchaResponse)
    let _url = global.ServerUrls.playerInsurance.updateDeleteInsurance;
    let rePlayer = /:playerId/gi;
    let reInsurance = /:insuranceId/gi;
    _url = _url.replace(rePlayer, _playerId);
    _url = _url.replace(reInsurance, _insuranceId);

    if (0 && this.platform.is('capacitor')) {
      return from(this.ftService.uploadFile(_params['insuranceDocument'], _url, ContentType.WILDCARD_IMAGE, _params));
    } else {
      let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
      return this.http.execute(request).pipe(map((resp: any) => resp));
    }
  }

  addPlayerInsurance(playerId: number, params: any): Observable<any> {
    let _playerId = playerId;
    let _params = params;

    // "bookingRequestedAt":  moment().format("YYYY-MM-DD")

    //??console.log("book tee time slot ", captchaResponse)
    let _url = global.ServerUrls.playerInsurance.addInsurance;
    let rePlayer = /:playerId/gi;
    _url = _url.replace(rePlayer, _playerId);

    console.debug('[service] adding player insurance ', playerId, _params, params, _url);

    if (this.platform.is('capacitor')) {
      return from(this.ftService.uploadFile(_params['insuranceDocument'], _url, ContentType.WILDCARD_IMAGE, _params));
    } else {
      let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
      return this.http.execute(request).pipe(map((resp: any) => resp));
    }
  }

  public updatePlayerInsuranceDocument(
    imageURL: string,
    contentType: string,
    playerId: number,
    insuranceId: number,
    authToken?: string,
    params?: any,
    file?: any
  ): Observable<any> {
    let _url = global.ServerUrls.playerInsurance.updateDeleteInsurance;
    let rePlayer = /:playerId/gi;
    let reInsurance = /:insuranceId/gi;
    _url = _url.replace(rePlayer, playerId);
    _url = _url.replace(reInsurance, insuranceId);
    if (!this.platform.is('capacitor')) {
      // const _formData: FormData = new FormData();
      // _formData = params;
      // _formData = Object.assign(_formData,params);
      // _formData.append('insuranceDocument', file);

      let options = {
        // "playerId": (playerId)? playerId:this.session.playerId
        insuranceDocument: file,
        authToken: authToken,
      };

      options = Object.assign(options, params);
      // let _headers = new HttpHeaders({
      //         'Content-Type':'multipart/form-data',
      //         // 'X-AUTH-TOKEN': authToken
      //     });
      let _hdrs = {
        'Content-Type': 'multipart/form-data',
      };

      let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.MULTIPART_FORM, options);
      return this.http.execute(request).pipe(map((resp: any) => resp));
    } else {
      let options = {
        // "playerId": (playerId)? playerId:this.session.playerId
        insuranceDocument: imageURL,
        file: imageURL,
        authToken: authToken,
      };

      options = Object.assign(options, params);
      return from(this.ftService.uploadFile(imageURL, _url, contentType, options, 'insurance'));
    }
  }

  public addPlayerInsuranceDocument(
    imageURL: string,
    contentType: string,
    playerId: number,
    authToken?: string,
    params?: any,
    file?: any
  ): Observable<any> {
    // UploadResult
    // public updatePlayerPhoto(imageUrl: string, mimeType: string, playerId?: number): Observable<UploadResult>{
    let _pDiscountProgId;
    let _url = global.ServerUrls.playerInsurance.addInsurance;
    let rePlayer = /:playerId/gi;
    _url = _url.replace(rePlayer, playerId);

    if (!this.platform.is('capacitor')) {
      const _formData: FormData = new FormData();
      _formData.append('insuranceDocument', file);

      // let _headers = new HttpHeaders({
      //         'Content-Type':'multipart/form-data',
      //         // 'X-AUTH-TOKEN': authToken
      //     });
      let _hdrs = {
        'Content-Type': 'multipart/form-data',
      };

      let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.MULTIPART_FORM, _formData);
      return this.http.execute(request).pipe(map((resp: any) => resp));
    } else {
      let options = {
        // "playerId": (playerId)? playerId:this.session.playerId
        insuranceDocument: imageURL,
        file: imageURL,
        authToken: authToken,
      };

      options = Object.assign(options, params);
      return from(this.ftService.uploadFile(imageURL, _url, contentType, options, 'insurance'));
    }
  }

  public getClubApplicablePlayerTypes(clubId?: number) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    // if (playerId) _params['playerId'] = playerId;
    // if (effectiveDate) _params['effectiveDate'] = effectiveDate;
    let request = new RemoteRequest(
      global.ServerUrls.getClubApplicablePlayerTypes,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let player: any = resp;
        //??console.log("get applicable club player types : ", resp)
        return player;
      })
    );
  }

  public suspendClubmembership(clubId: number, membershipId: number, params?: any): Observable<any> {
    let _clubId;
    let _membershipId;
    let _params;

    if (params) _params = params;
    if (clubId) _clubId = clubId;
    if (membershipId) _membershipId = membershipId;

    let reClub = /:clubId/gi;
    let reMembership = /:membershipId/gi;
    console.debug('service suspend club membership : ', _params, params);
    let _url = global.ServerUrls.clubMemberships.suspendMulti;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(reMembership, _membershipId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.HTML, _params);

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        return data;
      })
    );
  }

  public getPlayerMaxChargeableAmount(params: any) {
    let _params = {};
    _params = params;

    let reClubId = /:clubId/gi;
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.playerAccounts.getMaxChargeableClub;
    _url = _url.replace(reClubId, _params['clubId']);
    _url = _url.replace(rePlayerId, _params['playerId']);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        console.debug('api - player club account transactions : ', data);
        return data;
      })
    );
  }

  public getPlayerClubAccount(params: any) {
    let _statementId;
    let _params = {};
    _params = params;

    let reClubId = /:clubId/gi;
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.playerAccounts.getClubAccount;
    _url = _url.replace(reClubId, _params['clubId']);
    _url = _url.replace(rePlayerId, _params['playerId']);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let playerClubAccount: PlayerClubAccount = resp;
        console.debug('api - player club account transactions : ', playerClubAccount);
        return playerClubAccount;
      })
    );
  }

  public createPlayerClubAccount(params: any) {
    let _statementId;
    let _params = {};
    _params = params;

    let reClubId = /:clubId/gi;
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.playerAccounts.getClubAccount;
    _url = _url.replace(reClubId, _params['clubId']);
    _url = _url.replace(rePlayerId, _params['playerId']);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let playerClubAccount: PlayerClubAccount = resp;
        console.debug('api - player club account transactions : ', playerClubAccount);
        return playerClubAccount;
      })
    );
  }

  public updateCreditLimit(clubId: number, playerId: number, params: any): Observable<any> {
    let _params = {};

    if (params) _params = params;
    let reClubId = /:clubId/gi;
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.playerAccounts.updateCreditLimit;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePlayerId, playerId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  public playerPaymentToClub(clubId: number, playerId: number, params: any): Observable<any> {
    let _params = params;
    let _clubId = clubId;
    let _playerId = playerId;
    let reClubId = /:clubId/gi;
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.playerAccounts.paymentToClub;
    _url = _url.replace(reClubId, _clubId);
    _url = _url.replace(rePlayerId, _playerId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  userProfileUpdateAddress(
    userId: number,
    userAddressData: UserAddress,
    addressName: string,
    addressData: AddressData,
    setDefault?: boolean
  ) {
    let _addressName = '';
    let _userId;
    let _setDefault = setDefault;
    let _params = {};
    if (addressName) _addressName = addressName;
    if (userId) _userId = userId;
    if (addressData) _params = addressData;
    let _params2 = {
      setDefault: _setDefault,
      addressName: _addressName,
    };
    _params = {
      ..._params,
      ..._params2,
    };
    // _params = {
    //     addressName: userAddressData.name,
    //     setDefault: setDefault,
    //     address: userAddressData.address
    // };
    // if(_setDefault) _params['setDefault'] = _setDefault;
    // if(_addressName) _params['addressName'] = _addressName;
    let _updateAddressURL = global.ServerUrls.profileUsers + '/' + _userId + global.ServerUrls.userProfiles.saveAddress;
    let request = new RemoteRequest(_updateAddressURL, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: any = resp;
        console.debug('Updating service save address - ', _params, ' : ', result);
        return result;
      })
    );
  }

  public createProgramApplication(partnerId: string, programId: number, playerId: number): Observable<any> {
    let _params = {
      playerId: playerId,
    };
    let rePartnerId = /:partnerId/gi;
    let reProgramId = /:programId/gi;
    let _url = global.ServerUrls.partnerDiscountCompany.createApplication;
    _url = _url.replace(rePartnerId, partnerId);
    _url = _url.replace(reProgramId, programId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  public getUserDetailsById(userId: number): Observable<UserAuthentication> {
    let _userId;
    let _params;
    if (userId) _userId = userId;

    let reUser = /:userId/gi;

    let _url = global.userProfile + global.ServerUrls.userProfiles.getUserDetails;
    _url = _url.replace(reUser, _userId);
    console.debug('get user details : ', _url, _userId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let userDetails: UserAuthentication = resp;
        return userDetails;
      })
    );
  }

  getPromoCode(context: string, couponCode: string) {
    // let reClubId= /:clubId/gi;
    let _params = {
      context: context,
      couponCode: couponCode,
    };
    let _url = global.ServerUrls.promo.getActiveCoupons;
    // _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        console.debug('api - booing by reference : ', resp);
        return data;
      })
    );
  }
  getPromoIsActive(context: string) {
    // let reClubId= /:clubId/gi;
    let _params = {
      context: context,
    };
    let _url = global.ServerUrls.promo.isAnyActive;
    // _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        console.debug('api - booing by reference : ', resp);
        return data;
      })
    );
  }
  userProfileDeleteAddress(userId: number, addressName: string) {
    let _addressName;
    let _userId = userId;
    let _params = {};
    if (addressName) _addressName = addressName;
    _params = {
      addressName: _addressName,
    };
    // _params = {
    //     addressName: userAddressData.name,
    //     setDefault: setDefault,
    //     address: userAddressData.address
    // };
    // if(_setDefault) _params['setDefault'] = _setDefault;
    // if(_addressName) _params['addressName'] = _addressName;
    let _updateAddressURL = global.ServerUrls.profileUsers + '/' + _userId + global.ServerUrls.userProfiles.deleteAddress;
    // _updateAddressURL += "?addressName=" + _addressName;
    let request = new RemoteRequest(_updateAddressURL, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: any = resp;
        console.debug('Updating service save address - ', _params, ' : ', result);
        return result;
      })
    );
  }
  getClubOrdersList(clubId: number, params: any) {
    let reClubId = /:clubId/gi;
    let _params = params;
    let _clubId = clubId;

    let _url = global.ServerUrls.clubOrder.getOrdersList;
    _url = _url.replace(reClubId, _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        if (data.items && data.items.length > 0) {
          data.items.forEach((order: any) => {
            JsonService.deriveFulImageURL(order.club, 'clubLogo');
            JsonService.deriveFulImageURL(order.club, 'clubImage');
            JsonService.deriveFulImageURL(order.club, 'clubThumbnail');
            JsonService.deriveFulImageURL(order.clubLite, 'clubLogo');
            JsonService.deriveFulImageURL(order.clubLite, 'clubImage');
            JsonService.deriveFulImageURL(order.clubLite, 'clubThumbnail');
          });
        }
        return data;
      })
    );
  }

  public searchBookingAgent(
    partnerId: string,
    fromDate?: string,
    toDate?: string,
    statusType?: string,
    statusList?: Array<string>,
    clubId?: number,
    search?: string,
    pageSize?: number,
    pageNo?: number,
    bookingMedium?: string,
    slotFrom?: string,
    slotTo?: string,
    bookingStart?: string
  ) {
    // pageSize?: number, pageNo?: number

    // 'assets/json_teeTimeBooking.json'
    let _params = {}; //"?clubId="+clubId+"&forDate=" +forDate + "&registeredOnly="+registeredOnly+"&includeCancelled="+includeCancelled;
    let _partnerId = partnerId ? '/' + partnerId : '';
    if (fromDate) _params['fromDate'] = fromDate;
    if (toDate) _params['toDate'] = toDate;
    if (statusType) _params['statusType'] = statusType;
    /**
         * A - Active, I - Inactive, B - Both, C - Custom For custom specify comma separated list of status in statusList
            Default value : B
         */
    if (statusList) _params['statusList'] = statusList; // statusList.join(",");
    if (clubId) _params['clubId'] = clubId;
    if (pageSize) _params['pageSize'] = pageSize;
    if (pageNo) _params['pageNo'] = pageNo;
    if (search) _params['search'] = search;
    if (bookingMedium) _params['bookingMedium'] = bookingMedium.toUpperCase();
    if (slotFrom) _params['slotFrom'] = slotFrom;
    if (slotTo) _params['slotTo'] = slotTo;
    if (bookingStart) _params['bookingStart'] = bookingStart;

    let request = new RemoteRequest(
      global.ServerUrls.searchBookingAgent + _partnerId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    // {
    //     fromDate: _params['fromDate'],
    //     toDate: _params['toDate'],
    //     statusType: _params['statusType'],
    //     statusList: _params['statusList'],
    //     clubId: _params['clubId'],
    //     pageNo: _params['pageNo'],
    //     pageSize: _params['pageSize'],
    //     search: _params['search'],
    //     bookingMedium: _params['bookingMedium'],
    // }
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??console.log("club booking list : ", resp)
        let clubBookingList: PagedData<TeeTimeBooking> = resp;
        clubBookingList.items.forEach((tb: TeeTimeBooking) => {
          JsonService.deriveFullUrl(tb.bookedByPlayer, 'profile');
          JsonService.deriveFullUrl(tb.bookedByPlayer, 'image');
          JsonService.deriveFullUrl(tb.bookingAgent, 'partnerImage');
          JsonService.deriveFullUrl(tb.bookedByUser?.profile, 'photo');
          JsonService.deriveFullUrl(tb.bookedByUser?.profile, 'profileImage');
          JsonService.deriveFullUrl(tb.clubData, 'clubImage');
          JsonService.deriveFullUrl(tb.clubData, 'clubLogo');
          JsonService.deriveFullUrl(tb.clubData, 'clubThumbnail');
          tb.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
            JsonService.deriveFullUrl(p.player, 'profile');
            JsonService.deriveFullUrl(p.player, 'image');
            JsonService.deriveFullUrl(p.caddyAssigned, 'caddyImage');
            JsonService.deriveFullUrl(p.caddyPreferred, 'caddyImage');
          });
          //    if(tb.flight) tb.bookingStatus = 'PaymentFull'
        });
        //  //??console.log("club flight service first : ", flightList, resp, resp)
        //    return {resp , clubBookingList};
        return clubBookingList;
      })
    );
  }

  public getBookingBillPrint(bookingId: number, format?: string, bookingPlayerId?: number): Observable<any> {
    let _bookingId = bookingId;
    let _bookingPlayerId = bookingPlayerId;
    let _format = format;

    let reBooking = /:bookingId/gi;
    let _params = {};
    if (format) _params['format'] = _format;
    if (bookingPlayerId) _params['bookingPlayerId'] = _bookingPlayerId;

    let _url = global.ServerUrls.generateBookingBill;
    // downloadBookingBill
    _url = _url.replace(reBooking, _bookingId);
    console.debug('get wallet balance : ', _url);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    // {
    //     // "application/pdf"

    //     // responseType : 'blob'
    //     // responseType : 'arraybuffer'
    //     // responseType: 'text'

    // }
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        return data;
      })
    );
  }

  public getClubWalletBalance(clubId: number, params: any): Observable<PlayerClubWalletBalancePage> {
    let _clubId;
    let _params = {};
    if (clubId) _clubId = clubId;
    if (params) _params = params;

    let reClub = /:clubId/gi;

    let _url = global.ServerUrls.playerClubWallet.getClubWalletBalance;
    _url = _url.replace(reClub, _clubId);
    console.debug('get wallet balances : ', _params['search'], _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let walletBalances: PlayerClubWalletBalancePage = resp;
        walletBalances.items.forEach((item: PlayerClubWalletBalance) => {
          JsonService.deriveFullUrl(item.player, 'image');
          JsonService.deriveFullUrl(item.player, 'profile');
        });
        return walletBalances;
      })
    );
  }

  public getClubAccountsList(clubId: number, params?: any) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.playerAccounts.listInClub;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let clubPlayerAccountsPage: PlayerClubAccountPage = resp;
        console.debug('api - bill details : ', clubPlayerAccountsPage);
        return clubPlayerAccountsPage;
      })
    );
  }

  addClubOrder(clubId: number, params?: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.clubOrder.addNewOrder;

    _url = _url.replace(reClubId, clubId);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  // OLDaddClubOrder(clubId: number, items: Array < string > ) {
  //   let _params = {
  //     items: items
  //   }
  //   let reClubId = /:clubId/gi;
  //   let _url = global.ServerUrls.clubOrder.addNewOrder;

  //   _url = _url.replace(reClubId, clubId);

  //   let request = new RemoteRequest(_url,
  //     this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
  //   return this.http.execute(request).pipe(
  //     map((resp: any) => resp));
  // }

  public getFilteredClubMemberships(clubId: number, params?: any) {
    // ,activeOnly?: boolean, search?: string
    let _clubId;
    let _params = {};
    if (clubId) _clubId = clubId;
    // if(clubId) _params['clubId'] = clubId;
    let _status;
    if (params) _params = params;
    console.debug('new get club members list : ', params);

    let _clubMembersURL = global.ServerUrls.clubMemberships.listClubMemberships;

    let reClub = /:clubId/gi;
    _clubMembersURL = _clubMembersURL.replace(reClub, _clubId);

    let request = new RemoteRequest(_clubMembersURL, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: ClubMembershipPage = resp;
        data.items.forEach((c: ClubMembership) => {
          JsonService.deriveFulImageURL(c.player, 'profile');
          JsonService.deriveFulImageURL(c.player, 'image');
          c.player.playerId = c.player.id;
          JsonService.deriveFulImageURL(c, 'memberImage');
        });
        //   let player: PlayerData = resp;
        return data;
      })
    );
  }

  addOrderItems(clubId: number, orderId: number, params?: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let _url = global.ServerUrls.clubOrder.items.add;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public generateBookingReports(url: string, params: any, external?: boolean): Observable<any> {
    let _params = params;
    let _clubId = params['clubId'];
    let _partnerId = params['partnerId'];
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    // if(format) _params['format'] = _format;
    // if(bookingPlayerId) _params['bookingPlayerId'] = _bookingPlayerId;

    let _url = global.MygolfServer + url;
    _url = _url.replace(reClubId, _clubId);
    _url = _url.replace(rePartnerId, _partnerId);
    let requestMethod = this.requestMethod.get;
    let contentType = ContentType.URL_ENCODED_FORM_DATA;
    if (external) {
      requestMethod = this.requestMethod.post;
      contentType = ContentType.JSON;
    }
    let request = new RemoteRequest(_url, requestMethod, contentType, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          console.debug('generate booking report', resp, external);
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getSummaryDailyReport(clubId: number, params: any): Observable<any> {
    console.debug('in service printing ', params);
    let _params = params;
    let _clubId = clubId;
    let reClubId = /:clubId/gi;
    // if(format) _params['format'] = _format;
    // if(bookingPlayerId) _params['bookingPlayerId'] = _bookingPlayerId;

    let _url = global.ServerUrls.getSummaryDailyReport;
    _url = _url.replace(reClubId, _clubId);
    // downloadBookingBill
    // _url = _url.replace(reBooking, _bookingId);
    console.debug('get summary daily report : ', _url);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        return data;
      })
    );
  }

  public getPartnerList(params: any) {
    let _params = params;
    // if (search) _params['search'] = search;
    // if (pageSize) _params['pageSize'] = pageSize;
    // if (pageNo) _params['pageNo'] = pageNo;
    let request = new RemoteRequest(
      global.ServerUrls.partnerDiscountCompany.list,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let discountCompanies: DiscountCompanyPage = resp;
          if (discountCompanies && discountCompanies.totalItems > 0)
            discountCompanies.items.forEach((dc: DiscountCompany) => {
              JsonService.deriveFulImageURL(dc, 'partnerImage');
            });
          console.debug('get list discount companies : ', resp);
          return discountCompanies;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPricingPlansList(clubId: number, params?: any) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.teeTime.listPricingPlans;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let pricingPlans: Array<TeeTimePricingPlan> = resp;
        console.debug('api - bill details : ', pricingPlans);
        return pricingPlans;
      })
    );
  }

  public getFilteredTeeSlots(clubId: number, params?: any) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.teeTime.searchSlots;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let teeTimeSlotDisplayPage: TeeTimeSlotDisplayPage = resp;
        console.debug('tee time slot page  : ', teeTimeSlotDisplayPage);
        return teeTimeSlotDisplayPage;
      })
    );
  }

  public updateTeeSlots(clubId: number, search: any, update: any): Observable<any> {
    let _clubId = clubId;
    let _params = {};
    //     search: JSON.stringify(search),
    //     search.slotsIn: search.slotsIn,
    //     update: JSON.stringify(update)
    // }
    if (search.slotsIn) _params['search.slotsIn'] = search.slotsIn;
    if (search.teeOffTimeFrom) _params['search.teeOffTimeFrom'] = search.teeOffTimeFrom; //: "07:00:00",
    if (search.teeOffTimeTo) _params['search.teeOffTimeTo'] = search.teeOffTimeTo; //: "19:00:00",
    if (search.weekDays) _params['search.weekDays'] = search.weekDays; //: [null],
    if (search.specialDays) _params['search.specialDays'] = search.specialDays; //: [null],
    if (search.booked) _params['search.booked'] = search.booked; //: "",
    if (search.allowWalking) _params['search.allowWalking'] = search.allowWalking; //: "",
    if (search.availableForBooking) _params['search.availableForBooking'] = search.availableForBooking; //: "",
    if (search.allowNineHole) _params['search.allowNineHole'] = search.allowNineHole; //: "",
    if (search.allowEighteenHole) _params['search.allowEighteenHole'] = search.allowEighteenHole; //: "",
    if (search.membersOnly) _params['search.membersOnly'] = search.membersOnly; //: "",
    if (search.maxPlayers) _params['search.maxPlayers'] = search.maxPlayers; //: null,
    if (search.minPlayers) _params['search.minPlayers'] = search.minPlayers; //: null,
    if (search.maxPlayersPerBuggy) _params['search.maxPlayersPerBuggy'] = search.maxPlayersPerBuggy; //: null,
    if (search.maxPlayersPerCaddie) _params['search.maxPlayersPerCaddie'] = search.maxPlayersPerCaddie; //: null,
    if (search.regularPricingPlan) _params['search.regularPricingPlan'] = search.regularPricingPlan; //: null,
    if (search.promotionalPricingPlan) _params['search.promotionalPricingPlan'] = search.promotionalPricingPlan; //: null,
    if (search.jumboPricingPlan) _params['search.jumboPricingPlan'] = search.jumboPricingPlan; //: null,
    if (search.courses) _params['search.courses'] = search.courses; //: [null],
    if (search.fromDate) _params['search.fromDate'] = search.fromDate; //: moment().format("YYYY-MM-DD"),
    if (search.toDate) _params['search.toDate'] = search.toDate; //: moment().format("YYYY-MM-DD")

    if (update.allowWalking) _params['update.allowWalking'] = update.allowWalking; //: null,
    if (update.availableForBooking) _params['update.availableForBooking'] = update.availableForBooking; //: null,
    if (update.reasonForBlocking) _params['update.reasonForBlocking'] = update.reasonForBlocking; //: null,
    if (update.allowNineHole) _params['update.allowNineHole'] = update.allowNineHole; //: null,
    if (update.allowEighteenHole) _params['update.allowEighteenHole'] = update.allowEighteenHole; //: null,
    if (update.membersOnly) _params['update.membersOnly'] = update.membersOnly; //: null,
    if (update.maxPlayers) _params['update.maxPlayers'] = update.maxPlayers; //: null,
    if (update.minPlayers) _params['update.minPlayers'] = update.minPlayers; //: null,
    if (update.maxPlayersPerBuggy) _params['update.maxPlayersPerBuggy'] = update.maxPlayersPerBuggy; //: null,
    if (update.maxPlayersPerCaddie) _params['update.maxPlayersPerCaddie'] = update.maxPlayersPerCaddie; //: null,
    if (update.maxPlayersPerBuggyJumbo) _params['update.maxPlayersPerBuggyJumbo'] = update.maxPlayersPerBuggyJumbo; //: null,
    if (update.maxPlayersPerCaddieJumbo) _params['update.maxPlayersPerCaddieJumbo'] = update.maxPlayersPerCaddieJumbo; //: null,
    if (update.regularPricingPlan) _params['update.regularPricingPlan'] = update.regularPricingPlan; //: null,
    if (update.clearPromotion) _params['update.clearPromotion'] = update.clearPromotion; //: null,
    if (update.promotionalPricingPlan) _params['update.promotionalPricingPlan'] = update.promotionalPricingPlan; //: null,
    if (update.clearJumboPricingPlan) _params['update.clearJumboPricingPlan'] = update.clearJumboPricingPlan; //: null,
    if (update.jumboPricingPlan) _params['update.jumboPricingPlan'] = update.jumboPricingPlan; //: null

    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.teeTime.searchAndUpdateSlots;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
    //    .catch(this.http.handleError);
  }

  public listBookingPlayerType(clubId?: number) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    // if(clubId) _params['clubId'] = clubId;
    // if(playerId) _params['playerId'] = playerId;
    // if(effectiveDate) _params['effectiveDate'] = effectiveDate;

    let request = new RemoteRequest(
      global.ServerUrls.listBookingPlayerType,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        //   let player: PlayerData = resp;
        //??console.log("get list club vouchers issued : ", resp)
        return data;
      })
    );
  }

  public getBuggyTypesList(clubId: number) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.getBuggyTypes;
    _url = _url.replace(reClubId, clubId);

    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let buggyTypesList: Array<BuggyType> = resp;
        console.debug('buggy type list  : ', buggyTypesList);
        return buggyTypesList;
      })
    );
  }

  getClubOrderDetails(clubId: number, orderId: number) {
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let _clubId = clubId;
    let _orderId = orderId;

    let _url = global.ServerUrls.clubOrder.getOrderDetails;
    _url = _url.replace(reClubId, _clubId);
    _url = _url.replace(reOrderId, _orderId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        console.debug('api - refund mapping : ', resp);
        return data;
      })
    );
  }

  updateClubOrderDetails(clubId: number, orderId: number, params: any) {
    let _url;
    _url = global.ServerUrls.clubOrder.updateOrderDetails;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }
  updateClubOrderStatus(clubId: number, orderId: number, status: string) {
    let _url;
    if (status === 'cancel') _url = global.ServerUrls.clubOrder.cancelOrder;
    else if (status === 'confirm') _url = global.ServerUrls.clubOrder.confirmOrder;
    else if (status === 'finalize') _url = global.ServerUrls.clubOrder.finalizeOrder;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);

    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.HTML);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  /**
   * @param playerId
   * Gets all the club membership details ordered by club names
   * @returns {Observable<R>}
   */
  public getPlayerMemberships(playerId: number): Observable<Array<ClubMembership>> {
    let _playerId;
    if (playerId) _playerId = playerId;
    let request = new RemoteRequest(global.ServerUrls.playerMemberships, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, null, {
      'Player-Id': _playerId,
    });
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let memberships: Array<ClubMembership> = resp;
        memberships.forEach((cm: ClubMembership) => {
          if (cm.club && cm.club.clubImage) JsonService.deriveFullUrl(cm.club, 'clubImage');
          JsonService.deriveFulImageURL(cm, 'memberImage');
        });
        return memberships;
      })
    );
  }

  updateSlotBuggyCaddieSettings(slotDayId: number, slotNo: number, params: any) {
    let _params = {};
    if (params) _params = params;
    if (slotDayId) _params['slotDayId'] = slotDayId;
    if (slotNo) _params['slotNo'] = slotNo;
    let _url = global.ServerUrls.teeTime.updateSlotBuggyCaddieSettings;
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: any = resp;
        console.debug('Slot Buggy Caddie Settings : ', result);

        return result;
      })
    );
  }

  updateSlotParameters(slotDayId: number, slotNo: number, params: any) {
    let _params = {};
    if (params) _params = params;
    if (slotDayId) _params['slotDayId'] = slotDayId;
    if (slotNo) _params['slotNo'] = slotNo;
    let _url = global.ServerUrls.teeTime.updateSlotParameters;
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: any = resp;
        console.debug('Slot Buggy Caddie Settings : ', result);

        return result;
      })
    );
  }

  deleteClubOrder(clubId: number, orderId: number) {
    let _params = {};
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let _url = global.ServerUrls.clubOrder.deleteOrder;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  doRefundOrder(clubId: number, orderId: number, params: any) {
    let _params = params;
    let _url;
    _url = global.ServerUrls.clubOrder.doRefundOrder;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  undoRefundOrder(clubId: number, orderId: number, refundId: number) {
    let _url;
    _url = global.ServerUrls.clubOrder.undoRefundOrder;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let reRefundId = /:refundId/gi;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    _url = _url.replace(reRefundId, refundId);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }
  deleteOrderItems(clubId: number, orderId: number, itemId: number) {
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let reItemId = /:itemId/gi;
    let _url = global.ServerUrls.clubOrder.items.delete;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    _url = _url.replace(reItemId, itemId);

    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }
  updateOrderItems(clubId: number, orderId: number, itemId, params?: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let reItemId = /:itemId/gi;
    let _url = global.ServerUrls.clubOrder.items.update;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    _url = _url.replace(reItemId, itemId);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  chargeToAccountOrder(clubId: number, orderId: number, params: any) {
    let _params = params;
    let _url;
    _url = global.ServerUrls.clubOrder.chargeToAccount;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public getAgentClubSettings(partnerId: string, clubId: number) {
    let _params = {};
    if (partnerId) _params['partnerId'] = partnerId;
    if (clubId) _params['clubId'] = clubId;

    let _url = global.ServerUrls.partnerDiscountCompany.getAgentClubSettings;
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePartnerId, partnerId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        // map((resp: any) => {
        map((resp: any) => {
          let clubSettings: BookingAgentClubSetting = resp;
          //??console.log("get list club vouchers issued : ", resp)
          return clubSettings;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  onAddOrderPayment(clubId: number, orderId: number, params: any) {
    let _params = params;
    let _url;
    _url = global.ServerUrls.clubOrder.addPayment;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  onUpdateOrderPayment(clubId: number, orderId: number, paymentId: number, params: any) {
    let _params = params;
    let _url;
    _url = global.ServerUrls.clubOrder.updatePayment;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let rePaymentId = /:paymentId/gi;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    _url = _url.replace(rePaymentId, paymentId);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  onDeleteOrderPayment(clubId: number, orderId: number, paymentId: number) {
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let rePaymentId = /:paymentId/gi;
    let _url = global.ServerUrls.clubOrder.deletePayment;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    _url = _url.replace(rePaymentId, paymentId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getPlayerInsurances(playerId: number, params?: any) {
    let _url = global?.ServerUrls?.playerInsurance?.listInsurances;

    let rePlayer = /:playerId/gi;
    _url = _url.replace(rePlayer, playerId);
    let _params = params;

    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: Array<PlayerInsurance> = resp;
        console.debug('player insurances 1 : ', data);
        data.forEach(d => {
          JsonService.deriveFulImageURL(d, 'insuranceDocument');
        });

        console.debug('player insurances 2 : ', data);
        return data;
      })
    );
  }

  deletePlayerInsurance(playerId: number, insuranceId: number, params?: any) {
    let _playerId = playerId;
    let _insuranceId = insuranceId;
    let _params = params;

    // "bookingRequestedAt":  moment().format("YYYY-MM-DD")

    //??console.log("book tee time slot ", captchaResponse)
    let _url = global.ServerUrls.playerInsurance.updateDeleteInsurance;
    let rePlayer = /:playerId/gi;
    let reInsurance = /:insuranceId/gi;
    _url = _url.replace(rePlayer, _playerId);
    _url = _url.replace(reInsurance, _insuranceId);

    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public updateBookingMedium(params: any): Observable<any> {
    let _params;
    if (params) _params = params;

    console.debug('update booking medium : ', _params, params);
    let _url = global.ServerUrls.updateBookingMedium;
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.HTML, _params);

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        return data;
      })
    );
  }

  public getDetailedItemizedBill(bookingId: number, format?: string): Observable<any> {
    let _bookingId = bookingId;
    let _format = format;

    let reBooking = /:bookingId/gi;
    let _params = {};
    if (format) _params['format'] = _format;

    let _url = global.ServerUrls.generateItemizedBill;
    // downloadBookingBill
    _url = _url.replace(reBooking, _bookingId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        return data;
      })
    );
  }
  getBookingByReference(clubId: number, bookingReference: string) {
    let reClubId = /:clubId/gi;
    let _params = {
      clubId: clubId,
      bookingReference: bookingReference,
    };
    let _url = global.ServerUrls.teeTime.getBookingByReference;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        return data;
      })
    );
  }

  createUpdatePrimaryMembership(clubId: number, playerId: number, params?: any) {
    let _params = {};
    let _clubId = clubId;
    let _playerId = playerId;
    if (params) _params = params;
    if (_playerId) _params['playerId'] = _playerId;
    console.debug('create/update club membership : ', _params);
    let re = /:clubId/gi;
    let _url = global.ServerUrls.clubMemberships.createUpdatePrimary;
    _url = _url.replace(re, _clubId);
    // _url += '?playerId=' + _playerId;
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let result: any = resp;
        console.debug('create update primary membership : ', result);
        return result;
      })
    );
  }

  public bookingChargeToClub(
    bookingId: number,
    playerId: number,
    amount: number,
    bypassWallet?: boolean,
    remarks?: string
  ): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (playerId) _params['playerId'] = playerId;
    if (amount) _params['amount'] = amount;
    if (bypassWallet) _params['bypassWallet'] = bypassWallet;
    if (remarks) _params['remarks'] = remarks;
    let request = new RemoteRequest(
      global.ServerUrls.playerAccounts.bookingChargeToClub,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  public registerNewPlayer(
    firstName: string,
    lastName: string,
    gender: string,
    email: string,
    phone: string,
    handicap: number,
    teeoff: string,
    countryId?: string,
    nationalityId?: string,
    clubId?: number
  ): Observable<PlayerInfo> {
    let request = new RemoteRequest(global.ServerUrls.registerPlayer, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, {
      firstName: firstName,
      lastName: lastName,
      gender: gender,
      email: email,
      teeoff: teeoff,
      phone: phone,
      handicap: handicap,
      country: countryId, // residing in
      nationality: nationalityId, //nationality
      addedByClub: clubId,
    });

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let player: PlayerInfo = resp;
        return player;
      })
    );
  }

  public deleteAdditionalItems(bookingId: number, itemIds: Array<number>): Observable<any> {
    let _bookingId;
    let _itemIds;
    if (bookingId) _bookingId = bookingId;
    if (itemIds) _itemIds = itemIds;
    let reBooking = /:bookingId/gi;
    console.debug('service delete  additional items  : ', _bookingId, _itemIds);
    let _url = global.ServerUrls.teeTime.deleteAdditionalItems;
    _url = _url.replace(reBooking, _bookingId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA, {
      itemIds: _itemIds,
    });
    return this.http.execute(request).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  public getSlotPrices(params: any): Observable<Array<TeeTimePrice>> {
    let _params;
    if (params) _params = params;
    let _url = global.ServerUrls.teeTime.getSlotPrices;
    console.debug('get slot prices : ', _params);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let slotPrices: Array<TeeTimePrice> = resp;
        return slotPrices;
      })
    );
  }

  public getBillDetails(billId: number) {
    let reBillId = /:billId/gi;
    let _url = global.ServerUrls.getBillDetails;
    _url = _url.replace(reBillId, billId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let billDetails: Bill = resp;
        console.debug('api - bill details : ', billDetails);
        return billDetails;
      })
    );
  }

  public updateClubPaymentMethod(billId: number, method: string) {
    let _billId;
    let _params = {};

    if (billId) _billId = billId;
    if (method) _params['paymentMethod'] = method;
    let reBillId = /:billId/gi;
    let _url = global.ServerUrls.updateClubPaymentMethod;
    _url = _url.replace(reBillId, _billId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        return data;
      })
    );
  }
  public getSearchAllSlots(
    forDate: string,
    fromTime?: string,
    toTime?: string,
    pageSize?: number,
    page?: number,
    partnerId?: string,
    clubId?: Array<string>,
    countryId?: string,
    search?: string,
    location?: string
  ) {
    // Player-Id
    let request = new RemoteRequest(global.ServerUrls.searchAllSlots, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      forDate: forDate,
      fromTime: fromTime,
      toTime: toTime,
      pageSize: pageSize,
      pageNo: page,
      partner: partnerId,
      clubs: clubId,
      country: countryId,
      search: search,
      location: location,
    });
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          // TeeTimeSlot
          let teeTimeSlot: any = resp;
          // Array < ClubTeeTimeSlots >
          if (teeTimeSlot && teeTimeSlot.totalItems > 0) {
            teeTimeSlot.items.forEach(c => {
              JsonService.deriveFullUrl(c.club, 'clubImage');
              JsonService.deriveFullUrl(c.club, 'clubThumbnail');
              JsonService.deriveFullUrl(c.club, 'clubLogo');
              c.slots.forEach(s => {
                JsonService.deriveFullUrl(s.slot.startCourse, 'courseImage');
              });
            });
          }

          //??console.log("service first - tee time slot : ", teeTimeSlot, resp, resp)
          return {
            teeTimeSlot: teeTimeSlot.items,
            resp: resp,
          };
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public searchBookingsByPartner(
    partnerId: string,
    programId?: string,
    startDate?: string,
    endDate?: string,
    statusType?: string,
    bookingStatuses?: Array<string>,
    clubId?: number,
    search?: string,
    pageSize?: number,
    pageNo?: number,
    bookingMedium?: string,
    slotFrom?: string,
    slotTo?: string,
    bookingStart?: string
  ) {
    // pageSize?: number, pageNo?: number

    // 'assets/json_teeTimeBooking.json'
    let _params = {}; //"?clubId="+clubId+"&forDate=" +forDate + "&registeredOnly="+registeredOnly+"&includeCancelled="+includeCancelled;
    // let _partnerId = partnerId ? ("/" + partnerId) : '';
    let rePartnerId = /:partnerId/gi;
    let reProgramId = /:programId/gi;
    if (startDate) _params['startDate'] = startDate;
    if (endDate) _params['endDate'] = endDate;
    if (slotFrom) _params['slotFrom'] = slotFrom;
    if (slotTo) _params['slotTo'] = slotTo;
    if (bookingStart) _params['bookingStart'] = bookingStart;

    if (statusType) _params['statusType'] = statusType;
    /**
         * A - Active, I - Inactive, B - Both, C - Custom For custom specify comma separated list of status in statusList
            Default value : B
         */
    if (bookingStatuses) _params['bookingStatuses'] = bookingStatuses; // statusList.join(",");
    if (clubId) _params['clubId'] = clubId;
    if (pageSize) _params['pageSize'] = pageSize;
    if (pageNo) _params['pageNo'] = pageNo;
    if (search) _params['search'] = search;
    if (bookingMedium) _params['bookingMedium'] = bookingMedium.toUpperCase();

    let _url = '';
    if (programId) {
      _url = global.ServerUrls.partnerDiscountCompany.getProgramBookings;
      _url = _url.replace(reProgramId, programId);
    } else _url = global.ServerUrls.partnerDiscountCompany.getPartnerBookings;

    _url = _url.replace(rePartnerId, partnerId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    // {
    //     fromDate: _params['fromDate'],
    //     toDate: _params['toDate'],
    //     statusType: _params['statusType'],
    //     statusList: _params['statusList'],
    //     clubId: _params['clubId'],
    //     pageNo: _params['pageNo'],
    //     pageSize: _params['pageSize'],
    //     search: _params['search'],
    //     bookingMedium: _params['bookingMedium'],
    // }
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          //??console.log("club booking list : ", resp)
          let clubBookingList: PagedData<TeeTimeBooking> = resp;
          clubBookingList.items.forEach((tb: TeeTimeBooking) => {
            JsonService.deriveFullUrl(tb.bookedByPlayer, 'profile');
            JsonService.deriveFullUrl(tb.bookedByPlayer, 'image');
            JsonService.deriveFullUrl(tb.bookingAgent, 'partnerImage');
            JsonService.deriveFullUrl(tb.bookedByUser?.profile, 'photo');
            JsonService.deriveFullUrl(tb.bookedByUser?.profile, 'profileImage');
            JsonService.deriveFullUrl(tb.clubData, 'clubImage');
            JsonService.deriveFullUrl(tb.clubData, 'clubLogo');
            JsonService.deriveFullUrl(tb.clubData, 'clubThumbnail');
            tb.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
              JsonService.deriveFullUrl(p.player, 'profile');
              JsonService.deriveFullUrl(p.player, 'image');
              JsonService.deriveFullUrl(p.caddyAssigned, 'caddyImage');
              JsonService.deriveFullUrl(p.caddyPreferred, 'caddyImage');
            });
            //    if(tb.flight) tb.bookingStatus = 'PaymentFull'
          });
          return clubBookingList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getClubLoggedInOutletsList(clubId: number, params?: any): Observable<Array<any>> {
    let _clubId;
    let _params = {};
    if (clubId) _clubId = clubId;
    if (params) _params = params;

    let reClub = /:clubId/gi;

    let _url = global.ServerUrls.outlet.getLoggedInOutletList;
    _url = _url.replace(reClub, _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let clubOutletList: Array<ClubOutlet> = resp;
        return clubOutletList;
      })
    );
  }
  public getPlayerClubTransactions(params: any) {
    let _url = global.ServerUrls.playerAccounts.listTransations;

    // console.debug("club memberships : ", re, _url, global.ServerUrls.clubMemberships.listForPlayer, playerId )
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let playerClubAccountTransactionPage: PlayerClubAccountTransactionPage = resp;
        console.debug('api - player club account transactions : ', resp);
        //    memberships.forEach((cm: any) => {
        //        if (cm.club && cm.club.clubImage)
        //            JsonService.deriveFullUrl(cm.club, "clubImage");
        //    });
        return playerClubAccountTransactionPage;
      })
    );
  }
  public getClubOutletList(clubId: number, params?: any): Observable<Array<any>> {
    let _clubId;
    let _params = {};
    if (clubId) _clubId = clubId;
    if (params) _params = params;

    let reClub = /:clubId/gi;

    let _url = global.ServerUrls.outlet.getClubOutletList;
    _url = _url.replace(reClub, _clubId);
    console.debug('get club outlet list : ', _params, _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let _resp: ClubOutletPage = resp;
        let clubOutletList: Array<ClubOutlet> = [];

        _resp.items.forEach((pack: any, index: number) => {
          JsonService.deriveFullImageUrlArrayObject(pack.images);
        });

        if (_resp && _resp.totalItems > 0) clubOutletList = _resp.items;
        return clubOutletList;
      })
    );
  }
  public getClubWalletTransactions(clubId: number, params): Observable<PlayerClubWalletTransactionPage> {
    let _playerId;
    let _clubId;
    let _params;
    if (params) _params = params;
    if (clubId) _clubId = clubId;

    let reClub = /:clubId/gi;

    let _url = global.ServerUrls.playerClubWallet.getWalletTransactions;
    _url = _url.replace(reClub, _clubId);
    console.debug('get wallet balance : ', _url, _params, _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let playerWalletTransactionPage: PlayerClubWalletTransactionPage = resp;
        return playerWalletTransactionPage;
      })
    );
  }
  public getClubWalletTopUps(clubId: number, params): Observable<PlayerClubWalletTopupPage> {
    let _playerId;
    let _clubId;
    let _params;
    if (params) _params = params;
    if (clubId) _clubId = clubId;

    let reClub = /:clubId/gi;

    let _url = global.ServerUrls.playerClubWallet.getWalletTopups;
    _url = _url.replace(reClub, _clubId);
    console.debug('get wallet balance : ', _url, _params, _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let playerClubWalletTopup: PlayerClubWalletTopupPage = resp;
        return playerClubWalletTopup;
      })
    );
  }
  public getClubPaymentTransactions(params: any) {
    let _url = global.ServerUrls.playerAccounts.getClubPaymentTransactions;

    // console.debug("club memberships : ", re, _url, global.ServerUrls.clubMemberships.listForPlayer, playerId )
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let playerClubAccountTransactionPage: PlayerClubAccountTransactionPage = resp;
        console.debug('api - player club account transactions : ', resp);
        //    memberships.forEach((cm: any) => {
        //        if (cm.club && cm.club.clubImage)
        //            JsonService.deriveFullUrl(cm.club, "clubImage");
        //    });
        return playerClubAccountTransactionPage;
      })
    );
  }
  public importClubPayments(clubId: number, file: any): Observable<any> {
    // public updatePlayerPhoto(imageUrl: string, mimeType: string, playerId?: number): Observable<UploadResult>{
    let _clubId = clubId;

    const _formData: FormData = new FormData();
    _formData.append('file', file);

    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.playerAccounts.importClubPayments;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.MULTIPART_FORM, _formData);
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }
  public setRefundWalletBalance(params): Observable<any> {
    let _params = {};
    if (params) _params = params;

    let request = new RemoteRequest(
      global.ServerUrls.playerClubWallet.refundWalletBalance,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          console.debug('set refund wallet balance : ', resp);
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public revertWalletBalance(params): Observable<any> {
    let _params = {};
    if (params) _params = params;

    let request = new RemoteRequest(
      global.ServerUrls.playerClubWallet.revertWalletBalance,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          console.debug('set refund wallet balance : ', resp);
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public deleteClubPlayerTopup(clubId: number, playerId: number, topupId: number): Observable<any> {
    let _clubId = clubId;
    let _playerId;
    let _topupId;
    if (clubId) _clubId = clubId;
    if (playerId) _playerId = playerId;
    if (topupId) _topupId = topupId;

    let reClub = /:clubId/gi;
    let rePlayer = /:playerId/gi;
    let reTopup = /:topupId/gi;

    let _url = global.ServerUrls.playerClubWallet.deleteClubTopup;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(rePlayer, _playerId);
    _url = _url.replace(reTopup, _topupId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return (
      this.http
        .execute(request)
        //  this.http.execute(request, global.ServerUrls.removeCardClubApplication+"/"+_clubId+"?playerDiscountId="+_params['playerDiscountId'])
        .pipe(
          map((resp: any) => {
            return resp;
          })
        )
    );
  }
  public getClubPaymentImports(params: any) {
    let _url = global.ServerUrls.clubPayments.getImports;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let playerAccountPaymentImportPage: any = resp;
        console.debug('api - player club account transactions : ', resp);
        return playerAccountPaymentImportPage;
      })
    );
  }
  public getPlayerWalletBalance(clubId: number, playerId: number): Observable<PlayerClubWalletBalance> {
    let _playerId;
    let _clubId;
    if (playerId) _playerId = playerId;
    if (clubId) _clubId = clubId;

    let reClub = /:clubId/gi;
    let rePlayer = /:playerId/gi;

    let _url = global.ServerUrls.playerClubWallet.getWalletBalance;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(rePlayer, _playerId);
    console.debug('get wallet balance : ', _url, playerId, clubId, _playerId, _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let playerWallet: PlayerClubWalletBalance = resp;
        return playerWallet;
      })
    );
  }
  public getExpenditureTypes(clubId: number, search: string): Observable<Array<any>> {
    let _clubId;
    let _params = {};
    if (clubId) _clubId = clubId;
    if (search) _params['search'] = search;

    let reClub = /:clubId/gi;

    let _url = global.ServerUrls.playerClubWallet.getExpenditureTypes;
    _url = _url.replace(reClub, _clubId);
    console.debug('get expenditure types : ', _params['search'], _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let expenditureTypes: Array<any> = resp;
        return expenditureTypes;
      })
    );
  }
  public addClubPlayerTopup(clubId: number, playerId?: number, params?: any): Observable<any> {
    let _clubId;
    let _playerId;
    let _params;
    if (params) _params = params;
    if (clubId) _clubId = clubId;
    if (playerId) _playerId = playerId;

    let reClub = /:clubId/gi;
    let rePlayer = /:playerId/gi;
    console.debug('service add club player topup : ', _params, params);
    let _url = global.ServerUrls.playerClubWallet.addClubTopup;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(rePlayer, _playerId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerWalletTopup: any = resp;
          return playerWalletTopup;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public deductWalletBalance(clubId: number, playerId: number, params?: any): Observable<TeeTimeBooking> {
    let _clubId;
    let _playerId;
    let _params;
    if (params) _params = params;
    if (clubId) _clubId = clubId;
    if (playerId) _playerId = playerId;

    let reClub = /:clubId/gi;
    let rePlayer = /:playerId/gi;
    // console.debug("service add club player topup : ", _params, _bookingId)
    let _url = global.ServerUrls.playerClubWallet.deductWalletBalance;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(rePlayer, _playerId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let teeTimeBooking: TeeTimeBooking = resp;
          return teeTimeBooking;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public updateClubPlayerTopup(clubId: number, playerId: number, topupId: number, params?: any): Observable<any> {
    let _clubId;
    let _playerId;
    let _topupId;
    let _params;

    if (params) _params = params;
    if (clubId) _clubId = clubId;
    if (playerId) _playerId = playerId;
    if (topupId) _topupId = topupId;

    let reClub = /:clubId/gi;
    let rePlayer = /:playerId/gi;
    let reTopup = /:topupId/gi;
    console.debug('service add club player topup : ', _params, params);
    let _url = global.ServerUrls.playerClubWallet.updateTopupAttribute;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(rePlayer, _playerId);
    _url = _url.replace(reTopup, _topupId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.HTML, _params);

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerWalletTopup: any = resp;
          return playerWalletTopup;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public addUpdateAdditionalItems(bookingId: number, params?: any): Observable<TeeTimeBooking> {
    let _bookingId;
    let _params;
    if (params) _params = params;
    if (bookingId) _bookingId = bookingId;
    // if(params) {
    //     _params.forEach((item)=>{
    //         item['unitPrice'] = item['unitPriceUsed'];
    //     })
    // }

    let reBooking = /:bookingId/gi;
    console.debug('service add club player topup : ', _params, _bookingId);
    let _url = global.ServerUrls.teeTime.addUpdateAdditionalItems;
    _url = _url.replace(reBooking, _bookingId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.XML, _params);

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let teeTimeBooking: TeeTimeBooking = resp;
          return teeTimeBooking;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public uploadPlayerCardDiscountWeb(file: any, imageURL: string, playerDiscountProgramId: number): Observable<any> {
    let _pDiscountProgId;
    if (playerDiscountProgramId) _pDiscountProgId = '?id=' + playerDiscountProgramId;
    let options = {
      file: file,
    };
    const _formData: FormData = new FormData();
    _formData.append('file', file);
    let _hdrs = {
      'Content-Type': 'multipart/form-data',
    };
    let _url = global.ServerUrls.updatePlayerDiscountDocument + _pDiscountProgId;
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.MULTIPART_FORM, _formData);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }
  transferAndApplyPlayerVoucher(params: any) {
    let _params = {};
    if (params) _params = params;
    let _url = global.ServerUrls.transferAndApplyVoucher;
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          console.debug('Player Transfer/Apply Voucher [resp] - ', resp);
          console.debug('Player Transfer/Apply Voucher [params] - ', params);
          console.debug('Player Transfer/Apply Voucher [result] - ', result);
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  transferPlayerVoucher(params: any) {
    let _params = {};
    if (params) _params = params;
    let _url = global.ServerUrls.transferPlayerVoucher;
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          console.debug('Player Transfer Voucher [resp] - ', resp);
          console.debug('Player Transfer Voucher [params] - ', params);
          console.debug('Player Transfer Voucher [result] - ', result);
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public addPlayerTypeWeb(
    file: any,
    imageURL: string,
    contentType: string,
    playerId: number,
    bookingPlayerType: string,
    authToken?: string,
    formData?: any
  ): Observable<any> {
    let _playerId;
    let _playerType;
    if (playerId) _playerId = 'playerId=' + playerId;
    if (bookingPlayerType) _playerType = '&bookingPlayerType=' + bookingPlayerType;
    let options = {
      file: file,
      authToken: authToken,
    };

    const _formData: FormData = new FormData();
    _formData.append('file', file);
    let _hdrs = {
      'Content-Type': 'multipart/form-data',
      'X-AUTH-TOKEN': authToken,
      'Player-Id': _playerId,
    };

    let _url = global.ServerUrls.assignBookingPlayerType + '?' + _playerId + _playerType;
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.MULTIPART_FORM, _formData);
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  getClubGroupDetails(groupId: string): Observable<any> {
    let _groupId = groupId;
    let reGroupId = /:groupId/gi;

    let url = global.ServerUrls.clubGroups.getDetails;
    url = url.replace(reGroupId, _groupId);
    let request = new RemoteRequest(url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data = resp;
        JsonService.deriveFullUrl(data, 'logo');
        return data;
      })
    );
  }

  public getAgentClubSetup(params: any) {
    let _params = params;
    let _url = global.ServerUrls.bookingAgent.clubSettings;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data = resp;
        if (data && data.items && data.items.length > 0) {
          data.items.forEach(item => {
            JsonService.deriveFulImageURL(item.clubData, 'clubImage');
            JsonService.deriveFulImageURL(item.clubData, 'clubLogo');
            JsonService.deriveFulImageURL(item.clubData, 'cubThumbnail');
            JsonService.deriveFulImageURL(item.discountCompany, 'partnerImage');
          });
        }
        console.debug('api - agent club settings : ', data);
        return data;
      })
    );
  }

  public getPlayerVouchers(params: any) {
    //??console.log("get player id ", playerId);
    // let _caddyId = (caddyId)?"/"+caddyId:"";
    let _params = params;
    // if (playerId) _params['playerId'] = playerId;
    // if (activeAsOf) _params['activeAsOf'] = activeAsOf;
    let request = new RemoteRequest(
      global.ServerUrls.listPlayerVouchers,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          //??console.log("get voucher : ", resp)
          let voucherListPage: TeeTimeClubVoucherPage = resp;
          //  //??console.log("get FAQ2 : ", groupItems)
          return voucherListPage;
        })
      )
      .pipe(catchError(this.http.handleError));
    // return this.http.get('/assets/shipping.json');
  }
  public redeemPlayerVoucher(clubId: number, voucherId: number): Observable<any> {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (voucherId) _params['voucherId'] = voucherId;
    let request = new RemoteRequest(
      global.ServerUrls.redeemPlayerVoucher,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??console.log("apply for verifiy player discount card: ", resp)
        return resp;
      })
    );
  }

  public importBulkScorecard(file: any, frontNineCourse: number, backNineCourse: number): Observable<any> {
    const _formData: FormData = new FormData();
    _formData.append('scorecardFile', file);
    _formData.append('firstNineCourse', String(frontNineCourse));
    if (backNineCourse) _formData.append('secondNineCourse', String(backNineCourse));

    let _url = global.ServerUrls.importScorecard;
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.MULTIPART_FORM, _formData);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }
  public getClubListLite(clubId: number, params?: any): Observable<ClubDataLite> {
    let _params;
    _params = {
      activeOnly: true,
      pageSize: 1000,
    };
    let _url = global.ServerUrls.lite.clubListOpen;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubLitePage: ClubDataLitePage = resp;
          let _clubLite: ClubDataLite;

          if (clubLitePage && clubLitePage.totalItems > 0) {
            _clubLite = clubLitePage.items.find((club: ClubDataLite) => {
              return club.clubId == clubId;
            });
          }
          return _clubLite;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubInfoLite(clubId: number): Observable<ClubDataLite> {
    let _clubId = clubId;
    let reClub = /:clubId/gi;
    let _url = global.ServerUrls.lite.getClubInfo;
    _url = _url.replace(reClub, _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let _clubLite: ClubDataLite = resp;
          return _clubLite;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBuggyAvailabilityStat(clubId: number, forDate: string) {
    let _params = {};
    // _params['clubId'] = clubId;
    // _params['playerId'] = playerId;
    _params['forDate'] = forDate;

    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.getBuggyAvailabilityStats;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data = resp;
          console.log('club flight service buggy avl stats : ', resp);
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubAgentPricingPlanList(clubId: number, partnerId: string, params?: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    let _url = global.ServerUrls.bookingAgent.clubPricingPlans.getList;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePartnerId, partnerId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public addAgentPricingPlan(partnerId: string, clubId: number, params: any) {
    let _params = params;
    if (partnerId) _params['partnerId'] = partnerId;
    if (clubId) _params['clubId'] = clubId;

    let _url = global.ServerUrls.bookingAgent.clubPricingPlans.create;
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePartnerId, partnerId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubSettings: any = resp;
          //??console.log("get list club vouchers issued : ", resp)
          return clubSettings;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public deleteAgentPricingPlan(partnerId: string, clubId: number, agentPricingPlanId: number) {
    // let _params = params;
    // if (partnerId) _params['partnerId'] = partnerId;
    // if (clubId) _params['clubId'] = clubId;

    let _url = global.ServerUrls.bookingAgent.clubPricingPlans.delete;
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    let reAgentPricingPlanId = /:agentPricingPlanId/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePartnerId, partnerId);
    _url = _url.replace(reAgentPricingPlanId, agentPricingPlanId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.JSON);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubSettings: any = resp;
          //??console.log("get list club vouchers issued : ", resp)
          return clubSettings;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updateAgentPricingPlan(partnerId: string, clubId: number, params: any) {
    let _params = params;
    if (partnerId) _params['partnerId'] = partnerId;
    if (clubId) _params['clubId'] = clubId;

    let _url = global.ServerUrls.bookingAgent.clubPricingPlans.update;
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePartnerId, partnerId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubSettings: any = resp;
          //??console.log("get list club vouchers issued : ", resp)
          return clubSettings;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updateAgentPaymentRules(partnerId: string, clubId: number, params: any) {
    let _params = params;
    if (partnerId) _params['partnerId'] = partnerId;
    if (clubId) _params['clubId'] = clubId;

    let _url = global.ServerUrls.bookingAgent.updatePaymentRules;
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePartnerId, partnerId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.JSON, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubSettings: any = resp;
          //??console.log("get list club vouchers issued : ", resp)
          return clubSettings;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getAgentBookingCount(clubId: number, partnerId: string, teeOffDate?: string) {
    let _params = {};
    if (teeOffDate) _params['teeOffDate'] = teeOffDate;

    let _url = global.ServerUrls.bookingAgent.getBookingCount;
    let reClubId = /:clubId/gi;
    let rePartnerId = /:bookingAgent/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePartnerId, partnerId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          //??console.log("check max booking - service : ", resp)
          let bookingCount: BookingCount = resp;
          return bookingCount;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public createAgentClubSettings(partnerId: string, clubId: number, params: any) {
    let _params = params;
    if (partnerId) _params['partnerId'] = partnerId;
    if (clubId) _params['clubId'] = clubId;

    let _url = global.ServerUrls.bookingAgent.updateClubSetting;
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePartnerId, partnerId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubSettings: BookingAgentClubSetting = resp;
          //??console.log("get list club vouchers issued : ", resp)
          return clubSettings;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public deleteAgentClubSetting(partnerId: string, clubId: number) {
    // let _params = params;
    // if (partnerId) _params['partnerId'] = partnerId;
    // if (clubId) _params['clubId'] = clubId;

    let _url = global.ServerUrls.bookingAgent.updateClubSetting;
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePartnerId, partnerId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubSettings: BookingAgentClubSetting = resp;
          //??console.log("get list club vouchers issued : ", resp)
          return clubSettings;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updateAgentClubSettings(partnerId: string, clubId: number, params: any) {
    let _params = params;
    if (partnerId) _params['partnerId'] = partnerId;
    if (clubId) _params['clubId'] = clubId;

    let _url = global.ServerUrls.bookingAgent.updateClubSetting;
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePartnerId, partnerId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubSettings: BookingAgentClubSetting = resp;
          //??console.log("get list club vouchers issued : ", resp)
          return clubSettings;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getAgentClubTransactions(params: any) {
    let _params = params;
    let _url = global.ServerUrls.bookingAgent.transactions;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: BookingAgentTransactionPage = resp;
        console.debug('api - agent club transactions : ', data);
        if (data && data.items && data.items.length > 0) {
          data.items.forEach(item => {
            JsonService.deriveFulImageURL(item.clubData, 'clubImage');
            JsonService.deriveFulImageURL(item.clubData, 'clubLogo');
            JsonService.deriveFulImageURL(item.clubData, 'cubThumbnail');
            JsonService.deriveFulImageURL(item.discountCompany, 'partnerImage');
          });
        }
        return data;
      })
    );
  }

  setAgentOfflinePaymentTopup(clubId: number, partnerId: string, params: any) {
    let _params = params;
    _params['clubId'] = clubId;
    _params['partnerId'] = partnerId;
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    let _url;
    _url = global.ServerUrls.bookingAgent.offlinePaymentTopup;
    _url = _url.replace(reClubId, _params['clubId']);
    _url = _url.replace(rePartnerId, _params['partnerId']);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public deleteAgentOfflinePaymentTopup(clubId: number, partnerId: string, transactionId: number) {
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    let url = `${global.ServerUrls.bookingAgent.offlinePaymentTopup}?transactionId=${transactionId}`;
    url = url.replace(reClubId, String(clubId));
    url = url.replace(rePartnerId, partnerId);
    let params = {
      transactionId: transactionId,
    };
    let request = new RemoteRequest(url, this.requestMethod.delete, ContentType.JSON);
    return this.http.execute(request).pipe(map((resp: any) => resp));
    //    .catch(this.handleError);
  }

  clearUpdateBookingAgent(bookingId: number, bookingAgent?: string) {
    let _params = {};
    _params['bookingId'] = bookingId;
    _params['bookingAgent'] = bookingAgent;
    let _url;
    _url = global.ServerUrls.bookingAgent.clearUpdateBookingBy;

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public undoClubTransaction(clubId: number, playerId: number, transactionId: number): Observable<any> {
    // public updatePlayerPhoto(imageUrl: string, mimeType: string, playerId?: number): Observable<UploadResult>{
    let _clubId = clubId;
    let _playerId = playerId;
    let _transactionId = transactionId;

    let reClubId = /:clubId/gi;
    let rePlayerId = /:playerId/gi;
    let reTransactionId = /:transactionId/gi;
    let _url = global.ServerUrls.playerAccounts.undoTransaction;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePlayerId, playerId);
    _url = _url.replace(reTransactionId, transactionId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public generateAgentStatements(clubId: number, partnerId?: string, statementDate?: string) {
    let _params = {
      partnerId: partnerId,
      statementDate: statementDate,
    };

    let _url = global.ServerUrls.bookingAgent.statements.generate;
    let reClubId = /:clubId/gi;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          //??console.log("get list club vouchers issued : ", resp)
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public listAgentStatements(params: any) {
    let _params = params;
    let _url = global.ServerUrls.bookingAgent.statements.list;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: BookingAgentStatementPage = resp;
        console.debug('api - agent statements : ', data);
        if (data && data.items && data.items.length > 0) {
          data.items.forEach(item => {
            JsonService.deriveFulImageURL(item.club, 'clubImage');
            JsonService.deriveFulImageURL(item.club, 'clubLogo');
            JsonService.deriveFulImageURL(item.club, 'clubThumbnail');
            JsonService.deriveFulImageURL(item.bookingAgent, 'partnerImage');
          });
        }
        return data;
      })
    );
  }

  public approveAgentStatements(clubId: number, statementIds: Array<number>) {
    let _params = {
      statementIds: statementIds,
    };

    let _url = global.ServerUrls.bookingAgent.statements.approve;
    let reClubId = /:clubId/gi;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          //??console.log("get list club vouchers issued : ", resp)
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public cancelAgentStatements(clubId: number, statementId: number) {
    let _params = {
      statementId: statementId,
    };

    let _url = global.ServerUrls.bookingAgent.statements.cancel;
    let reClubId = /:clubId/gi;
    _url = _url.replace(reClubId, clubId);
    _url += '?statementId=' + statementId;
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          //??console.log("get list club vouchers issued : ", resp)
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public deleteAgentStatements(clubId: number, statementId: number) {
    let _params = {
      statementId: statementId,
    };

    let _url = global.ServerUrls.bookingAgent.statements.delete;
    let reClubId = /:clubId/gi;
    _url = _url.replace(reClubId, clubId);
    _url += '?statementId=' + statementId;
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          //??console.log("get list club vouchers issued : ", resp)
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getAgentStatementDetails(statementId: number) {
    let _url = global.ServerUrls.bookingAgent.statements.getDetails;
    let reStatementId = /:statementId/gi;
    _url = _url.replace(reStatementId, statementId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: BookingAgentStatement = resp;
        // BookingAgentStatementPage
        return data;
      })
    );
  }

  public downloadAgentStatement(statementId: number): Observable<any> {
    let reStatementId = /:statementId/gi;

    let _url = global.ServerUrls.bookingAgent.statements.downloadPrint;
    // downloadBookingBill
    _url = _url.replace(reStatementId, statementId);
    console.debug('get wallet balance : ', _url);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        return data;
      })
    );
  }

  public printAgentStatement(statementId: number): Observable<any> {
    let reStatementId = /:statementId/gi;

    let _url = global.ServerUrls.bookingAgent.statements.generatePrint;
    // downloadBookingBill
    _url = _url.replace(reStatementId, statementId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        console.debug('get statement print : ', resp);
        let data: any = resp;
        return data;
      })
    );
  }

  public searchFacilityBookings(params) {
    // let _cartId = this.orderService.getCartId();
    let _params = params;
    let _url = global.ServerUrls.outlet.bookings.search;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getMultiItemizedBill(
    clubId: number,
    bookingReferencs: Array<string>,
    invoiceOnly?: boolean,
    bookingPlayerId?: number,
    format?: string
  ): Observable<any> {
    let _clubId = clubId;
    let _references = bookingReferencs;
    let _format = format;
    let _invoiceOnly = invoiceOnly;
    let _bookingPlayerId = bookingPlayerId;

    let reClubId = /:clubId/gi;
    let _params = {};
    if (format) _params['format'] = _format;
    _params['bookingReferences'] = _references;
    _params['invoiceOnly'] = _invoiceOnly;
    _params['bookingPlayerId'] = _bookingPlayerId;

    let _url = global.ServerUrls.genMultiItemizedBill;
    // downloadBookingBill
    _url = _url.replace(reClubId, _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        return data;
      })
    );
  }

  public getClubData(clubId: number) {
    // let _cartId = this.orderService.getCartId();
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.getClubData;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getClubOutletType(clubId: number): Observable<Array<any>> {
    let _clubId;
    let _params = {};
    if (clubId) _clubId = clubId;

    let reClub = /:clubId/gi;

    let _url = global.ServerUrls.outlet.getClubOutletTypes;
    _url = _url.replace(reClub, _clubId);
    // console.debug("get club outlet list : ", _params , _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  // public getClubOutletType(clubId: number): Observable<Array<any>> {
  //   let _clubId;
  //   let _params = {};
  //   if (clubId) _clubId = clubId;

  //   let reClub = /:clubId/gi;

  //   let _url = global.ServerUrls.outlet.getClubOutletTypes;
  //   _url = _url.replace(reClub, _clubId);
  //   // console.debug("get club outlet list : ", _params , _clubId);
  //   let request = new RemoteRequest(
  //     _url,
  //     this.requestMethod.get,
  //     ContentType.URL_ENCODED_FORM_DATA
  //   );
  //   return this.http
  //     .execute(request)
  //     .pipe(
  //       map((resp: any) => {
  //         let _resp: any = resp;
  //         let clubOutletTypes: Array<any> = _resp;
  //         return clubOutletTypes;
  //       })
  //     )
  //     .pipe(catchError(this.http.handleError));
  // }

  public getOutletType(): Observable<Array<any>> {
    let _url = global.ServerUrls.outlet.getOutletTypes;
    // console.debug("get club outlet list : ", _params , _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let _resp: any = resp;
          let outletTypes: Array<any> = _resp;
          return outletTypes;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubPosSales(params: any): Observable<any> {
    let _url = global.ServerUrls.clubPOSandSales.listPosSales;
    // console.debug("get club outlet list : ", _params , _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let _resp: any = resp;
          let posSalesPage: ClubPosSalePage = _resp;
          return posSalesPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public listPOSImportInstances(params: any): Observable<any> {
    let _url = global.ServerUrls.clubPOSandSales.listImportInstances;
    // console.debug("get club outlet list : ", _params , _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let _resp: any = resp;
          let posSalesPage: ClubPosSalesImportPage = _resp;
          return posSalesPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPOSImportInstancesById(params: any): Observable<any> {
    let reClubId = /:clubId/gi;
    let _clubId = params?.clubId;
    let _url = global.ServerUrls.clubPOSandSales.getImportInstancesById;

    _url = _url.replace(reClubId, _clubId);
    // console.debug("get club outlet list : ", _params , _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let _resp: any = resp;
          let posSalesPage: ClubPosSale = _resp;
          return posSalesPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPOSImportInstanceDetails(params: any): Observable<any> {
    let reClubId = /:clubId/gi;
    let _clubId = params?.clubId;
    let _url = global.ServerUrls.clubPOSandSales.getImportInstanceDetails;

    _url = _url.replace(reClubId, _clubId);
    // console.debug("get club outlet list : ", _params , _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let _resp: any = resp;
          let posSalesImport: ClubPosSalesImport = _resp;
          return posSalesImport;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getTemplateImportPOS(clubId: number): Observable<any> {
    let _clubId = clubId;
    let reClubId = /:clubId/gi;

    let _url = global.ServerUrls.clubPOSandSales.downloadImportTemplate;
    // downloadBookingBill
    _url = _url.replace(reClubId, _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        console.debug('template response : ', resp, data);
        return data;
      })
    );
  }

  public importPosTrxn(clubId: number, file: any): Observable<any> {
    // public updatePlayerPhoto(imageUrl: string, mimeType: string, playerId?: number): Observable<UploadResult>{
    let _clubId = clubId;

    const _formData: FormData = new FormData();
    _formData.append('importFile', file);

    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.clubPOSandSales.uploadImportPOS;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.MULTIPART_FORM, _formData);
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  // list club groups

  getClubGroups(params: any): Observable<any> {
    let _params = params;

    let url = global.ServerUrls.clubGroups.list;
    let request = new RemoteRequest(url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          console.debug('get club groups : ', resp);
          let data: ClubGroupPage = resp;
          if (data.items && data.items.length > 0) {
            data.items.forEach((clubGroup: ClubGroup) => {
              JsonService.deriveFulImageURL(clubGroup, 'logo');
            });
          }
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  // get club group details

  // getClubGroupDetails(groupId: string): Observable < any > {
  //     let _groupId = groupId;
  //     let reGroupId = /:groupId/gi;

  //     let url = global.ServerUrls.clubGroups.getDetails;
  //     url = url.replace(reGroupId, _groupId);
  //     let request = new RemoteRequest(url,
  //        this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
  //     return this.http.execute(request)
  //         .map((resp: any) => {
  //             let data = resp;

  //             JsonService.deriveFulImageURL(data,'logo')
  //             return data;
  //         })
  //     //    .catch(this.http.handleError);
  // }
  // add/update club group
  public addUpdateClubGroups(params: any, image: any): Observable<any> {
    let _params = params;
    let url = global.ServerUrls.clubGroups.addUpdate;

    delete params['logo'];
    const _formData: FormData = new FormData();
    for (let p in params) {
      _formData.append(p, params[p]);
    }
    if (image) _formData.append('logo', image, image.name);

    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.MULTIPART_FORM, _formData);
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  deleteClubGroups(groupId: string): Observable<any> {
    let _groupId = groupId;
    let reGroupId = /:groupId/gi;

    let url = global.ServerUrls.clubGroups.delete;
    url = url.replace(reGroupId, _groupId);

    let request = new RemoteRequest(url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  // set / remove  clubs to group
  public setOrRemoveClubGroups(clubId: number, groupId?: number): Observable<any> {
    let _clubId = clubId;
    let _params = {
      groupId: groupId,
    };
    let reClubId = /:clubId/gi;
    let url = global.ServerUrls.clubGroups.setOrRemoveClub;
    url = url.replace(reClubId, _clubId);
    console.debug('updating pax : ', _clubId, url);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public associateClubGroupUser(groupId: string, userId: number): Observable<any> {
    let _groupId = groupId;
    let _userId = userId;
    let _params = {
      userId: _userId,
    };
    let reGroupId = /:groupId/gi;
    let reUserId = /:userId/gi;
    // let headers = {};
    // if (captchaResponse && captchaResponse.length > 0) headers['captcha-response'] = captchaResponse;
    // else headers = null;
    let url = global.ServerUrls.clubGroups.associateUsers;
    url = url.replace(reGroupId, _groupId);
    url = url.replace(reUserId, _userId);
    console.debug('updating pax : ', _groupId, url);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public deassociateClubGroupUser(groupId: string, userId: number): Observable<any> {
    let _groupId = groupId;
    let _userId = userId;
    let reGroupId = /:groupId/gi;
    let reUserId = /:userId/gi;
    // let headers = {};
    // if (captchaResponse && captchaResponse.length > 0) headers['captcha-response'] = captchaResponse;
    // else headers = null;
    let url = global.ServerUrls.clubGroups.deassociateUsers;
    url = url.replace(reGroupId, _groupId);
    url = url.replace(reUserId, _userId);
    console.debug('updating pax : ', _groupId, url);
    let request = new RemoteRequest(url, this.requestMethod.delete, ContentType.JSON);
    return this.http.execute(request).pipe(map((resp: any) => resp));
    //    .catch(this.http.handleError);
  }
  // list club group users

  // add club group user

  public addClubGroupUser(groupId: string, params: any): Observable<any> {
    let _groupId = groupId;
    let _params = params;
    let formData: FormData = new FormData();

    for (let key in _params) {
      formData.append(key, _params[key]);
    }
    // let headers = {};
    // if (captchaResponse && captchaResponse.length > 0) headers['captcha-response'] = captchaResponse;
    // else headers = null;
    let url = global.ServerUrls.clubGroups.createUser;
    console.debug('updating pax : ', _groupId, url);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.MULTIPART_FORM, formData);
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  getClubGroupUsers(groupId: string): Observable<any> {
    let _groupId = groupId;
    let reGroupId = /:groupId/gi;

    let url = global.ServerUrls.clubGroups.getUsers;
    url = url.replace(reGroupId, _groupId);
    let request = new RemoteRequest(url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  getUsersList(params?: any): Observable<any> {
    let _params = params;

    let url = global.ServerUrls.listUsers;
    let request = new RemoteRequest(url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
    //    .catch(this.handleError);
  }

  getUserRolesList(): Observable<any> {
    let url = global.ServerUrls.user.availableRoles;
    let request = new RemoteRequest(url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(map((resp: any) => resp));
    //    .catch(this.handleError);
  }
  public setUserRoles(userId: number, roleIds: Array<string>, defaultRole?: string): Observable<any> {
    let _params = {
      userId: userId,
      roleIds: roleIds,
      defaultRole: defaultRole,
    };
    let _url = global.ServerUrls.user.setRoles; // + '?' + _playerId + _playerType;

    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public getProductPackagesList(clubId: number, params?: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.clubOrder.productPackages.list;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        console.debug('api - agent club transactions : ', data);
        if (data && data.length > 0) {
          data.forEach(item => {
            JsonService.deriveFulImageURL(item.club, 'clubImage');
            JsonService.deriveFulImageURL(item.club, 'clubLogo');
            JsonService.deriveFulImageURL(item.club, 'cubThumbnail');
            JsonService.deriveFulImageURL(item, 'logo');
          });
        }
        return data;
      })
    );
  }

  public addProductPackages(clubId: number, params: any, image?: any) {
    let _params = params;
    _params['clubId'] = clubId;
    let reClubId = /:clubId/gi;

    delete params['logo'];
    const _formData: FormData = new FormData();
    for (let p in params) {
      _formData.append(p, params[p]);
    }
    if (image) {
      _formData.append('logo', image[0], image[0].name);
    }

    let _url;
    _url = global.ServerUrls.clubOrder.productPackages.add;
    _url = _url.replace(reClubId, _params['clubId']);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.MULTIPART_FORM, _formData);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public getProductPackageDetails(clubId: number, packageId: number) {
    let reClubId = /:clubId/gi;
    let rePackageId = /:packageId/gi;
    let _url = global.ServerUrls.clubOrder.productPackages.getDetail;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePackageId, packageId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        console.debug('api - agent club transactions : ', data);
        JsonService.deriveFulImageURL(data.club, 'clubImage');
        JsonService.deriveFulImageURL(data.club, 'clubLogo');
        JsonService.deriveFulImageURL(data.club, 'cubThumbnail');
        JsonService.deriveFulImageURL(data, 'logo');
        return data;
      })
    );
  }

  public updateProductPackageDetails(clubId: number, packageId: number, params: any, image?: any) {
    let _params = params;
    _params['clubId'] = clubId;
    _params['packageId'] = packageId;

    delete params['logo'];
    const _formData: FormData = new FormData();
    for (let p in params) {
      _formData.append(p, params[p]);
    }
    if (image) {
      _formData.append('logo', image[0], image[0].name);
    }
    let reClubId = /:clubId/gi;
    let rePackageId = /:packageId/gi;
    let _url;
    _url = global.ServerUrls.clubOrder.productPackages.update;
    _url = _url.replace(reClubId, _params['clubId']);
    _url = _url.replace(rePackageId, _params['packageId']);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.MULTIPART_FORM, _formData);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public deleteProductPackage(clubId: number, packageId: number) {
    let _clubId = clubId;
    let _packageId = packageId;
    let reClubId = /:clubId/gi;
    let rePackageId = /:packageId/gi;
    // let headers = {};
    // if (captchaResponse && captchaResponse.length > 0) headers['captcha-response'] = captchaResponse;
    // else headers = null;
    let url = global.ServerUrls.clubOrder.productPackages.delete;
    url = url.replace(reClubId, _clubId);
    url = url.replace(rePackageId, packageId);
    let request = new RemoteRequest(url, this.requestMethod.delete, ContentType.JSON);
    return this.http.execute(request).pipe(map((resp: any) => resp));
    //    .catch(this.handleError);
  }

  public addItemsToPackages(clubId: number, packageId: number, params: any) {
    let _params = params;
    _params['clubId'] = clubId;
    _params['packageId'] = packageId;

    // delete params['logo']
    // const _formData: FormData = new FormData();
    // for(let p in params) {
    //     _formData.append(p, params[p]);
    // }
    let reClubId = /:clubId/gi;
    let rePackageId = /:packageId/gi;
    let _url;
    _url = global.ServerUrls.clubOrder.productPackages.addItem;
    _url = _url.replace(reClubId, _params['clubId']);
    _url = _url.replace(rePackageId, _params['packageId']);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public removeItemsToPackages(clubId: number, packageId: number, params: any) {
    console.debug('removing items from package ', clubId, packageId, params);
    let _clubId = clubId;
    let _packageId = packageId;
    let reClubId = /:clubId/gi;
    let rePackageId = /:packageId/gi;
    // let headers = {};
    // if (captchaResponse && captchaResponse.length > 0) headers['captcha-response'] = captchaResponse;
    // else headers = null;
    let url = global.ServerUrls.clubOrder.productPackages.deleteItem;
    url = url.replace(reClubId, _clubId);
    url = url.replace(rePackageId, _packageId);
    if (params?.productId) url += '?productId=' + params?.productId;
    console.debug('removing items from package ', clubId, packageId, params, url);
    let request = new RemoteRequest(url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
    //    .catch(this.handleError);
  }

  public addPackageToOrder(clubId: number, orderId: number, packageId: number) {
    let _clubId = clubId;
    let _packageId = packageId;
    let _orderId = orderId;

    // delete params['logo']
    // const _formData: FormData = new FormData();
    // for(let p in params) {
    //     _formData.append(p, params[p]);
    // }
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let rePackageId = /:packageId/gi;
    let _url;
    _url = global.ServerUrls.clubOrder.productPackages.addToOrder;
    _url = _url.replace(reClubId, _clubId);
    _url = _url.replace(reOrderId, _orderId);
    _url = _url.replace(rePackageId, _packageId);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  listPOSMappings(clubId: number) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.listPOSMappings;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: Array<RefundTrxnType> = resp;
        console.debug('api - refund mapping : ', resp);
        return data;
      })
    );
  }

  addUpdatePOSMappings(clubId: number, params: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.updatePOSMappings;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public deletePOSMappings(clubId: number, mappingId: string): Observable<any> {
    let _params = {};
    // let _mappingId = mappingId;

    let reClubId = /:clubId/gi;
    let reMappingId = /:mappingId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.deletePOSMappings;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reMappingId, mappingId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      //  this.http.execute(request, global.ServerUrls.removeCardClubApplication+"/"+_clubId+"?playerDiscountId="+_params['playerDiscountId'])
      map((resp: any) => {
        //??console.log("delete player discount card: ", resp)
        return resp;
      })
    );
  }

  listPOSCodes(params) {
    let _url = global.ServerUrls.clubPOSandSales.listPOSCodes;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: ClubPosPage = resp;
        console.debug('api - pos codes : ', resp);
        return data;
      })
    );
  }

  addPOSCode(clubId: number, params: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.clubPOSandSales.createClubPOSCode;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  updatePOSCode(clubId: number, posId: number, params: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let rePosId = /:posId/gi;
    let _url = global.ServerUrls.clubPOSandSales.updateClubPOSCode;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePosId, posId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public deletePOSCode(clubId: number, posId: number): Observable<any> {
    let _params = {};
    // let _mappingId = mappingId;

    let reClubId = /:clubId/gi;
    let rePosId = /:posId/gi;
    let _url = global.ServerUrls.clubPOSandSales.deleteClubPOSCode;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePosId, posId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      //  this.http.execute(request, global.ServerUrls.removeCardClubApplication+"/"+_clubId+"?playerDiscountId="+_params['playerDiscountId'])
      map((resp: any) => {
        //??console.log("delete player discount card: ", resp)
        return resp;
      })
    );
  }

  public getAgentMultiItemizedBill(
    clubId: number,
    bookingAgent: string,
    startDate: string,
    endDate: string,
    invoiceOnly?: boolean,
    bookingPlayerId?: number,
    format?: string
  ): Observable<any> {
    let _clubId = clubId;
    let _agentId = bookingAgent;
    let _format = format;
    let _invoiceOnly = invoiceOnly;
    let _bookingPlayerId = bookingPlayerId;

    let reClubId = /:clubId/gi;
    let reAgentId = /:bookingAgent/gi;
    let _params = {};
    if (format) _params['format'] = _format;
    _params['startDate'] = startDate;
    _params['endDate'] = endDate;
    if (invoiceOnly) _params['invoiceOnly'] = _invoiceOnly;
    if (bookingPlayerId) _params['bookingPlayerId'] = _bookingPlayerId;

    let _url = global.ServerUrls.genAgentMultiItemizedBill;
    // downloadBookingBill
    _url = _url.replace(reClubId, _clubId);
    _url = _url.replace(reAgentId, _agentId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  chargeBookingToAgentAccount(bookingId: number, partnerId: string, params: any) {
    let _params = params;
    _params['bookingId'] = bookingId;
    _params['partnerId'] = partnerId;
    let _url;
    _url = global.ServerUrls.bookingAgent.chargeToAccount;

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public getAgentClubMaxChargeableAmount(params: any) {
    let _params = {};
    _params = params;

    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    let _url = global.ServerUrls.bookingAgent.maxChargeableAmount;
    _url = _url.replace(reClubId, _params['clubId']);
    _url = _url.replace(rePartnerId, _params['partnerId']);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        console.debug('api - agent club max chargeable amount : ', data);
        return data;
      })
    );
  }

  public getClubVoucherSeriesNew(clubId: number, params: any, itemsOnly: boolean = false) {
    let _clubId;
    if (clubId) _clubId = clubId;
    let reClubId = /:clubId/gi;
    let _params = params;
    let _url = global.ServerUrls.voucherSeries.listByClub;
    _url = _url.replace(reClubId, _clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let voucherListPage: VoucherSeriesPage = resp;
          // Array < TeeTimeClubVoucher >
          if (itemsOnly) return voucherListPage.items;
          else return voucherListPage;
        })
      )
      .pipe(catchError(this.http.handleError));
    // return this.http.get('/assets/shipping.json');
  }

  deleteFacility(facilityId: number) {
    let reFacilityId = /:outletId/gi;
    let _url = global.ServerUrls.outlet.remove;

    _url = _url.replace(reFacilityId, facilityId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  createClubOutlet(clubId: number, params: any): Observable<any> {
    let _clubId = clubId;
    let _params = params;
    let reClubId = /:clubId/gi;
    // let headers = {};
    // if (captchaResponse && captchaResponse.length > 0) headers['captcha-response'] = captchaResponse;
    // else headers = null;

    if (params['bookableFacility'] === 'true' || params['bookableFacility']) {
      if (params['minBookingDuration.duration']) _params['minBookingDuration.duration'] = params['minBookingDuration.duration'];
      if (params['minBookingDuration.durationUnit']) _params['minBookingDuration.durationUnit'] = params['minBookingDuration.durationUnit'];
    }
    delete _params['minBookingDuration'];
    // _params['minBookingDuration.durationUnit'] = 'HOUR'
    let url = global.ServerUrls.outlet.createClubOutlet;
    url = url.replace(reClubId, _clubId);
    console.debug('updating pax : ', _clubId, url, _params);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public addFacilityImages(
    file: Array<any>,
    imageURL: any,
    contentType: string,
    outletId: number,
    bookingPlayerType: string,
    authToken?: string,
    formData?: any
  ): Observable<any> {
    let options = {
      images: file,
      authToken: authToken,
    };

    let _outletId = outletId;
    let reOutletId = /:outletId/gi;

    const _formData: FormData = new FormData();
    if (file && file.length > 0)
      for (let x of file) {
        _formData.append('images', x, x.name);
      }

    let _hdrs = {
      'Content-Type': 'multipart/form-data',
      'X-AUTH-TOKEN': authToken,
    };

    let _url = global.ServerUrls.outlet.addImages;
    _url = _url.replace(reOutletId, _outletId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.MULTIPART_FORM, _formData);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getOutletDetails(outletId: number) {
    let reOutletId = /:outletId/gi;
    let _url = global.ServerUrls.outlet.getDetails;
    _url = _url.replace(reOutletId, outletId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubOutlet: ClubOutlet = resp;
          return clubOutlet;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  updateOutlet(outletId: number, params: any): Observable<any> {
    let _outletId = outletId;
    let _params = params;
    let reOutletId = /:outletId/gi;
    // let headers = {};
    // if (captchaResponse && captchaResponse.length > 0) headers['captcha-response'] = captchaResponse;
    // else headers = null;

    if (params['bookableFacility'] === 'true' || params['bookableFacility']) {
      if (params['minBookingDuration.duration']) _params['minBookingDuration.duration'] = params['minBookingDuration.duration'];
      if (params['minBookingDuration.durationUnit']) _params['minBookingDuration.durationUnit'] = params['minBookingDuration.durationUnit'];
    }
    delete _params['minBookingDuration'];
    // _params['minBookingDuration.durationUnit'] = 'HOUR'
    let url = global.ServerUrls.outlet.update;
    url = url.replace(reOutletId, _outletId);
    console.debug('updating outlet : ', _outletId, url, _params);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  updateFacilityBookingRules(outletId: number, params: any): Observable<any> {
    let _outletId = outletId;
    let _params = params;
    let reOutletId = /:outletId/gi;
    // _params['minBookingDuration.durationUnit'] = 'HOUR'
    let url = global.ServerUrls.outlet.updateBookingRules;
    url = url.replace(reOutletId, _outletId);
    console.debug('updating pax : ', _outletId, url, _params);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.JSON, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  addFacilityLocation(outletId: number, params: any): Observable<any> {
    let _outletId = outletId;
    let _params = params;
    let reOutletId = /:outletId/gi;
    delete _params['minBookingDuration'];
    _params['minBookingDuration.duration'] = params['minBookingDuration.duration'];
    _params['minBookingDuration.durationUnit'] = params['minBookingDuration.durationUnit'];

    console.debug('add facility location : ', params, _params);
    let url = global.ServerUrls.outlet.locations.add;
    url = url.replace(reOutletId, _outletId);
    console.debug('updating pax : ', _outletId, url, _params);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  updateFacilityLocation(outletId: number, locationId: number, params: any): Observable<any> {
    let _outletId = outletId;
    let _locationId = locationId;
    let _params = params;
    let reOutletId = /:outletId/gi;
    let reLocationId = /:locationId/gi;
    delete _params['minBookingDuration'];
    _params['minBookingDuration.duration'] = params['minBookingDuration.duration'];
    _params['minBookingDuration.durationUnit'] = params['minBookingDuration.durationUnit'];

    console.debug('add facility location : ', params, _params);
    let url = global.ServerUrls.outlet.locations.update;
    url = url.replace(reOutletId, _outletId);
    url = url.replace(reLocationId, _locationId);
    console.debug('updating pax : ', _outletId, url, _params);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  deleteFacilityLocation(facilityId: number, locationId: number) {
    let reFacilityId = /:outletId/gi;
    let reLocationId = /:locationId/gi;
    let _url = global.ServerUrls.outlet.locations.delete;

    _url = _url.replace(reFacilityId, facilityId);

    _url = _url.replace(reLocationId, locationId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  updateFacilityItem(outletId: number, itemId: number, params: any): Observable<any> {
    let _outletId = outletId;
    let _itemId = itemId;
    let _params = params;
    let reOutletId = /:outletId/gi;
    let reItemId = /:itemId/gi;
    delete _params['minBookingDuration'];
    _params['minBookingDuration.duration'] = params['minBookingDuration.duration'];
    _params['minBookingDuration.durationUnit'] = params['minBookingDuration.durationUnit'];

    console.debug('add facility location : ', params, _params);
    let url = global.ServerUrls.outlet.items.update;
    url = url.replace(reOutletId, _outletId);
    url = url.replace(reItemId, _itemId);
    console.debug('updating pax : ', _outletId, url, _params);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  addFacilityItem(outletId: number, params: any): Observable<any> {
    let _outletId = outletId;
    let _params = params;
    let reOutletId = /:outletId/gi;
    delete _params['minBookingDuration'];
    _params['minBookingDuration.duration'] = params['minBookingDuration.duration'];
    _params['minBookingDuration.durationUnit'] = params['minBookingDuration.durationUnit'];
    // _params['minBookingDuration.durationUnit'] = 'HOUR'
    let url = global.ServerUrls.outlet.items.add;
    url = url.replace(reOutletId, _outletId);
    console.debug('updating pax : ', _outletId, url, _params);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  deleteFacilityItem(facilityId: number, itemId: number) {
    let reFacilityId = /:outletId/gi;
    let reItemId = /:itemId/gi;
    let _url = global.ServerUrls.outlet.items.delete;

    _url = _url.replace(reFacilityId, facilityId);

    _url = _url.replace(reItemId, itemId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  updateFacilityWorkingHours(outletId: number, params: any, facilityMode?: string): Observable<any> {
    let _outletId = outletId;
    let _params = params;
    let reOutletId = /:outletId/gi;
    let reLocationId = /:locationId/gi;
    let reItemId = /:itemId/gi;

    let url = '';
    if (facilityMode === 'location') {
      url = global.ServerUrls.outlet.locations.workingHours;
      url = url.replace(reOutletId, String(_outletId));
      url = url.replace(reLocationId, params['locationId']);
    } else if (facilityMode === 'item') {
      url = global.ServerUrls.outlet.items.workingHours;
      url = url.replace(reOutletId, String(_outletId));
      url = url.replace(reItemId, params['itemId']);
    } else {
      url = global.ServerUrls.outlet.workingHours;
      url = url.replace(reOutletId, String(_outletId));
    }

    console.debug('updating working hours : ', facilityMode, _outletId, url, _params);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  updateFacilityClosingTimes(outletId: number, dayId: number, params: any, facilityMode?: string): Observable<any> {
    let _outletId = outletId;
    let _dayId = dayId;
    let _params = params;
    let reOutletId = /:outletId/gi;
    let reLocationId = /:locationId/gi;
    let reItemId = /:itemId/gi;

    let url = '';
    if (facilityMode === 'location') {
      url = global.ServerUrls.outlet.locations.closingTimes;
      url = url.replace(reOutletId, String(_outletId));
      url = url.replace(reLocationId, params['locationId']);
    } else if (facilityMode === 'item') {
      url = global.ServerUrls.outlet.items.closingTimes;
      url = url.replace(reOutletId, String(_outletId));
      url = url.replace(reItemId, params['itemId']);
    } else {
      url = global.ServerUrls.outlet.closingTimes;
      url = url.replace(reOutletId, String(_outletId));
    }

    url += '?dayId=' + _dayId;
    console.debug('updating pax : ', _outletId, url, _params);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.JSON, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  clearFacilityTimings(outletId: number, dayId: number, params: any, facilityMode?: string): Observable<any> {
    let _outletId = outletId;
    // let _dayId = dayId
    let _params = {
      dayId: dayId,
    };
    let reOutletId = /:outletId/gi;
    let reLocationId = /:locationId/gi;
    let reItemId = /:itemId/gi;
    // let reDayId = /:dayId/gi;

    let url = '';
    if (facilityMode === 'location') {
      url = global.ServerUrls.outlet.locations.clearTimings;
      url = url.replace(reOutletId, String(_outletId));
      url = url.replace(reLocationId, params['locationId']);
    } else if (facilityMode === 'item') {
      url = global.ServerUrls.outlet.items.clearTimings;
      url = url.replace(reOutletId, String(_outletId));
      url = url.replace(reItemId, params['itemId']);
    } else {
      url = global.ServerUrls.outlet.clearTimings;
      url = url.replace(reOutletId, String(_outletId));
    }

    // url = url.replace(reDayId, _dayId);
    console.debug('updating pax : ', _outletId, url);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  addFacilityClosures(outletId: number, params: any, facilityMode?: string): Observable<any> {
    let _outletId = outletId;
    // let _dayId = dayId
    let _params = params;
    let reOutletId = /:outletId/gi;
    let reLocationId = /:locationId/gi;
    let reItemId = /:itemId/gi;
    // let reDayId = /:dayId/gi;

    let url = '';
    if (facilityMode === 'location') {
      url = global.ServerUrls.outlet.locations.addClosures;
      url = url.replace(reOutletId, String(_outletId));
      url = url.replace(reLocationId, String(params['locationId']));
    } else if (facilityMode === 'item') {
      url = global.ServerUrls.outlet.items.addClosures;
      url = url.replace(reOutletId, String(_outletId));
      url = url.replace(reItemId, String(params['itemId']));
    } else {
      url = global.ServerUrls.outlet.addClosures;
      url = url.replace(reOutletId, String(_outletId));
    }

    console.debug('updating pax : ', _outletId, url);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getFacilityClosures(params) {
    // let _cartId = this.orderService.getCartId();
    let _params = params;
    let _url = global.ServerUrls.outlet.getClosures;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubFacilityBooking: Array<ClubFacilityBooking> = resp;
          return clubFacilityBooking;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  deleteFacilityClosures(closureId: number): Observable<any> {
    let _closureId = closureId;
    let reClosureId = /:closureId/gi;
    // let reDayId = /:dayId/gi;

    let url = global.ServerUrls.outlet.deleteClosures;
    url = url.replace(reClosureId, _closureId);
    let request = new RemoteRequest(url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getFacilityPricingList(clubId: number, params: any): Observable<any> {
    let _clubId = clubId;
    let _params = params;
    // let reDayId = /:dayId/gi;

    let url = global.ServerUrls.outlet.pricing.getList;
    // url = url.replace(reDayId, _dayId);
    console.debug('updating pax : ', _clubId, url);
    let request = new RemoteRequest(url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  addFacilityPricing(facilityId: number, params: any): Observable<any> {
    let _facilityId = facilityId;
    let _params = params;
    let reFacilityId = /:facilityId/gi;
    let url = '';
    url = global.ServerUrls.outlet.pricing.add;
    url = url.replace(reFacilityId, String(_facilityId));
    console.debug('updating pax : ', _facilityId, url);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.JSON, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  updateFacilityPricing(pricingId: number, params: any): Observable<any> {
    let _pricingId = pricingId;
    // let _dayId = dayId
    let _params = params;
    let rePricingId = /:pricingId/gi;

    let url = global.ServerUrls.outlet.pricing.update;
    url = url.replace(rePricingId, _pricingId);
    console.debug('updating pax : ', _pricingId, url);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.JSON, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  getBasePriceList(pricingId: number, params: any): Observable<any> {
    let _pricingId = pricingId;
    let _params = params;
    let rePricingId = /:pricingId/gi;

    let url = global.ServerUrls.outlet.pricing.getBasePrices;
    url = url.replace(rePricingId, _pricingId);
    console.debug('updating pax : ', _pricingId, url);
    let request = new RemoteRequest(url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  addBasePricing(pricingId: number, params: any): Observable<any> {
    let _pricingId = pricingId;
    let _params = params;
    let rePricingId = /:pricingId/gi;

    let url = '';
    url = global.ServerUrls.outlet.pricing.addBasePrices;
    url = url.replace(rePricingId, String(_pricingId));

    url += '?dayId=' + _params['dayId'] + '&startDate=' + _params['startDate'] + '&endDate=' + _params['endDate'];

    // url = url.replace(reDayId, _dayId);
    console.debug('updating pax : ', _pricingId, url);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  updateBasePricing(pricingId: number, basePriceId: number, params: any): Observable<any> {
    let _pricingId = pricingId;
    let _basePriceId = basePriceId;
    // let _dayId = dayId
    let _params = params;
    let rePricingId = /:pricingId/gi;
    let reBasePriceId = /:basePriceId/gi;

    let url = '';
    url = global.ServerUrls.outlet.pricing.updateBasePrices;
    url = url.replace(rePricingId, String(_pricingId));
    url = url.replace(reBasePriceId, String(_basePriceId));

    url += '?dayId=' + _params['dayId'] + '&startDate=' + _params['startDate'] + '&endDate=' + _params['endDate'];

    console.debug('updating pax : ', _pricingId, url);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  // let reDayId = /:dayId/gi;

  testSendBookingProgress(type: string = 'success', clubId: number, bookingReference: string, params: any) {
    let _params = params;
    if (clubId) _params['clubId'] = clubId;
    if (bookingReference) _params['bookingReference'] = bookingReference;
    let _url = global.ServerUrls.teeTimeBooking.test.sendBookingSuccess;
    if (type === 'failed') {
      _url = global.ServerUrls.teeTimeBooking.test.sendBookingFailed;
    }
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          //??console.log("Booking Cancel Guard - ",resetCancelGuard," : ",result)
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  deleteFacilityPricing(pricingId: number): Observable<any> {
    let _pricingId = pricingId;
    let rePricingId = /:pricingId/gi;
    let url = global.ServerUrls.outlet.pricing.delete;
    url = url.replace(rePricingId, _pricingId);
    // url = url.replace(reDayId, _dayId);
    console.debug('updating pax : ', _pricingId, url);
    let request = new RemoteRequest(url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  setFacilityDefaultPricing(facilityId: number, pricingId: number, params?: any, overrideMode?: string): Observable<any> {
    let _facilityId = facilityId;
    // let _dayId = dayId
    let _params = {
      pricing: pricingId,
    };
    let reFacilityId = /:facilityId/gi;
    let reLocationId = /:locationId/gi;
    let reItemId = /:itemId/gi;

    let url = '';
    if (overrideMode === 'location') {
      url = global.ServerUrls.outlet.locations.setPricing;
      url = url.replace(reFacilityId, String(_facilityId));
      url = url.replace(reLocationId, String(params['locationId']));
    } else if (overrideMode === 'item') {
      url = global.ServerUrls.outlet.items.setPricing;
      url = url.replace(reFacilityId, String(_facilityId));
      url = url.replace(reItemId, String(params['itemId']));
    } else {
      url = global.ServerUrls.outlet.defaultPricing;
      url = url.replace(reFacilityId, String(_facilityId));
    }
    // url = url.replace(reDayId, _dayId);
    console.debug('updating pax : ', _facilityId, url);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  deleteBasePricing(pricingId: number, basePriceId: number): Observable<any> {
    let _pricingId = pricingId;
    let _basePriceId = basePriceId;
    let rePricingId = /:pricingId/gi;
    let reBasePriceId = /:basePriceId/gi;

    let url = global.ServerUrls.outlet.pricing.deleteBasePrices;
    url = url.replace(rePricingId, _pricingId);
    url = url.replace(reBasePriceId, _basePriceId);
    // url = url.replace(reDayId, _dayId);
    console.debug('updating pax : ', _pricingId, url);
    let request = new RemoteRequest(url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  addPricingTimeRange(pricingId: number, params: any, overrideMode?: string): Observable<any> {
    let _pricingId = pricingId;
    let _params = params;
    let rePricingId = /:pricingId/gi;
    let reBasePriceId = /:basePriceId/gi;
    let url = '';
    if (overrideMode === 'base') {
      url = global.ServerUrls.outlet.pricing.addBaseTimeRangePrice;
      url = url.replace(rePricingId, String(_pricingId));
      url = url.replace(reBasePriceId, params['basePriceId']);
    } else {
      url = global.ServerUrls.outlet.pricing.addTimeRangePrice;
      url = url.replace(rePricingId, String(_pricingId));
    }
    console.debug('updating pax : ', _pricingId, url);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  deletePricingTimeRange(pricingId: number, params: any, basePriceId?: string, startTime?: any, PlayerTypeId?: number): Observable<any> {
    let _pricingId = pricingId;
    let _basePriceId = basePriceId;
    let _params = params;
    let rePricingId = /:pricingId/gi;
    let reBasePriceId = /:basePriceId/gi;

    let url = '';
    if (basePriceId) {
      url = global.ServerUrls.outlet.pricing.deleteBaseTimeRangePrice;
      url = url.replace(rePricingId, String(_pricingId));
      url = url.replace(reBasePriceId, String(_basePriceId));
    } else {
      url = global.ServerUrls.outlet.pricing.deleteTimeRangePrice;
      url = url.replace(rePricingId, String(_pricingId));
    }
    // url = url.replace(reDayId, _dayId);
    console.debug('updating pax : ', _pricingId, url);
    let request = new RemoteRequest(
      url + '?startTime=' + startTime + (PlayerTypeId ? '&playerType=' + PlayerTypeId : ''),
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA
    );

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  addBasePricingPlayerType(pricingId: number, basePriceId: number, playerType: string, params: any): Observable<any> {
    let _pricingId = pricingId;
    let _basePriceId = basePriceId;
    let _playerType = playerType;
    let _params = params;
    let rePricingId = /:pricingId/gi;
    let reBasePriceId = /:basePriceId/gi;
    let rePlayerType = /:playerType/gi;
    // let reDayId = /:dayId/gi;

    let url = global.ServerUrls.outlet.pricing.addBasePlayerTypePrices;
    url = url.replace(rePricingId, String(_pricingId));
    url = url.replace(reBasePriceId, String(_basePriceId));
    url = url.replace(rePlayerType, String(_playerType));

    // }

    // url += '?dayId='+_params['dayId'] + '&startDate='+_params['startDate']+'&endDate='+_params['endDate'];

    // url = url.replace(reDayId, _dayId);
    console.debug('updating pax : ', _pricingId, url);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  deleteBasePricingPlayerType(pricingId: number, basePriceId: number, playerType: string): Observable<any> {
    let _pricingId = pricingId;
    let _basePriceId = basePriceId;
    let _playerType = playerType;
    let rePricingId = /:pricingId/gi;
    let reBasePriceId = /:basePriceId/gi;
    let rePlayerType = /:playerType/gi;

    let url = '';
    url = global.ServerUrls.outlet.pricing.deleteBasePlayerTypePrices;
    url = url.replace(rePricingId, String(_pricingId));
    url = url.replace(reBasePriceId, String(_basePriceId));
    url = url.replace(rePlayerType, String(_playerType));
    // url = url.replace(reDayId, _dayId);
    console.debug('updating pax : ', _pricingId, url);
    let request = new RemoteRequest(url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public deleteFacilityImages(facilityId: number, imageUrls: string): Observable<any> {
    let _facilityId = facilityId;
    let reFacilityId = /:outletId/gi;
    let _url = global.ServerUrls.outlet.removeImages; // + '?' + _playerId + _playerType;

    _url = _url.replace(reFacilityId, _facilityId);
    let request = new RemoteRequest(_url + '?imageUrls=' + imageUrls, this.requestMethod.delete, ContentType.JSON);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  excludeAgentCommission(bookingId: number, bookingPlayerIds: Array<number>, exclude: boolean = true) {
    let _params = {
      bookingId: bookingId,
      bookingPlayerIds: bookingPlayerIds,
      exclude: exclude,
    };
    let _url = global.ServerUrls.bookingAgent.excludeBookingPlayer;
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  setAgentCommissionComponent(clubId: number, partnerId: string, params: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    let _url = global.ServerUrls.bookingAgent.setCommissionComponent;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePartnerId, partnerId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public getClubCountryList(search?: string): Observable<Array<Country>> {
    let _params = { searchText: search };
    let _url = global.ServerUrls.getClubCountries;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: Array<Country> = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  /**
   * @param clubId integer
   * @param partnerId string
   * @param mygolfNewsOnly (boolean)
   * @param startDate (date string)
   * @param endDate (date string)
   * @param activeOn (date string)
   * @param activeOrInactive A - Active news only, I - Inactive only, B - Both (Default). This parameter is ignored if activeOn is specified.
   * @param search The filter text used on the fields title, news brief and full news
   * @param pageSize Default value : 30
   * @param pageNo Default value : 1
   *
   **/
  getNewsList(params): Observable<NewsPage> {
    let url = global.ServerUrls.getNewsList;
    let _params = {};
    if (!appProps.filterNewsPromoByDates) params['startDate'] = null;
    _params = removeEmptyKeys(params);
    let request = new RemoteRequest(url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((result: any) => {
        let list: News[] = result.items;
        if (list && list.length)
          result.items.forEach(news => {
            JsonService.deriveFullImageUrlArrayObject(news.images);
            JsonService.deriveFullUrl(news?.club, 'clubLogo');
            JsonService.deriveFullUrl(news?.club, 'clubImage');
            JsonService.deriveFullUrl(news?.club, 'clubThumbnail');
            JsonService.deriveFullUrl(news?.partner, 'partnerImage');
          });
        return result;
      })
    );
  }

  /**
   * @param clubId integer
   * @param partnerId string
   * @param mygolfOnly (boolean)
   * @param startDate (date string)
   * @param endDate (date string)
   * @param activeOn (date string)
   * @param activeOrInactive A - Active news only, I - Inactive only, B - Both (Default). This parameter is ignored if activeOn is specified.
   * @param search The filter text used on the fields title, news brief and full news
   * @param pageSize Default value : 30
   * @param pageNo Default value : 1
   *
   **/
  getPromoAdsList(params): Observable<OffersAndAdvertisementPage> {
    let url = global.ServerUrls.getPromotionList;
    let _params = {};
    if (!appProps.filterNewsPromoByDates) params['startDate'] = null;
    _params = removeEmptyKeys(params);
    let request = new RemoteRequest(url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((result: any) => {
        let list: OfferAndAdvertisement[] = result.items;
        if (list && list.length)
          result.items.forEach(promotion => {
            JsonService.deriveFullImageUrlArrayObject(promotion.images);
            JsonService.deriveFullUrl(promotion?.club, 'clubLogo');
            JsonService.deriveFullUrl(promotion?.club, 'clubImage');
            JsonService.deriveFullUrl(promotion?.club, 'clubThumbnail');
            JsonService.deriveFullUrl(promotion?.partner, 'partnerImage');
          });
        return result;
      })
    );
  }

  changeNewsOwnership(type: string, newsId: number, id: number | string) {
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    let reNewsId = /:newsId/gi;
    let _url = global.ServerUrls.news.moveToMygolf2u;
    _url = _url.replace(reNewsId, newsId);
    if (type === 'club') {
      _url = global.ServerUrls.news.moveToClub;
      _url = _url.replace(reNewsId, newsId);
      _url = _url.replace(reClubId, id);
    } else if (type === 'partner') {
      _url = global.ServerUrls.news.moveToPartner;
      _url = _url.replace(reNewsId, newsId);
      _url = _url.replace(rePartnerId, id);
    } else {
      _url = global.ServerUrls.news.moveToMygolf2u;
      _url = _url.replace(reNewsId, newsId);
    }
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  changePromoAdsOwnership(type: string, promoId: number, id: number | string) {
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    let rePromoId = /:id/gi;
    let _url = global.ServerUrls.promoAds.moveToMygolf2u;
    _url = _url.replace(rePromoId, promoId);
    if (type === 'club') {
      _url = global.ServerUrls.promoAds.moveToClub;
      _url = _url.replace(rePromoId, promoId);
      _url = _url.replace(reClubId, id);
    } else if (type === 'partner') {
      _url = global.ServerUrls.promoAds.moveToPartner;
      _url = _url.replace(rePromoId, promoId);
      _url = _url.replace(rePartnerId, id);
    } else {
      _url = global.ServerUrls.promoAds.moveToMygolf2u;
      _url = _url.replace(rePromoId, promoId);
    }
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }
  public searchFacilities(clubId: number, params: any) {
    let _params = params;

    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.outlet.searchFacilities;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let bookableFacilityResult: BookableFacilitySearchResult = resp;
          return bookableFacilityResult;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public bookFacilitySlot(reqBookSlot: FacilityBookingRequest): Observable<any> {
    let _reqBookSlot = reqBookSlot;
    let request = new RemoteRequest(global.ServerUrls.outlet.bookings.bookSlot, this.requestMethod.post, ContentType.JSON, _reqBookSlot);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public createOrderForBooking(bookingNew: boolean, cartId: string): Observable<any> {
    let _cartId = bookingNew ? this.orderService.getCartId() : cartId;
    let _params = {
      cartId: _cartId,
    };
    let request = new RemoteRequest(
      global.ServerUrls.outlet.bookings.createOrder,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getFacilityBookingOrderById(orderId: number) {
    let reOrderId = /:Id/gi;
    let _url = global.ServerUrls.order.facilityBookingById;

    _url = _url.replace(reOrderId, orderId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getoutletInfoById(outletId: number) {
    let _outletId = /:outletId/gi;
    let _url = global.ServerUrls.outlet.getInfo;
    _url = _url.replace(_outletId, outletId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          if (data) {
            JsonService.deriveFullImageUrlArrayObject(data.images);
          }
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  cancelFacilityBooking(bookingId: number) {
    let reBookingId = /:bookingId/gi;

    let _url = global.ServerUrls.outlet.bookings.cancel;

    _url = _url.replace(reBookingId, bookingId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  deleteFacilityBookingOrder(orderId: number) {
    let reOrderId = /:orderId/gi;
    let _url = global.ServerUrls.outlet.bookings.removeOrder;

    _url = _url.replace(reOrderId, orderId);
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updatePaxForFacBooking(bookingId: number, pax: BookingPax): Observable<any> {
    let _bookingId = bookingId;
    let _params = {
      pax: pax,
    };
    let reBookingId = /:bookingId/gi;
    // let headers = {};
    // if (captchaResponse && captchaResponse.length > 0) headers['captcha-response'] = captchaResponse;
    // else headers = null;
    let url = global.ServerUrls.outlet.bookings.updatePax;
    url = url.replace(reBookingId, _bookingId);
    console.debug('updating pax : ', _bookingId, url, _params);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.JSON, pax);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updateCountForFacBooking(bookingId: number, params: AdditionalItemCount): Observable<any> {
    let _bookingId = bookingId;
    let _params = params;
    let reBookingId = /:bookingId/gi;
    // let headers = {};
    // if (captchaResponse && captchaResponse.length > 0) headers['captcha-response'] = captchaResponse;
    // else headers = null;
    let url = global.ServerUrls.outlet.bookings.updateAdditionalCount;
    url = url.replace(reBookingId, _bookingId);
    console.debug('updating pax : ', _bookingId, url, _params);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.JSON, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public searchFacilityOrders(params) {
    let _url = global.ServerUrls.order.searchFacilityOrders;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let orderListPage: any = resp;
          if (orderListPage) {
            orderListPage.forEach((order: any) => {
              JsonService.deriveFulImageURL(order.club, 'clubLogo');
              JsonService.deriveFulImageURL(order.club, 'clubImage');
              JsonService.deriveFulImageURL(order.club, 'clubThumbnail');
              JsonService.deriveFulImageURL(order.clubLite, 'clubLogo');
              JsonService.deriveFulImageURL(order.clubLite, 'clubImage');
              JsonService.deriveFulImageURL(order.clubLite, 'clubThumbnail');
            });
          }
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  facilitiesOverrideBasePrice(pricingId: number, params: any): Observable<any> {
    let _pricingId = pricingId;
    let _params = params;
    let rePricingId = /:pricingId/gi;

    let url = '';
    url = global.ServerUrls.outlet.facilitiesOverrideBasePrice;
    url = url.replace(rePricingId, String(_pricingId));
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  rearrangeFacilityImages(imageInfo, facilityId) {
    let reOutletId = /:outletId/gi;
    let url = '';
    url = global.ServerUrls.outlet.facilitiesRearangeImage;
    url = url.replace(reOutletId, String(facilityId));
    let quaryParams: any = '';
    imageInfo?.forEach((value, index) => {
      if (index === 0) {
        quaryParams += `?imageUrls=${value}`;
      } else {
        quaryParams += `,${value}`;
      }
    });

    let request = new RemoteRequest(url + quaryParams, this.requestMethod.put, ContentType.URL_ENCODED_FORM_DATA);

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCompListLiteSecured(pageNo: number = 1, params: any) {
    params['pageNo'] = pageNo;

    if (params['startDate']) params['startDate'] = moment(params['startDate']).format('YYYY-MM-DD');
    if (params['endDate']) params['endDate'] = moment(params['endDate']).format('YYYY-MM-DD');
    if (params['status'] === 'all') params['status'] = '';
    if (params['countryId'] === null || !params['countryId']) delete params['countryId'];
    let _url = global.ServerUrls.competitions.getListLiteSecured;
    // +"?pageNo="+params['pageNo']+"&pageSize="+params['pageSize'];

    console.debug('in request : ', params);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compDataPage: CompetitionDataLitePage = resp;
          compDataPage?.items.forEach((comp: CompetitionDataLite) => {
            if (comp?.id)
              // comp.competitionId = comp.id;
              JsonService.deriveFullUrl(comp, 'playerPhoto');
            JsonService.deriveFullUrl(comp, 'image');
            JsonService.deriveFullUrl(comp, 'thumbnail');
          });
          //  //??console.log("club flight service first - booking Opts : ", bookingOptions, resp, resp.json())
          return compDataPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getNewCompetitionList(pageNo: number = 1, params: any) {
    params['pageNo'] = pageNo;

    if (params['startDate']) params['startDate'] = moment(params['startDate']).format('YYYY-MM-DD');
    if (params['endDate']) params['endDate'] = moment(params['endDate']).format('YYYY-MM-DD');
    if (params['status'] === 'all') params['status'] = '';
    // else if(params['status']?.split(',')?.length > 1) {
    //     let _status = [];
    //     _status = params['status'].split(',');
    //   _status.forEach(status => {
    //     params = params.append('status', status);
    //   });
    // }
    if (params['countryId'] === null || !params['countryId']) delete params['countryId'];

    for (let key in params) {
      if (params[key] === null || !params[key]) delete params[key];
    }

    //   let _params = new HttpParams();
    //   for(let key in params) {
    //     _params = _params.append(key, params[key]);
    //   }
    //   if(params['status']?.split(',')?.length > 1) {
    //     let _status = [];
    //     _status = params['status'].split(',');
    //   _status.forEach(status => {
    //     _params = _params.append('status', status);
    //   });
    // }
    let _url = global.ServerUrls.competitions.getList;
    // +"?pageNo="+params['pageNo']+"&pageSize="+params['pageSize'];

    console.debug('in request : ', params);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compDataPage: CompetitionDataPage = resp;
          compDataPage?.items.forEach((comp: CompetitionData) => {
            if (comp?.id)
              // comp.competitionId = comp.id;
              JsonService.deriveFullUrl(comp, 'playerPhoto');
            JsonService.deriveFullUrl(comp, 'image');
            JsonService.deriveFullUrl(comp, 'thumbnail');
          });
          //  //??console.log("club flight service first - booking Opts : ", bookingOptions, resp, resp.json())
          return compDataPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  /**
   * Search clubs
   * @param searchText The search text filter. The search is applied on clubName, tag, address,
   * city, state
   * @param activeOnly Only clubs with status "Active" are considered.
   * @param pageNumber The search happens in paged manner. this parameter specifies which page is
   * requested
   * @param countryId The optional country id. Only clubs from this country are returned. Clubs
   * without country are ignored
   * @returns {Observable<R>}
   */
  public searchClubsNew(
    searchText: string,
    activeOnly: boolean,
    pageNumber: number,
    countryId?: string,
    pageSize?: number,
    clubType: string = 'B'
  ): Observable<ClubDataPage> {
    let _url = global.ServerUrls.getClubList;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      searchText: searchText,
      activeOnly: activeOnly,
      pageNo: pageNumber,
      countryId: countryId,
      pageSize: pageSize,
      clubType: clubType,
    });
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          console.debug('search clubs', resp);
          let clubDataPage: ClubDataPage = resp;
          if (clubDataPage && clubDataPage?.items)
            clubDataPage.items.forEach((c: any) => {
              c.clubId = c.id;
              c.clubName = c.name;
              if (!isPresent(c.clubImage)) c.clubImage = 'document/img/default_club.png';

              JsonService.deriveFullUrl(c, 'clubImage');
            });
          return clubDataPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getUserList(params?: any): Observable<UserPage> {
    let _params = params;
    for (let key in _params) {
      if (_params[key] === null || !_params[key]) delete _params[key];
    }
    let _url = global.ServerUrls.userProfiles.getList;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: UserPage = resp;
          result?.items?.forEach((user: UserAuthentication) => {
            JsonService.deriveFulImageURL(user?.profile, 'photo');
            JsonService.deriveFulImageURL(user?.profile, 'profileImage');
          });
          console.debug('api - user list : ', resp);
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getUserHomeItemList(userId: number): Observable<Array<UserHomeItem>> {
    let _params = {
      userId: userId,
    };
    for (let key in _params) {
      if (_params[key] === null || !_params[key]) delete _params[key];
    }
    let _url = global.ServerUrls.homeItems.get;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: Array<UserHomeItem> = resp;
          result?.forEach((userHomeItem: UserHomeItem) => {
            JsonService.deriveFulImageURL(userHomeItem?.user, 'profileImage');
          });
          console.debug('api - user home item list : ', resp);
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  setHomeUserItemVisibility(homeItem: string, sequence: number = 0, hide: boolean = false): Observable<any> {
    let _params = {
      homeItem: homeItem,
      sequence: sequence,
      hide: hide,
    };

    let url = '';
    url = global.ServerUrls.homeItems.setVisibility;
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getDefinedClubOutletTypes(clubId: number): Observable<Array<ClubOutletType>> {
    let _url = global.ServerUrls.outlet.clubOutletTypes.getDefinedList;
    let reClubId = /:clubId/gi;
    _url = _url.replace(reClubId, String(clubId));
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: Array<ClubOutletType> = resp;
          console.debug('api - user home item list : ', resp);
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  setDefinedClubOutletTypes(clubId: number, outletTypes: Array<string>): Observable<any> {
    let _params = {
      outletTypes: outletTypes,
    };

    let _url = '';
    _url = global.ServerUrls.outlet.clubOutletTypes.setDefinedList;
    let reClubId = /:clubId/gi;
    _url = _url.replace(reClubId, String(clubId));
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getUserOutletTypes(clubId: number, userId: number): Observable<Array<ClubOutletType>> {
    let _url = global.ServerUrls.outlet.clubOutletTypes.getUser;
    let reClubId = /:clubId/gi;
    _url = _url.replace(reClubId, String(clubId));
    let reUserId = /:userId/gi;
    _url = _url.replace(reUserId, String(userId));
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: Array<ClubOutletType> = resp;
          console.debug('api - user home item list : ', resp);
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  setUserOutletTypes(clubId: number, userId: number, outletTypes: Array<string>): Observable<any> {
    let _params = {
      outletTypes: outletTypes,
    };

    let _url = '';
    _url = global.ServerUrls.outlet.clubOutletTypes.setUser;
    let reClubId = /:clubId/gi;
    _url = _url.replace(reClubId, String(clubId));
    let reUserId = /:userId/gi;
    _url = _url.replace(reUserId, String(userId));
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getAvailableOutletTypes(): Observable<Array<ClubOutletType>> {
    let _url = global.ServerUrls.outlet.getAvailableTypes;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: Array<ClubOutletType> = resp;
          console.debug('api - user home item list : ', resp);
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  deleteFacilityItem_v1(facilityId: number, itemId: Array<number>) {
    let reFacilityId = /:outletId/gi;
    let _url = global.ServerUrls.outlet.items.itemsDelete;

    _url = _url.replace(reFacilityId, facilityId);
    let request = new RemoteRequest(_url + `?itemIds=${itemId}`, this.requestMethod.delete, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  bulkUpdateFacilityLocation(
    outletId: number,
    itemId: Array<number>,
    locationId: number,
    description: string,
    pricingPlanId: number,
    minDuration: any,
    minDurationUnit: any
  ): Observable<any> {
    let _outletId = outletId;
    let reOutletId = /:outletId/gi;
    let url = global.ServerUrls.outlet.items.bulkUpdate;
    url = url.replace(reOutletId, _outletId);
    let request = new RemoteRequest(
      url +
        `?itemIds=${itemId}&locationId=${locationId}&description=${description}&duration= ${minDuration}&durationUnit=${minDurationUnit}&pricingPlanId=${pricingPlanId}`,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  bulkUpdateFacilityItem(
    outletId: number,
    itemId: Array<number>,
    locationId: number,
    description: string,
    pricingPlanId: number,
    minDuration: any,
    minDurationUnit: any
  ): Observable<any> {
    let _outletId = outletId;
    let reOutletId = /:outletId/gi;
    let url = global.ServerUrls.outlet.items.bulkUpdate;
    url = url.replace(reOutletId, _outletId);
    let request = new RemoteRequest(
      url +
        `?itemIds=${itemId}&locationId=${locationId}&description=${description}&duration= ${minDuration}&durationUnit=${minDurationUnit}&pricingPlanId=${pricingPlanId}`,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public repriceFacilityBookingOrder(orderId: number): Observable<any> {
    let _orderId = orderId;
    let reOrderId = /:orderId/gi;
    let url = global.ServerUrls.clubOrder.reprice;
    url = url.replace(reOrderId, _orderId);
    console.debug('updating pax : ', _orderId, url);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.JSON);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  addRequestAdjustment(requestId: number, adjustment: number, remarks: string, tax: boolean): Observable<any> {
    let _params = {
      requestId: requestId,
      adjustment: adjustment,
      remarks: remarks,
      tax: tax,
    };

    let _url = global.ServerUrls.stayAndPlay.addRequestAdjustments;
    let reRequestId = /:requestId/gi;
    _url = _url.replace(reRequestId, String(requestId));
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  updateRequestAdjustment(requestId: number, sequence: number, adjustment: number, remarks: string, tax: boolean): Observable<any> {
    let _params = {
      requestId: requestId,
      adjustment: adjustment,
      remarks: remarks,
      tax: tax,
    };

    let _url = global.ServerUrls.stayAndPlay.updateRequestAdjustments;
    let reRequestId = /:requestId/gi;
    _url = _url.replace(reRequestId, String(requestId));
    let reSequence = /:sequence/gi;
    _url = _url.replace(reSequence, String(sequence));
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  removeRequestAdjustment(requestId: number, sequence: number) {
    // let _params = {};
    // let _clubId = clubId;
    // if (playerDiscountId) _params['playerDiscountId'] = playerDiscountId;

    let _url = global.ServerUrls.stayAndPlay.removeRequestAdjustment;

    let reRequestId = /:requestId/gi;
    _url = _url.replace(reRequestId, String(requestId));
    let reSequence = /:sequence/gi;
    _url = _url.replace(reSequence, String(sequence));
    let request = new RemoteRequest(
      _url,
      // global.ServerUrls.removeCardClubApplication+"/"+_clubId,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return (
      this.http
        .execute(request)
        //  this.http.execute(request, global.ServerUrls.removeCardClubApplication+"/"+_clubId+"?playerDiscountId="+_params['playerDiscountId'])
        .pipe(
          map((resp: any) => {
            //??
            return resp;
          })
        )
    );
  }

  addOfflinePaymentStayPlay(requestId: number, offlinePayment: Array<OfflinePayment>) {
    let _params = {};
    _params = offlinePayment;

    let _url = global.ServerUrls.stayAndPlay.addOfflinePayment;
    let reRequestId = /:requestId/gi;
    _url = _url.replace(reRequestId, String(requestId));
    const paymentDateTime = moment().format('YYYY-MM-DDTHH:mm:ss');
    _url += `?paymentDateTime=${paymentDateTime}`;
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.JSON, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  deleteOfflinePaymentStayPlay(requestId: number, paymentId: number) {
    let _url = global.ServerUrls.stayAndPlay.deleteOfflinePayment;
    const params = {
      stayAndPlayPaymentId: paymentId,
    };
    let reRequestId = /:requestId/gi;
    _url = _url.replace(reRequestId, String(requestId));
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.HTML, params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  updateOfflinePaymentStayPlay() {}
  doRefundStayPlay(requestId: number, refundForm: RefundForm) {
    let _params = {};
    for (let key in refundForm) {
      // if (refundForm[key] === undefined) delete refundForm[key];
      if (refundForm[key] === null) delete refundForm[key];
    }
    _params = refundForm;

    let _url = global.ServerUrls.stayAndPlay.doRefund;
    let reRequestId = /:requestId/gi;
    _url = _url.replace(reRequestId, String(requestId));
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }
  undoRefundStayPlay(requestId: number, refundInstanceId: number) {
    let _url = global.ServerUrls.stayAndPlay.undoRefund;
    const params = {
      refundInstanceId: refundInstanceId,
    };
    let reRequestId = /:requestId/gi;
    _url = _url.replace(reRequestId, String(requestId));
    let request = new RemoteRequest(_url, this.requestMethod.delete, ContentType.HTML, params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  updateBookingConfirmationStatus(bookingId: number, bookingConfirmationStatus: BookingConfirmationStatus, reason?: string) {
    let _params = {
      bookingId: bookingId,
      status: bookingConfirmationStatus,
    };
    if (reason?.length) _params['reason'] = reason;

    let _url = global.ServerUrls.teeTime.updateBookingConfirmationStatus;
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  /**
   * Search clubs
   * @param confirmationStatus // Pending, Confirmed, Rejected
   * city, state
   **/
  public searchBookingAgreementPartner(partnerId: string, params: any) {
    // fromDate?: string,
    // toDate?: string,
    // statusType?: string,
    // statusList?: Array<string>,
    // clubId?: number,
    // search?: string,
    // pageSize?: number,
    // pageNo?: number,
    // bookingMedium?: string,
    // slotFrom?: string,
    // slotTo?: string,
    // bookingStart?: string
    // pageSize?: number, pageNo?: number

    // 'assets/json_teeTimeBooking.json'
    let _params = params;
    let _url = global.ServerUrls.teeTime.searchForPartner;

    let rePartnerId = /:partnerId/gi;
    _url = _url.replace(rePartnerId, partnerId);

    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??console.log("club booking list : ", resp)
        let clubBookingList: PagedData<TeeTimeBooking> = resp;
        clubBookingList.items.forEach((tb: TeeTimeBooking) => {
          JsonService.deriveFullUrl(tb.bookedByPlayer, 'profile');
          JsonService.deriveFullUrl(tb.bookedByPlayer, 'image');
          JsonService.deriveFullUrl(tb.bookingAgent, 'partnerImage');
          JsonService.deriveFullUrl(tb.bookedByUser?.profile, 'photo');
          JsonService.deriveFullUrl(tb.bookedByUser?.profile, 'profileImage');
          JsonService.deriveFullUrl(tb.clubData, 'clubImage');
          JsonService.deriveFullUrl(tb.clubData, 'clubLogo');
          JsonService.deriveFullUrl(tb.clubData, 'clubThumbnail');
          tb.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
            JsonService.deriveFullUrl(p.player, 'profile');
            JsonService.deriveFullUrl(p.player, 'image');
            JsonService.deriveFullUrl(p.caddyAssigned, 'caddyImage');
            JsonService.deriveFullUrl(p.caddyPreferred, 'caddyImage');
          });
          //    if(tb.flight) tb.bookingStatus = 'PaymentFull'
        });
        //  //??console.log("club flight service first : ", flightList, resp, resp)
        //    return {resp , clubBookingList};
        return clubBookingList;
      })
    );
  }

  saveBookingEInvoiceSetup(bookingId: number, tBookingEInvoicePlayerForm: Array<TBookingEInvoicePlayerDTO>) {
    let _params = tBookingEInvoicePlayerForm;

    let _url = global.ServerUrls.eInvoicing.saveTeeBookingSetup;
    let reBookingId = /:bookingId/gi;
    _url = _url.replace(reBookingId, bookingId);

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.XML, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }
  saveOrderEInvoiceSetup(orderId: number, orderEInvoiceSetup: EInvoicingSetup) {
    let _params = orderEInvoiceSetup;

    let _url = global.ServerUrls.eInvoicing.saveOrderSetup;
    let reOrderId = /:orderId/gi;
    _url = _url.replace(reOrderId, orderId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.XML, _params);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        //??
        return resp;
      })
    );
  }

  /**
   * @param playerId: number
   * @param eInvoicingOption: string <None|Individual|Company>
   * @param country: string
   **/
  public updatePlayerEInvoiceInfo(playerId: number, eInvoicingOption: string, country: string, params: any): Observable<any> {
    let _playerId = playerId;
    let rePlayerId = /:playerId/gi;
    let _params = params;
    _params['eInvoicingOption'] = eInvoicingOption;

    let url = global.ServerUrls.eInvoicing.saveForPlayer;
    url = url.replace(rePlayerId, _playerId);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getEInvoiceEntityDetails(countryId: string, taxIdentificationNumber: string) {
    let _params = {
      countryId: countryId,
      tin: taxIdentificationNumber,
    };
    let _url = global.ServerUrls.eInvoicing.getEntityDetails;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getEInvoiceEntityList(countryId: string, taxIdentificationNumber: string) {
    let _params = {
      countryId: countryId,
      tin: taxIdentificationNumber,
    };
    let _url = global.ServerUrls.eInvoicing.getEntityList;
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getPlayerDetails(playerId: number): Observable<PlayerData> {
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.getPlayerDetails;
    _url = _url.replace(rePlayerId, playerId);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  /**
   * Gets the states from the servers
   * @param countryId (Optional) If you want states of a country specify the country id
   * @param searchText The search text to filter the states (Optional)
   * @returns {Observable<R>}
   */
  public listStates(countryId: string, searchText?: string): Observable<Array<State>> {
    let request = new RemoteRequest(global.ServerUrls.getStates, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, {
      country: countryId,
      search: searchText,
    });
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let states: Array<State> = [];
          console.debug('get states :', countryId, resp, states);
          resp.forEach((state: string) => {
            states.push({
              stateCode: state,
              stateName: state,
            });
          });
          return states;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getStatesCities(country: string = 'MYS', initial: boolean = false) {
    let _randomizer = Math.floor(Math.random() * 7777) + 1;
    let _url;
    if (!initial) _url = global.MygolfServer + `/document/assets/e-invoice/${country}/states-cities.json?v=${_randomizer}`;
    else _url = `https://app.mygolf2u.com/assets/e-invoice/${country}/states-cities.json?v=${_randomizer}`;
    // let _url = global.MygolfServer+'/document/assets/app-attributes.json'+"?v="+_randomizer
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.JSON);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data;
        if (typeof resp === 'string') data = JSON.parse(resp);

        data = JSON.parse(JSON.stringify(data));
        if (data?.length) {
          data.forEach((state: any) => {
            state.cities.sort((a, b) => {
              return a - b;
            });
          });
        }
        return data;
      }),
      catchError(error => {
        console.error('Error fetching states and cities:', error);
        return throwError(() => new Error('Failed to fetch states and cities.'));
      })
    );
  }

  /**
   * Gets the states from the servers
   * @param countryId (Optional) If you want states of a country specify the country id
   * @param tin The search text to filter the states (Optional)
   * @returns {Observable<R>}
   */
  public checkTINvalid(countryId: string, tin: string, params: any): Observable<any> {
    let _url = global.ServerUrls.eInvoicing.checkTINvalid;

    let reCountryId = /:countryId/gi;
    let reTin = /:tin/gi;
    _url = _url.replace(reCountryId, countryId);
    _url = _url.replace(reTin, tin);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  /**
   * Gets the states from the servers
   * @param countryId (Optional) If you want states of a country specify the country id
   * @param tin The search text to filter the states (Optional)
   * @returns {Observable<R>}
   */
  public searchTIN(countryId: string, tin: string): Observable<any> {
    let _url = global.ServerUrls.eInvoicing.searchTIN;

    let reCountryId = /:countryId/gi;
    let reTin = /:tin/gi;
    _url = _url.replace(reCountryId, countryId);
    _url = _url.replace(reTin, tin);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public generateOrderPrint(clubId: number, orderId: number, params?: any): Observable<any> {
    let _clubId = clubId;
    let _orderId = orderId;
    let _params = params;

    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;

    let _url = global.ServerUrls.clubOrder.generateReport;
    // downloadBookingBill
    _url = _url.replace(reClubId, _clubId);
    _url = _url.replace(reOrderId, orderId);
    console.debug('get itemized bill : ', _url);
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA, _params);

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          //??
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public approveStayPlayRequest(requestId: number): Observable<any> {
    let reRequestId = /:requestId/gi;
    let url = global.ServerUrls.stayAndPlay.approveRequest;
    url = url.replace(reRequestId, requestId);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  updateBookingOfflinePayment(params: any) {
    let _params = params;
    // let reClubId= /:clubId/gi;
    // let reOrderId= /:orderId/gi;
    // let reItemId = /:itemId/gi;
    let _url = global.ServerUrls.teeTimeBooking.club.updateOfflinePayment;

    _url += '?bookingId=' + _params['bookingId'] + '&bookingBillId=' + _params['bookingBillId'];
    delete _params['bookingId'];
    delete _params['bookingBillId'];
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.JSON, _params);
    return this.http
      .execute(request)
      .pipe(map((resp: Response) => resp))
      .pipe(catchError(this.http.handleError));
  }

  getMultiCourseDetails(organizerId: number, multiCourseCompId: number) {
    let _url = global.ServerUrls.multiCourseCompetitions.getDetails;
    let reOrganizerId = /:organizerId/gi;
    _url = _url.replace(reOrganizerId, organizerId);
    let reMultiCourseCompId = /:multiCourseCompId/gi;
    _url = _url.replace(reMultiCourseCompId, multiCourseCompId);

    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((response: any) => {
          let resp = response;
          if (resp?.teams?.length) {
            resp?.teams.forEach((team: LeagueSeasonTeam) => {
              JsonService.deriveFullUrl(team, 'teamLogo');
            });
          }
          if (resp?.seasonCompetitions?.length) {
            resp?.seasonCompetitions.forEach((comp: LeagueSeasonCompetition) => {
              JsonService.deriveFullUrl(comp.competition, 'image');
            });
          }
          console.debug('get multi course comps details [1]: ', resp);
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  /**
   *
   * @param organizerId
   * @param multiCourseCompId | this is basically seasonId
   * @returns
   */
  getMultiCoursePlayersList(organizerId: number, multiCourseCompId: number) {
    let _url = global.ServerUrls.multiCourseCompetitions.getRegisteredPlayers;
    let reOrganizerId = /:organizerId/gi;
    _url = _url.replace(reOrganizerId, organizerId);
    let reMultiCourseCompId = /:multiCourseCompId/gi;
    _url = _url.replace(reMultiCourseCompId, multiCourseCompId);

    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((response: any) => {
          let resp: Array<TournamentPlayerBasicView> = response;
          resp.forEach(player => {
            if (player.player?.image?.length) JsonService.deriveFulImageURL(player?.player, 'image');
          });
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  /**
   *
   * @param organizerId
   * @param multiCourseCompId | this is basically seasonId
   * @returns
   */
  getMultiCourseGuestsList(organizerId: number, multiCourseCompId: number) {
    let _url = global.ServerUrls.multiCourseCompetitions.getRegisteredGuests;
    let reOrganizerId = /:organizerId/gi;
    _url = _url.replace(reOrganizerId, organizerId);
    let reMultiCourseCompId = /:multiCourseCompId/gi;
    _url = _url.replace(reMultiCourseCompId, multiCourseCompId);

    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((response: any) => {
          let resp: Array<LeagueSeasonGuestView> = response;
          resp?.forEach(guest => {
            if (guest?.player.image?.length) JsonService.deriveFulImageURL(guest?.player, 'image');
          });
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getCustomizedAttributes(initial: boolean = false, local: boolean = false) {
    let _randomizer = Math.floor(Math.random() * 7777) + 1;
    let _url;
    if (local && this.environmentService.isLocalhost()) {
      local = true;
    } else local = false;
    if (local) {
      _url = '/assets/customized-attributes.json' + '?v=' + _randomizer;
    } else {
      if (!initial) {
        if (global?.clubId && global?.appClient?.length) {
          _url = global.MygolfServer + `/document/assets/clubSpecific/${global?.clubId}/customized-attributes.json` + '?v=' + _randomizer;
        } else {
          _url = global.MygolfServer + '/document/assets/customized-attributes.json' + '?v=' + _randomizer;
        }
      } else {
        const _env = global.MygolfServerHost?.split('.')[0];
        _url = `https://applet.mygolf2u.com/api/attributes?env=${_env}`;
        // _url =
        //   'http://app.mygolf2u.com/settings' + '/customized-attributes.json' + '?v=' + _randomizer;
      }
    }
    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let data: any = resp;
        if (initial && !local) {
          return data?.sort((a, b) => {
            return b?.id - a?.id;
          })[0]?.data;
        }
        return data;
      })
    );
  }
  public importClubTransactions(clubId: number, file: any): Observable<any> {
    // public updatePlayerPhoto(imageUrl: string, mimeType: string, playerId?: number): Observable<UploadResult>{
    let _clubId = clubId;

    const _formData: FormData = new FormData();
    _formData.append('file', file);

    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.playerAccounts.importClubTransactions;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.MULTIPART_FORM, _formData);
    return this.http
      .execute(request)
      .pipe(map((resp: Response) => resp))
      .pipe(catchError(this.http.handleError));
  }

  sendSingleUserNotifications(userId: number, notification: NotificationData) {
    let _url = `${global.ServerUrls.firebaseNotifications.sendToUser.single}?userId=${userId}`;

    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.MULTIPART_FORM, notification);
    return this.http
      .execute(request)
      .pipe(map((resp: Response) => resp))
      .pipe(catchError(this.http.handleError));
  }

  sendMultipleUserNotifications(userIds: number[], notification: NotificationData) {
    let _url = `${global.ServerUrls.firebaseNotifications.sendToUser.multiple}`;
    let _content = {
      ids: userIds,
      notification: notification,
    };
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.MULTIPART_FORM, _content);
    return this.http
      .execute(request)
      .pipe(map((resp: Response) => resp))
      .pipe(catchError(this.http.handleError));
  }

  sendSinglePlayerNotifications(playerId: number, notification: NotificationData) {
    let _url = `${global.ServerUrls.firebaseNotifications.sendToPlayer.single}?playerId=${playerId}`;
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.MULTIPART_FORM, notification);
    return this.http
      .execute(request)
      .pipe(map((resp: Response) => resp))
      .pipe(catchError(this.http.handleError));
  }

  sendMultiplePlayerNotifications(playerIds: number[], notification: NotificationData) {
    let _url = `${global.ServerUrls.firebaseNotifications.sendToPlayer.multiple}`;
    let _content = {
      ids: playerIds,
      notification: notification,
    };
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.MULTIPART_FORM, _content);
    return this.http
      .execute(request)
      .pipe(map((resp: Response) => resp))
      .pipe(catchError(this.http.handleError));
  }

  /**
   *
   * @param organizerId
   * @param multiCourseCompId | this is basically seasonId
   * @returns
   */
  getTeamLeaderboard(compId: number, params: any) {
    let _params = params;
    let _url = global.ServerUrls.competitions.getTeamLeaderboard;
    let reCompId = /:compId/gi;
    _url = _url.replace(reCompId, compId);

    let request = new RemoteRequest(_url, this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);
    return this.http
      .execute(request)
      .pipe(
        map((response: any) => {
          let resp: Array<any> = response;
          resp.forEach(teamScore => {
            if (teamScore?.team?.teamLogo?.length) JsonService.deriveFulImageURL(teamScore?.team, 'teamLogo');
          });
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  setTeeTimeBookingLockerNumbers(bookingId: number, bookingPlayerIds: number[], lockerNumbers: string[]) {
    let _url = `${global.ServerUrls.teeTime.setLockerNumber}`;
    // const _lockerNumbers = lockerNumbers.includes(',') ? lockerNumbers : lockerNumbers + ',';
    const _bookingPlayerIds = [...bookingPlayerIds, ''].join(',');
    const _lockerNumbers = [...lockerNumbers, ''].join(',');
    let _query = {
      bookingId: bookingId,
      bookingPlayerIds: _bookingPlayerIds, // bookingPlayerIds.join(','),
      lockerNumbers: _lockerNumbers, //lockerNumbers.join(','),
    };
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, _query);
    return this.http
      .execute(request)
      .pipe(map((resp: Response) => resp))
      .pipe(catchError(this.http.handleError));
  }
}
